import React, { useState, useEffect, useRef } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
// import { CircularProgress } from "@mui/material";
import { CardBorder } from "rc-app/components/CardBorder";

import {
  XMarkIcon,
  //   PhotoIcon,
  VideoCameraIcon,
  //   DocumentIcon,
  PlayIcon,
} from "@heroicons/react/24/outline";
import { getAmenityIcon } from "rc-app/utils/amenityIcons";
import CustomSelect from "rc-app/components/ClientForm/CustomSelect";
import {
  createProjectByClinetManager,
  getClientProjects,
  listAgencyProjectsDetailed,
  listAllProjectNames,
  editProject,
  getProjectById,
  listAmenities,
  patchProjectDisplayOrder,
  setProjectAmenities,
  seedDefaultAmenities,
} from "rc-app/api/projectActionsApi";
import { useNavigate, useParams } from "react-router-dom";
import {
  getClientAdminByEmailId,
  getClientManagerByEmailId,
} from "rc-app/api/systemBusinessAdminActionApi";
import UserService from "rc-app/services/UserService";
import axios from "axios";
import Icon from "rc-app/components/Icons";
import NewMap from "rc-app/components/NewMap";
// import LogoUploadWithCrop from "rc-app/components/ImageUploadWithCrop";

import { getAgencyLogo, getAgencyById, getClientList } from "rc-app/api/agencyActionsApi";
import { getMatterports, createMatterport, updateMatterport, deleteMatterport } from "rc-app/api/matterportActionsApi";
import { getMetaModels, createMetaModel, updateMetaModel, deleteMetaModel } from "rc-app/api/metaModelsActionsApi";
import {
  generateProjectDescription,
  isAiConfigured,
  isReframeMode,
  type ProjectContext,
} from "rc-app/utils/aiProjectDescription";

const AddProject: React.FC = () => {
  // Add inside the component:
  const { projectId, clientId: routeClientId } = useParams();
  const isEditMode = !!projectId;
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState<
    "details" | "gallery" | "type" | "amenities" | "meta_assets"
  >("details");
  const [images, setImages] = useState<any[]>([]);
  const [videos, setVideos] = useState<any[]>([]);
  const [brochureFiles, setBrochureFiles] = useState<any[]>([]);
  const [projects, setProjects] = useState<any[]>([]);
  const [formErrors, setFormErrors] = useState<{ [key: string]: string }>({});
  const [agencyId, setAgencyId] = useState();
  const [agencyName, setAgencyName] = useState();
  const [existingProject, setExistingProject] = useState<any>(null);
  // Admin-only display_order override; blank means "don't touch" — backend
  // keeps the existing value. Loaded from the project record on edit.
  const [displayOrderInput, setDisplayOrderInput] = useState<string>("");

  const [selectedAmenities, setSelectedAmenities] = useState<string[]>([]);
  const selectedAmenitiesRef = useRef<string[]>([]);
  const [fetchedAmenities, setFetchedAmenities] = useState<any[]>([]);
  const [activeAmenityCategory, setActiveAmenityCategory] =
    useState<string>("security");
  const [isSeedingAmenities, setIsSeedingAmenities] = useState(false);

  // AI-assisted description state
  const [aiPanelOpen, setAiPanelOpen] = useState(false);
  const [aiHint, setAiHint] = useState("");
  const [aiLoading, setAiLoading] = useState(false);
  const [aiError, setAiError] = useState<string | null>(null);

  // Super-admin flow: when true, the next successful save skips the redirect
  // to /project_list and instead transitions into edit mode on the
  // meta_assets tab. Lets super admins go amenities → save → meta assets in
  // one continuous flow.
  const saveAndContinueRef = useRef(false);
  const [savingAndContinuing, setSavingAndContinuing] = useState(false);

  const amenityCategories = (() => {
    const grouped: Record<string, { category: string; label: string; items: any[] }> = {};
    fetchedAmenities.forEach((amenity) => {
      const cat = amenity.category || "other";
      if (!grouped[cat]) {
        grouped[cat] = {
          category: cat,
          label: cat.charAt(0).toUpperCase() + cat.slice(1).replace(/_/g, " "),
          items: [],
        };
      }
      grouped[cat].items.push(amenity);
    });
    return Object.values(grouped);
  })();

  const toggleAmenity = (key: string) => {
    setSelectedAmenities((prev) => {
      const next = prev.includes(key) ? prev.filter((a) => a !== key) : [...prev, key];
      selectedAmenitiesRef.current = next;
      return next;
    });
  };

  const [checkingProjectName, setCheckingProjectName] = useState(false);
  const [projectNameError, setProjectNameError] = useState("");
  const projectNameCheckTimeout = useRef<NodeJS.Timeout | null>(null);

  // const [showSuccess, setShowSuccess] = useState(true);

  console.log("images123", images);

  //   refs for project gallery input
  const imageInputRef = useRef<HTMLInputElement>(null);
  const videoInputRef = useRef<HTMLInputElement>(null);
  const brochureInputRef = useRef<HTMLInputElement>(null);
  const coverImageInputRef = useRef<HTMLInputElement>(null);

  const logoInputRef = useRef<HTMLInputElement>(null);
  const [isUploadingLogo, setIsUploadingLogo] = useState(false);

  const [isUploadingImages, setIsUploadingImages] = useState(false);
  const [isUploadingBrochures, setIsUploadingBrochures] = useState(false);

  const [coverImage, setCoverImage] = useState<string>("");
  const [isUploadingCoverImage, setIsUploadingCoverImage] = useState(false);

  const handleLogoUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const selectedImage = e.target.files?.[0];
    if (!selectedImage) return;

    setIsUploadingLogo(true);
    const API_URL = `${process.env.REACT_APP_ONEVERSE_REALESTATE_SERVER_URL}/api/v1/realestate/actions/realestate/gc_upload`;
    const uploadFormData = new FormData();
    uploadFormData.append("gc_upload_request", selectedImage);

    try {
      const res = await axios.post(API_URL, uploadFormData, {
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
          "ngrok-skip-browser-warning": "disabled",
          "Content-Type": "multipart/form-data",
        },
      });

      formik.setFieldValue("projectDetails.clientLogo", res.data.uploaded_url);
    } catch (error) {
      console.error("Logo upload failed:", error);
    } finally {
      setIsUploadingLogo(false);
    }
  };

  // useEffect(() => {
  //   const timer = setTimeout(() => setShowSuccess(false), 5000);
  //   return () => clearTimeout(timer);
  // }, []);

  useEffect(() => {
    getAgencyLogo(UserService.getUseremail()).then((res) => {
      if (res?.agencyName) setAgencyName(res.agencyName);
    });
    if (UserService.hasRole("super_admin") && routeClientId) {
      setAgencyId(routeClientId as any);
      getAgencyById(routeClientId).then((agency: any) => {
        if (agency?.name) setAgencyName(agency.name);
      });
    }
    {
      UserService.hasRole("agency_business_admin") &&
        getClientManagerByEmailId(UserService.getUseremail()).then((res) => {
          setAgencyId(res?.agency_business_admin?.agency_id);
        });
    }
    {
      UserService.hasRole("agency_system_admin") &&
        getClientAdminByEmailId(UserService.getUseremail()).then((res) => {
          setAgencyId(res?.agency_system_admin?.agency_id);
        });
    }
  }, [routeClientId]);

  /* ── CLONING A PROJECT ──────────────────────────────────────────────
     Super admin only, and only when creating. A new agency taking on a
     project that already exists elsewhere — a second phase, a re-launch, a
     builder moving between agencies — otherwise means re-typing forty
     fields and re-pasting every meta model URL by hand.

     `startMode` is null until the super admin chooses, so nobody clones by
     accident: the form asks before it shows itself. */
  const [startMode, setStartMode] = useState<null | "fresh" | "clone">(null);
  const [cloneAgencyId, setCloneAgencyId] = useState<string>("");
  const [cloneSourceId, setCloneSourceId] = useState<string>("");
  const [cloneAgencies, setCloneAgencies] = useState<any[]>([]);
  const [cloneProjects, setCloneProjects] = useState<any[]>([]);
  const [cloneProjectTotal, setCloneProjectTotal] = useState(0);

  /* ── WHAT IS ALREADY TAKEN ─────────────────────────────────────────
     The two fields have DIFFERENT scopes, and getting that wrong makes the
     check worse than none — it says "available" and the save is rejected.

       name → GLOBAL. Project._validate_unique_project_name queries
              {project_name, is_active} with NO agency filter, so a name
              taken by any agency on the platform is taken for everyone.
       slug → PER AGENCY. validate_project_slug_unique(slug, agency_id).

     Both were only discoverable by saving and being rejected. Now they are
     answered in the field.

     One fetch each rather than a request per keystroke: the old name check
     called getFullProjectData, which issues a detail request PER PROJECT —
     fifty projects meant fifty-one requests every time typing paused. */
  const [takenNames, setTakenNames] = useState<Map<string, string>>(new Map());
  const [takenSlugs, setTakenSlugs] = useState<Set<string>>(new Set());
  const [slugError, setSlugError] = useState("");
  const [cloneLoading, setCloneLoading] = useState(false);
  const [cloneAssetCount, setCloneAssetCount] = useState({ mm: 0, mp: 0 });

  useEffect(() => {
    if (startMode !== "clone" || cloneAgencies.length) return;
    /* `re_agency_list` — the key MyClientsPage reads. Named after the
       collection rather than the concept, which is why it is worth stating
       here instead of guessing at a shape. */
    getClientList().then((res: any) => {
      const list = res?.re_agency_list || [];
      setCloneAgencies(Array.isArray(list) ? list : []);
    }).catch(() => setCloneAgencies([]));
  }, [startMode, cloneAgencies.length]);

  useEffect(() => {
    if (!cloneAgencyId) { setCloneProjects([]); setCloneProjectTotal(0); return; }
    getClientProjects(cloneAgencyId).then((res: any) => {
      const list = Array.isArray(res?.projects) ? res.projects : [];
      setCloneProjects(list);
      /* The endpoint is hard-coded to 20 per page and this picker does not
         paginate. Rather than quietly offering a subset, the count is kept
         so the UI can say what it is not showing — a super admin hunting a
         project that is simply absent from the list would have no way to
         tell it existed. */
      setCloneProjectTotal(Number(res?.total) || list.length);
    }).catch(() => { setCloneProjects([]); setCloneProjectTotal(0); });
  }, [cloneAgencyId]);

  /* The experiences come across as STAGED entries, exactly as if the super
     admin had typed them into the Meta Assets tab before saving. The create
     path already persists staged assets against the new project id, so
     nothing new is needed on save.

     They carry the same URLs and the same Matterport ids — the clone points
     at the same hosted experience, which is the intent. Worth knowing: if
     the source agency ever takes those assets down, the clone goes with
     them. */
  useEffect(() => {
    if (!cloneSourceId) return undefined;
    let cancelled = false;
    setCloneLoading(true);
    (async () => {
      const [mpRes, mmRes] = await Promise.all([
        getMatterports(cloneSourceId).catch(() => null),
        getMetaModels(cloneSourceId).catch(() => null),
      ]);
      if (cancelled) return;
      const stamp = () => `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
      const mms = (Array.isArray(mmRes?.meta_models) ? mmRes.meta_models : [])
        .filter((mm: any) => mm.is_active !== false)
        .map((mm: any) => ({
          _id: `temp-mm-${stamp()}`, _temp: true,
          name: mm.name || "", url: mm.url || "",
          slug: mm.slug || "", description: mm.description || "",
        }));
      const mps = (Array.isArray(mpRes?.matterports) ? mpRes.matterports : [])
        .filter((mp: any) => mp.is_active !== false)
        .map((mp: any) => ({
          _id: `temp-mp-${stamp()}`, _temp: true,
          matterport_id: mp.matterport_id || "", name: mp.name || "",
          tour_type: mp.tour_type || "", description: mp.description || "",
        }));
      setProjectMetaModels(mms);
      setProjectMatterports(mps);
      setCloneAssetCount({ mm: mms.length, mp: mps.length });
      setCloneLoading(false);
    })();
    return () => { cancelled = true; setCloneLoading(false); };
  }, [cloneSourceId]);



  /* Reloaded whenever the target agency changes — for a super admin that is
     a live choice on this form, and "already taken" has a different answer
     in every agency. The project being edited is excluded from its own
     check, or renaming nothing to itself would look like a collision. */
  /* Names: platform-wide, so this does NOT depend on the chosen agency and
     is fetched once. */
  useEffect(() => {
    let cancelled = false;
    listAllProjectNames().then((map: any) => {
      if (!cancelled) setTakenNames(map || new Map());
    });
    return () => { cancelled = true; };
  }, []);

  /* Slugs: per agency, so reloaded whenever the target agency changes — for
     a super admin that is a live choice on this form. The project being
     edited is excluded from its own check, or renaming nothing to itself
     would look like a collision. */
  useEffect(() => {
    if (!agencyId) { setTakenSlugs(new Set()); return undefined; }
    let cancelled = false;
    listAgencyProjectsDetailed(agencyId).then((list: any[]) => {
      if (cancelled) return;
      const slugs = new Set<string>();
      for (const p of list) {
        if (isEditMode && String(p?._id || p?.id) === String(projectId)) continue;
        const s = String(p?.slug || "").trim().toLowerCase();
        if (s) slugs.add(s);
      }
      setTakenSlugs(slugs);
    });
    return () => { cancelled = true; };
  }, [agencyId, isEditMode, projectId]);

  useEffect(() => {
    listAmenities().then((res: any) => {
      const list = res?.re_amenity_list || res?.amenities || res?.data || [];
      console.log("fetchedAmenities sample:", list[0]);
      setFetchedAmenities(list);
      if (list.length > 0) setActiveAmenityCategory(list[0].category);
    });
  }, []);

  /* ── ONE HYDRATION PATH, TWO REASONS TO USE IT ──
     Editing loads a project into this form. Cloning loads a DIFFERENT
     project into the same form and then saves it as a new one. The mapping
     work is identical and it is 350 lines long, so it is not duplicated —
     the effect reads whichever id it was given.

     What differs is deliberately small and lives inside the `if (isEditMode)`
     guards below: a clone must not adopt the source's identity (its record,
     its display order, its agency, its RERA number). Everything descriptive
     comes across. */
  const sourceProjectId = isEditMode ? projectId : cloneSourceId;

  useEffect(() => {
    if (sourceProjectId) {
      getProjectById(sourceProjectId).then((res: any) => {
        const project = res?.project;

        if (project) {
          if (isEditMode) {
            // Store the existing project to preserve non-editable fields
            setExistingProject(project);
            setDisplayOrderInput(
              project.display_order != null ? String(project.display_order) : "",
            );
          }

          /* Edit follows the project's agency. A clone must NOT — the whole
             point is putting this project into a different one, and the
             target is whatever the super admin picked above. */
          const projectAgencyId = project.agency?.id || project.agency_id;
          if (isEditMode && UserService.hasRole("super_admin") && projectAgencyId) {
            setAgencyId(projectAgencyId);
            getAgencyById(projectAgencyId).then((agency: any) => {
              if (agency?.name) setAgencyName(agency.name);
            });
          }

          // Map project type
          const typeMapping: any = {
            villa_gated_community: "villaInGatedCommunity",
            apartment: "apartment",
            farmland: "farmland",
            layout_gated_community: "layoutInGatedCommunity",
            bungalow: "bungalow",
            commercial_space: "commercialSpace",
            commercial: "commercial",
          };

          const mappedType =
            typeMapping[project.project_type_details?.type] ||
            project.project_type_details?.type ||
            "";

          // Calculate number of units and unique units from unit_configurations
          const unitConfigs =
            project.project_type_details?.unit_configurations || [];
          const calculatedNumberOfUnits = unitConfigs.reduce(
            (total: number, unit: any) => total + (parseInt(unit.count) || 0),
            0,
          );
          const calculatedNumberOfUniqueUnits = unitConfigs.length;

          // Build property specific details based on type
          const propertySpecificDetails: any = {
            villaInGatedCommunity: {
              numberOfUnits: "",
              numberOfUniqueUnits: "",
              clubhouseSizeSqft: "",
              uniqueUnits: [],
            },
            apartment: {
              numberOfTowers: "",
              numberOfFloors: "",
              numberOfUnits: "",
              numberOfUniqueUnits: "",
              clubhouseSizeSqft: "",
              uniqueUnits: [],
            },
            farmland: {
              totalAreaInAcres: "",
              numberOfPlots: "",
              plotSizeRange: "",
              commonAmenities: "",
              uniquePlots: [],
            },
            bungalow: {
              numberOfUnits: "",
              numberOfUniqueUnits: "",
              commonAreaSizeSqft: "",
              uniqueUnits: [],
            },
            commercialSpace: {
              numberOfFloors: "",
              numberOfUnits: "",
              numberOfUniqueUnits: "",
              commonFacilitiesSizeSqft: "",
              uniqueUnits: [],
            },
            commercial: {
              buildingGrade: "",
              totalLeasableAreaSqft: "",
              parkingRatio: "",
              commonAreaSizeSqft: "",
              towers: [],
            },
            layoutInGatedCommunity: {
              totalPlots: "",
              numberOfUniqueLayouts: "",
              clubhouseSizeSqft: "",
              uniqueLayouts: [],
            },
          };

          // Populate specific property details based on type
          if (
            mappedType === "villaInGatedCommunity" &&
            project.project_type_details
          ) {
            propertySpecificDetails.villaInGatedCommunity = {
              numberOfUnits: calculatedNumberOfUnits.toString(),
              numberOfUniqueUnits: calculatedNumberOfUniqueUnits.toString(),
              clubhouseSizeSqft:
                project.project_type_details.clubhouse_size_sqft?.toString() ||
                "",
              uniqueUnits: [],
            };
          } else if (
            mappedType === "apartment" &&
            project.project_type_details
          ) {
            propertySpecificDetails.apartment = {
              numberOfTowers:
                project.project_type_details.number_of_towers?.toString() || "",
              numberOfFloors:
                project.project_type_details.number_of_floors?.toString() || "",
              numberOfUnits: calculatedNumberOfUnits.toString(),
              numberOfUniqueUnits: calculatedNumberOfUniqueUnits.toString(),
              clubhouseSizeSqft:
                project.project_type_details.clubhouse_size_sqft?.toString() ||
                "",
              uniqueUnits: [],
            };
          } else if (
            mappedType === "bungalow" &&
            project.project_type_details
          ) {
            propertySpecificDetails.bungalow = {
              numberOfUnits: calculatedNumberOfUnits.toString(),
              numberOfUniqueUnits: calculatedNumberOfUniqueUnits.toString(),
              commonAreaSizeSqft:
                project.project_type_details.common_area_size_sqft?.toString() ||
                "",
              uniqueUnits: [],
            };
          } else if (
            mappedType === "commercialSpace" &&
            project.project_type_details
          ) {
            propertySpecificDetails.commercialSpace = {
              numberOfFloors:
                project.project_type_details.number_of_floors?.toString() || "",
              numberOfUnits: calculatedNumberOfUnits.toString(),
              numberOfUniqueUnits: calculatedNumberOfUniqueUnits.toString(),
              commonFacilitiesSizeSqft:
                project.project_type_details.common_facilities_size_sqft?.toString() ||
                "",
              uniqueUnits: [],
            };
          } else if (
            mappedType === "farmland" &&
            project.project_type_details
          ) {
            propertySpecificDetails.farmland = {
              totalAreaInAcres: "",
              numberOfPlots: calculatedNumberOfUniqueUnits.toString(),
              plotSizeRange: "",
              commonAmenities: "",
              uniquePlots: [],
            };

            if (unitConfigs.length > 0) {
              setUniqueUnits(
                unitConfigs.map((unit: any, idx: any) => ({
                  id: Date.now().toString() + idx,
                  plotNumber: unit.name || `Plot ${idx + 1}`,
                  facing: unit.facing || "",
                  sizeInSqft: unit.size_sqft?.toString() || "",
                  unitNumber: unit.count?.toString() || "",
                })),
              );
            }
          } else if (
            mappedType === "layoutInGatedCommunity" &&
            project.project_type_details
          ) {
            propertySpecificDetails.layoutInGatedCommunity = {
              totalPlots: calculatedNumberOfUniqueUnits.toString(),
              numberOfUniqueLayouts: calculatedNumberOfUniqueUnits.toString(),
              clubhouseSizeSqft:
                project.project_type_details.clubhouse_size_sqft?.toString() ||
                "",
              uniqueLayouts: [],
            };
          } else if (
            mappedType === "commercial" &&
            project.project_type_details
          ) {
            const ptd = project.project_type_details;
            propertySpecificDetails.commercial = {
              buildingGrade: ptd.building_grade || "",
              totalLeasableAreaSqft:
                ptd.total_leasable_area_sqft?.toString() || "",
              parkingRatio: ptd.parking_ratio || "",
              commonAreaSizeSqft:
                ptd.common_area_size_sqft?.toString() || "",
              towers: (ptd.towers || []).map((t: any, idx: number) => ({
                id: `${Date.now()}_${idx}`,
                name: t.name || "",
                numberOfFloors: t.number_of_floors?.toString() || "",
                floorPlateSqft: t.floor_plate_sqft?.toString() || "",
              })),
            };
          }

          // Populate form with existing data
          formik.setValues({
            projectDetails: {
              projectDelivery: "",
              projectType: "",
              basicDetails: "",
              clientLogo: project.logo || "",
              /* A slug is an address, not a description. It is what
                 /c/<agency>/p/<slug> resolves to and what every share link
                 already in circulation points at, so two projects cannot
                 hold the same one. Copying it would either collide on save
                 or, worse, quietly steal traffic from the original.

                 Left blank on a clone so the super admin has to name the
                 new one. Nothing else in the form works this way, which is
                 the point — a field that must not be inherited should be
                 visibly empty rather than pre-filled and wrong. */
              slug: isEditMode ? (project.slug || "") : "",
              builder: {
                builderName: project.builder_name || "",
                projectName: project.project_name || "",
              },
              projectDescription: (() => {
                const raw = project.description || "";
                try {
                  const parsed = JSON.parse(raw);
                  if (parsed && typeof parsed === "object") {
                    return {
                      headline: parsed.headline || "",
                      lede: parsed.lede || "",
                      body: parsed.body || "",
                      quote: parsed.quote || "",
                    };
                  }
                } catch {}
                return { headline: "", lede: "", body: raw, quote: "" };
              })(),
              location: {
                addressLine1: project.address?.address_line1 || "",
                addressLine2: project.address?.address_line2 || "",
                city: project.address?.city || "",
                landmark: project.address?.landmark || "",
                country: project.address?.country || "",
                pincode: project.address?.postal_code || "",
                state: project.address?.province || "",
                latitude: project.geo_location?.[0] || "",
                longitude: project.geo_location?.[1] || "",
              },
              moreInformation: {
                projectSizeInAcres:
                  project.project_area?.value?.toString() || "",
                /* Copied. A RERA number identifies the DEVELOPMENT, not the
                   agency's record of it — the same towers registered once with
                   the regulator. So when the same project is set up under a
                   second agency, the registration is genuinely the same
                   number, and blanking it only made someone retype it.

                   (This was blank at first, on the assumption that a clone
                   meant a different building started from a template. It
                   doesn't; it means the same building, filed somewhere else.)

                   Unlike the slug, which is an address and must be unique. */
                projectLicenseNumber: project.registration_number || "",
                projectLaunchDate: project.launch_date || "",
                projectCompletionDate: project.completion_date || "",
                projectSaleableAreaSqft:
                  project.saleable_area?.value?.toString() || "",
              },
            },
            projectGallery: {
              brochures: project.project_brochure
                ? [{ url: project.project_brochure }]
                : [],
              images:
                project.project_images?.map((url: any) => ({ url })) || [],
              videos: [],
              routeViews: project.route_view?.length ? project.route_view : [""],
              videoLinks: project.property_videos?.length ? project.property_videos : [""],
            },
            projectTypeDetails: {
              typeOfProperty: mappedType,
              propertySpecificDetails: propertySpecificDetails,
            },
          });

          setImages(project.project_images || []);
          setCoverImage(project.project_images?.[0] || "");
          if (project.project_brochure) {
            setBrochureFiles([
              { url: project.project_brochure, name: "Project Brochure" },
            ]);
          }

          setPropertyType(mappedType);

          // Load unit configurations based on type
          if (project.project_type_details?.unit_configurations) {
            if (mappedType === "farmland") {
              // Render reads unit.unitNumber / sizeInSqft / bhk / facing
              // (same shape as apartment/villa). Restore from backend's
              // count / size_sqft / bhk.
              setUniqueUnits(
                project.project_type_details.unit_configurations.map(
                  (unit: any, idx: any) => ({
                    id: Date.now().toString() + idx,
                    unitNumber: unit.count?.toString() || "",
                    facing: unit.facing || "",
                    sizeInSqft: unit.size_sqft?.toString() || "",
                    bhk: unit.bhk?.toString() || "",
                  }),
                ),
              );
            } else if (mappedType === "layoutInGatedCommunity") {
              // Render reads unit.unitNumber / sizeInSqft / bhk / facing
              // (matching the apartment/villa shape) — restore those field
              // names from the backend's `count` / `size_sqft` / `bhk`.
              setUniqueUnits(
                project.project_type_details.unit_configurations.map(
                  (unit: any, idx: any) => ({
                    id: Date.now().toString() + idx,
                    unitNumber: unit.count?.toString() || "",
                    facing: unit.facing || "",
                    sizeInSqft: unit.size_sqft?.toString() || "",
                    bhk: unit.bhk?.toString() || "",
                  }),
                ),
              );
            } else if (mappedType === "commercialSpace") {
              // For commercial space
              setUniqueUnits(
                project.project_type_details.unit_configurations.map(
                  (unit: any, idx: any) => ({
                    id: Date.now().toString() + idx,
                    unitNumber: unit.count?.toString() || "",
                    facing: unit.facing || "",
                    sizeInSqft: unit.size_sqft?.toString() || "",
                    unitType: unit.name || "",
                    floorNumber: "",
                  }),
                ),
              );
            } else if (mappedType === "bungalow") {
              // For bungalow
              setUniqueUnits(
                project.project_type_details.unit_configurations.map(
                  (unit: any, idx: any) => ({
                    id: Date.now().toString() + idx,
                    unitNumber: unit.count?.toString() || "",
                    facing: unit.facing || "",
                    sizeInSqft: unit.size_sqft?.toString() || "",
                    bhk: unit.bhk?.toString() || "",
                    plotSizeInSqft: "",
                  }),
                ),
              );
            } else {
              // For villa and apartment
              setUniqueUnits(
                project.project_type_details.unit_configurations.map(
                  (unit: any, idx: any) => ({
                    id: Date.now().toString() + idx,
                    unitNumber: unit.count?.toString() || "",
                    facing: unit.facing || "",
                    sizeInSqft: unit.size_sqft?.toString() || "",
                    bhk: unit.bhk?.toString() || "",
                  }),
                ),
              );
            }
          }
          console.log("project.amenities raw:", project.amenities);
          if (project.amenities?.length > 0) {
            const ids = project.amenities.map((a: any) => a._id || a.amenity_id || a).filter((a: any) => typeof a === "string");
            setSelectedAmenities(ids);
            selectedAmenitiesRef.current = ids;
          }
        }
      });
    }
  }, [sourceProjectId, isEditMode]);

  useEffect(() => {
    return () => {
      if (projectNameCheckTimeout.current) {
        clearTimeout(projectNameCheckTimeout.current);
      }
    };
  }, []);

  const checkProjectName = async (projectName: string) => {
    if (!projectName.trim() || !agencyId) {
      return;
    }

    // Skip check in edit mode if name hasn't changed
    if (isEditMode && existingProject?.project_name === projectName) {
      return;
    }

    /* Answered from the agency's project list, loaded once when the agency
       was chosen. This used to call checkProjectNameExists, which fetches
       the list and then a detail request PER PROJECT — fifty projects meant
       fifty-one requests every time typing paused, to answer a question
       already sitting in memory.

       Kept async: it is awaited in two places, and the network version may
       come back if the list ever has to be paged. */
    /* ── TWO DIFFERENT ANSWERS, AND ONLY ONE OF THEM BLOCKS ──
       The backend compares project_name as an EXACT string — no collation,
       no trimming. So "Ark Artha" and "Ark Artha  " are two different names
       to it, and both save.

       This check used to normalise before comparing, which made the form
       stricter than the thing it was predicting: it refused a name the
       backend would have accepted. A field that blocks a legal save is
       worse than one that says nothing, because there is no way past it.

       So the two cases are separated:
         exact match      -> ERROR. The save will be rejected.
         match once
         trimmed/lowered  -> WARNING. The save will work, and you will have
                             two projects nobody can tell apart in a
                             dropdown, a share link or an analytics row.

       The warning does not block. Distinguishing them with trailing spaces
       is a legitimate thing to do knowingly and a bad thing to do by
       accident, and the difference is whether someone was told. */
    setCheckingProjectName(true);
    try {
      /* Compared as the RAW string, exactly as the backend does — no
         trimming, no case folding. Normalising here would refuse names the
         server accepts, and a field that blocks a legal save has no way
         past it. Excluded from its own check by id, since in edit mode a
         project's existing name is in the map. */
      const hit = takenNames.get(projectName);
      const isSelf = isEditMode && !!hit && String(hit) === String(projectId);
      setProjectNameError(
        hit && !isSelf
          ? "This project name is already taken — names are unique across every agency"
          : "",
      );
    } finally {
      setCheckingProjectName(false);
    }
  };

  // Validation schemas for each tab
  const detailsValidationSchema = Yup.object({
    // projectDelivery: Yup.string().required("Project delivery is required"),
    // projectType: Yup.string().required("Project type is required"),
    // basicDetails: Yup.string().required("Basic details are required"),
    builder: Yup.object({
      // builderName: Yup.string().required("Builder name is required"),
      projectName: Yup.string().required("Project name is required"),
    }),
    projectDescription: Yup.object({
      headline: Yup.string(),
      lede: Yup.string(),
      body: Yup.string().required("Description body is required"),
      quote: Yup.string(),
    }),
    location: Yup.object({
      addressLine1: Yup.string().required("Address line 1 is required"),
      city: Yup.string().required("City is required"),
      country: Yup.string().required("Country is required"),
      pincode: Yup.string().required("Pincode is required"),
      state: Yup.string().required("State is required"),
    }),
    moreInformation: Yup.object({
      projectSizeInAcres: Yup.number()
        .typeError("Project size must be a valid number")
        .required("Project size is required")
        .positive("Must be positive"),

      projectLicenseNumber: Yup.string().required("License number is required"),
      projectLaunchDate: Yup.date()
        .typeError("Completion date must be a valid date")
        .required("Launch date is required"),
      projectCompletionDate: Yup.date()
        .typeError("Completion date must be a valid date")
        .required("Completion date is required"),
      projectSaleableAreaSqft: Yup.number()
        .typeError("Saleable area must be a valid number")
        .required("Saleable area is required")
        .positive("Must be positive"),
    }),
  });

  const typeValidationSchema = Yup.object({
    typeOfProperty: Yup.string().required("Property type is required"),
  });

  const formik = useFormik({
    initialValues: {
      projectDetails: {
        projectDelivery: "",
        projectType: "",
        basicDetails: "",
        clientLogo: "",
        slug: "",
        builder: {
          builderName: "",
          projectName: "",
        },
        projectDescription: { headline: "", lede: "", body: "", quote: "" },
        location: {
          addressLine1: "",
          addressLine2: "",
          city: "",
          landmark: "",
          country: "",
          pincode: "",
          state: "",
          longitude: "",
          latitude: "",
        },
        moreInformation: {
          projectSizeInAcres: "",
          projectLicenseNumber: "",
          projectLaunchDate: "",
          projectCompletionDate: "",
          projectSaleableAreaSqft: "",
        },
      },
      projectGallery: {
        brochures: [] as any[],
        images: [] as any[],
        videos: [] as any[],
        routeViews: [""] as string[],
        videoLinks: [""] as string[],
      },
      projectTypeDetails: {
        typeOfProperty: "",
        propertySpecificDetails: {
          villaInGatedCommunity: {
            numberOfUnits: "",
            numberOfUniqueUnits: "",
            clubhouseSizeSqft: "",
            uniqueUnits: [] as any[],
          },
          apartment: {
            numberOfTowers: "",
            numberOfFloors: "",
            numberOfUnits: "",
            numberOfUniqueUnits: "",
            clubhouseSizeSqft: "",
            uniqueUnits: [] as any[],
          },
          layoutInGatedCommunity: {
            numberOfUnits: "",
            numberOfUniqueUnits: "",
            clubhouseSizeSqft: "",
            uniqueUnits: [] as any[],
          },
          farmland: {
            totalAreaInAcres: "",
            numberOfPlots: "",
            plotSizeRange: "",
            commonAmenities: "",
            uniqueUnits: [] as any[],
          },

          bungalow: {
            numberOfUnits: "",
            numberOfUniqueUnits: "",
            commonAreaSizeSqft: "",
            uniqueUnits: [] as any[],
          },
          commercialSpace: {
            numberOfFloors: "",
            numberOfUnits: "",
            numberOfUniqueUnits: "",
            commonFacilitiesSizeSqft: "",
            uniqueUnits: [] as any[],
          },
          commercial: {
            buildingGrade: "",
            totalLeasableAreaSqft: "",
            parkingRatio: "",
            commonAreaSizeSqft: "",
            towers: [] as any[],
          },
        },
      },
    },
    validationSchema: Yup.object({
      projectDetails: detailsValidationSchema,
      projectTypeDetails: typeValidationSchema,
    }),

    onSubmit: async (values) => {
      // if (projectNameError) {
      //   alert("Please fix the validation errors before saving.");
      //   return;
      // }
      /* Narrowly for clones. The guard above is commented out for ordinary
         creates and is left that way — whoever disabled it had a reason, and
         re-enabling it globally is not this change's business.

         A clone is different: nobody typed this name, so nobody was shown the
         duplicate warning while typing it. Saving a second "Auro Kohinoor"
         into the same agency because the form filled it in silently is a
         failure the person cannot be blamed for. */
      if (cloneSourceId && projectNameError) {
        alert(`${projectNameError}. Give the copy its own name before saving.`);
        return;
      }
      /* Slug is blocked for everyone, not only clones. It is a hard backend
         constraint (validate_project_slug_unique), so saving anyway just
         moves the same rejection later — after the form has been submitted
         and the person has stopped looking at the field. */
      if (slugError) {
        alert(`${slugError}. Pick a different slug before saving.`);
        return;
      }
      // Helper function to build project_type_details based on type
      const buildProjectTypeDetails = () => {
        const type = values.projectTypeDetails.typeOfProperty;
        const details = values.projectTypeDetails.propertySpecificDetails;

        switch (type) {
          case "villaInGatedCommunity":
            return {
              type: "villa_gated_community",
              clubhouse_size_sqft:
                parseInt(details.villaInGatedCommunity.clubhouseSizeSqft) || 0,
              unit_configurations: uniqueUnits.map((unit) => ({
                name: `${unit.bhk}BHK`,
                facing: unit.facing,
                size_sqft: parseInt(unit.sizeInSqft) || 0,
                count: unit.unitNumber,
                bhk: parseInt(unit.bhk) || 0,
              })),
            };

          case "apartment":
            return {
              type: "apartment",
              number_of_towers: parseInt(details.apartment.numberOfTowers) || 0,
              number_of_floors: parseInt(details.apartment.numberOfFloors) || 0,

              // number_of_units: parseInt(details.apartment.numberOfUnits) || 0,
              // number_of_unique_units:
              //   parseInt(details.apartment.numberOfUniqueUnits) || 0,

              clubhouse_size_sqft:
                parseInt(details.apartment.clubhouseSizeSqft) || 0,

              unit_configurations: uniqueUnits.map((unit) => ({
                name: `${unit.bhk}BHK`,
                facing: unit.facing,
                size_sqft: parseInt(unit.sizeInSqft) || 0,
                count: unit.unitNumber,
                bhk: parseInt(unit.bhk) || 0,
              })),
            };

          case "farmland":
            return {
              type: "farmland",
              unit_configurations: uniqueUnits.map((unit, i) => ({
                name: `Type ${i + 1}`,
                facing: unit.facing,
                size_sqft: parseInt(unit.sizeInSqft) || 0,
                count: parseInt(unit.unitNumber) || 0,
              })),
            };

          case "layoutInGatedCommunity":
            return {
              type: "layout_gated_community",
              unit_configurations: uniqueUnits.map((unit, i) => ({
                name: `Type ${i + 1}`,
                facing: unit.facing,
                size_sqft: parseInt(unit.sizeInSqft) || 0,
                count: parseInt(unit.unitNumber) || 0,
              })),
              clubhouse_size_sqft:
                parseInt(details.layoutInGatedCommunity.clubhouseSizeSqft) || 0,
            };

          case "bungalow":
            return {
              type: "bungalow",
              common_area_size_sqft:
                parseInt(details.bungalow.commonAreaSizeSqft) || 0,
              unit_configurations: uniqueUnits.map((unit) => ({
                name: `${unit.bhk}BHK Bungalow`,
                facing: unit.facing,
                size_sqft: parseInt(unit.sizeInSqft) || 0,
                plot_size_sqft: parseInt(unit.plotSizeInSqft) || 0,
                count: unit.unitNumber,
                bhk: parseInt(unit.bhk) || 0,
              })),
            };

          case "commercialSpace":
            return {
              type: "commercial_space",
              number_of_floors:
                parseInt(details.commercialSpace.numberOfFloors) || 0,
              common_facilities_size_sqft:
                parseInt(details.commercialSpace.commonFacilitiesSizeSqft) || 0,
              unit_configurations: uniqueUnits.map((unit) => ({
                name: unit.unitType || "Commercial Unit",
                facing: unit.facing,
                size_sqft: parseInt(unit.sizeInSqft) || 0,
                count: unit.unitNumber,
                unit_type: unit.unitType,
                floor_number: parseInt(unit.floorNumber) || 0,
              })),
            };

          case "commercial": {
            const c = details.commercial;
            const payload: any = {
              type: "commercial",
              building_grade: c.buildingGrade,
              total_leasable_area_sqft:
                parseFloat(c.totalLeasableAreaSqft) || 0,
              common_area_size_sqft: parseFloat(c.commonAreaSizeSqft) || 0,
              towers: (c.towers || []).map((t: any) => ({
                name: t.name || "",
                number_of_floors: parseInt(t.numberOfFloors) || 0,
                floor_plate_sqft: parseFloat(t.floorPlateSqft) || 0,
              })),
            };
            if (c.parkingRatio && c.parkingRatio.trim()) {
              payload.parking_ratio = c.parkingRatio.trim();
            }
            return payload;
          }

          default:
            return { type: type };
        }
      };

      // Build API payload
      const payload = {
        // agency_id: "68b53996ed2cf8175d432b5b", // Replace with actual agency_id from context/auth
        agency_id: agencyId,
        project_name: values.projectDetails.builder.projectName,
        slug: values.projectDetails.slug,
        description: JSON.stringify(values.projectDetails.projectDescription),
        logo: values.projectDetails.clientLogo,
        address: {
          address_line1: values.projectDetails.location.addressLine1,
          address_line2: values.projectDetails.location.addressLine2,
          landmark: values.projectDetails.location.landmark,
          postal_code: values.projectDetails.location.pincode,
          city: values.projectDetails.location.city,
          province: values.projectDetails.location.state,
          country: values.projectDetails.location.country,
        },
        project_area: {
          value: values.projectDetails.moreInformation.projectSizeInAcres,
          unit: "acres",
        },
        saleable_area: {
          value: values.projectDetails.moreInformation.projectSaleableAreaSqft,
          unit: "sqft",
        },
        registration_number:
          values.projectDetails.moreInformation.projectLicenseNumber,
        launch_date: values.projectDetails.moreInformation.projectLaunchDate,
        completion_date:
          values.projectDetails.moreInformation.projectCompletionDate,
        project_images: images.map((img) => img),
        project_brochure: brochureFiles[0]?.url || "",
        digital_twin_ids: isEditMode
          ? existingProject?.digital_twin_ids || []
          : [],
        virtual_tour_ids: isEditMode
          ? existingProject?.virtual_tour_ids || []
          : [],
        route_view: values.projectGallery.routeViews.filter((v: string) => v.trim() !== ""),
        property_videos: values.projectGallery.videoLinks.filter((v: string) => v.trim() !== ""),
        geo_location: [
          values.projectDetails.location.latitude,
          values.projectDetails.location.longitude,
        ].filter(Boolean),
        project_type_details: buildProjectTypeDetails(),
      };
      // const payload = {
      //   // agency_id: "6971e0cc5610e67fbdb085fc",
      //   agency_id: agencyId,
      //   project_name: "test3",
      //   description: "string",
      //   logo: "string",
      //   address: {
      //     address_line1: "string",
      //     address_line2: "string",
      //     landmark: "string",
      //     postal_code: "string",
      //     city: "string",
      //     province: "string",
      //     country: "string",
      //   },
      //   project_area: {
      //     value: "4554",
      //     unit: "sqm",
      //   },
      //   saleable_area: {
      //     value: "string",
      //     unit: "sqm",
      //   },
      //   registration_number: "string",
      //   launch_date: "2026-02-01",
      //   completion_date: "2026-02-15",
      //   project_images: ["string"],
      //   project_brochure: "string",
      //   digital_twin_ids: [] as any[],
      //   virtual_tour_ids: [] as any[],
      //   project_type_details: {
      //     type: "apartment",
      //     number_of_towers: 2,
      //     number_of_floors: 15,
      //     unit_configurations: [
      //       {
      //         name: "2BHK",
      //         facing: "east",
      //         size_sqft: 1200,
      //         count: 20,
      //         bhk: 2,
      //       },
      //     ],
      //     clubhouse_size_sqft: 3000,
      //   },
      // };

      // try {
      //   console.log("API Payload:", payload);

      //   createProjectByClinetManager(payload).then(() => {
      //     alert(`Project "${payload.project_name}" added successfully!`);
      //     formik.resetForm();
      //     setBrochureFiles([]);
      //     setImages([]);
      //     setVideos([]);
      //     setUniqueUnits([]);
      //     setPropertyType("");
      //     setActiveTab("details");
      //     navigate("/project_list");
      //   });
      // } catch (error) {
      //   console.error("Error saving project:", error);
      //   alert("Error saving project. Please try again.");
      // }

      try {
        console.log("API Payload:", payload);
        if (isEditMode) {
          await editProject(payload, projectId);
          console.log("calling setProjectAmenities with:", projectId, selectedAmenitiesRef.current);
          const amenityRes = await setProjectAmenities(projectId, selectedAmenitiesRef.current);
          console.log("setProjectAmenities response:", amenityRes);
          // Admin-only: if display_order was changed, send a separate PATCH.
          // Skipped silently for non-admins and when the value hasn't changed.
          if (canReorderProjects && displayOrderInput.trim() !== "") {
            const parsed = Number(displayOrderInput);
            const existingOrder =
              existingProject?.display_order != null
                ? Number(existingProject.display_order)
                : null;
            if (!Number.isNaN(parsed) && parsed !== existingOrder) {
              try {
                await patchProjectDisplayOrder(projectId, parsed);
              } catch (err) {
                console.error("display_order update failed:", err);
                alert(
                  "Project saved, but display order update failed. Try again.",
                );
              }
            }
          }
          alert(`Project "${payload.project_name}" updated successfully!`);
        } else {
          const res = await createProjectByClinetManager(payload);
          const newProjectId = res?.project?._id || res?._id;
          if (newProjectId) {
            await setProjectAmenities(newProjectId, selectedAmenitiesRef.current);
            if (isSuperAdmin) {
              const pendingMM = projectMetaModels.filter((mm: any) => mm._temp);
              const pendingMP = projectMatterports.filter((mp: any) => mp._temp);
              await Promise.allSettled([
                ...pendingMM.map((mm: any) =>
                  createMetaModel({
                    name: mm.name,
                    url: mm.url,
                    slug: mm.slug,
                    description: mm.description,
                    project_id: newProjectId,
                  }),
                ),
                ...pendingMP.map((mp: any) =>
                  createMatterport({
                    matterport_id: mp.matterport_id,
                    name: mp.name,
                    tour_type: mp.tour_type,
                    description: mp.description,
                    project_id: newProjectId,
                  }),
                ),
              ]);
            }
          }
          alert(`Project "${payload.project_name}" added successfully!`);

          // Super-admin save-and-continue flow: stay on the page, jump into
          // edit mode on the new project so the Meta Assets tab is wired up.
          if (saveAndContinueRef.current) {
            saveAndContinueRef.current = false;
            setSavingAndContinuing(false);
            const newId = res?.project?._id || res?._id;
            if (newId) {
              setActiveTab("meta_assets");
              navigate(`/edit_project/${newId}`);
              return;
            }
          }
        }

        formik.resetForm();
        setBrochureFiles([]);
        setImages([]);
        setVideos([]);
        setUniqueUnits([]);
        setPropertyType("");
        setSelectedAmenities([]);
        setActiveAmenityCategory("security");
        setActiveTab("details");
        navigate("/project_list");
      } catch (error) {
        console.error("Error saving project:", error);
        alert("Error saving project. Please try again.");
        saveAndContinueRef.current = false;
        setSavingAndContinuing(false);
      }
    },
  });

  // AI generate / reframe handler — pulls context from current form state +
  // selected amenities, calls Claude, populates the four description fields.
  const aiConfigured = isAiConfigured();
  const aiMode: "generate" | "reframe" = isReframeMode(
    formik.values.projectDetails.projectDescription,
  )
    ? "reframe"
    : "generate";

  const handleClearDescription = () => {
    const ok = window.confirm(
      "Clear all four description fields (headline, lede, body, quote)? This can't be undone.",
    );
    if (!ok) return;
    formik.setFieldValue("projectDetails.projectDescription.headline", "");
    formik.setFieldValue("projectDetails.projectDescription.lede", "");
    formik.setFieldValue("projectDetails.projectDescription.body", "");
    formik.setFieldValue("projectDetails.projectDescription.quote", "");
    setAiError(null);
  };

  const handleAiGenerate = async () => {
    setAiError(null);
    setAiLoading(true);
    try {
      const pd = formik.values.projectDetails;
      const amenityNames = selectedAmenities
        .map((id) => {
          const found = fetchedAmenities.find((a: any) => a._id === id);
          return found?.name || found?.label || "";
        })
        .filter((n: string) => n.length > 0);

      const ctx: ProjectContext = {
        projectName: pd.builder?.projectName,
        builderName: pd.builder?.builderName,
        projectType: pd.projectType,
        projectDelivery: pd.projectDelivery,
        addressLine1: pd.location?.addressLine1,
        landmark: pd.location?.landmark,
        city: pd.location?.city,
        state: pd.location?.state,
        projectSizeInAcres: pd.moreInformation?.projectSizeInAcres,
        projectSaleableAreaSqft: pd.moreInformation?.projectSaleableAreaSqft,
        amenityNames,
      };

      const result = await generateProjectDescription(
        ctx,
        aiMode === "reframe" ? pd.projectDescription : undefined,
        aiHint,
      );

      formik.setFieldValue(
        "projectDetails.projectDescription.headline",
        result.headline,
      );
      formik.setFieldValue("projectDetails.projectDescription.lede", result.lede);
      formik.setFieldValue("projectDetails.projectDescription.body", result.body);
      formik.setFieldValue("projectDetails.projectDescription.quote", result.quote);

      // Clear validation error on body if any (body is required)
      if (formErrors.projectDescription) {
        const newErrors = { ...formErrors };
        delete newErrors.projectDescription;
        setFormErrors(newErrors);
      }

      setAiHint("");
      setAiPanelOpen(false);
    } catch (err: any) {
      setAiError(err?.message || "AI generation failed. Please try again.");
    } finally {
      setAiLoading(false);
    }
  };

  const [propertyType, setPropertyType] = useState("");
  const [uniqueUnits, setUniqueUnits] = useState<any[]>([]);
  const [unitsByType, setUnitsByType] = useState<Record<string, any[]>>({});
  const [projectMatterports, setProjectMatterports] = useState<any[]>([]);
  const [projectMetaModels, setProjectMetaModels] = useState<any[]>([]);
  const [loadingMetaAssets, setLoadingMetaAssets] = useState(false);

  /* ── A CLONED NAME HAS NEVER BEEN CHECKED ──
     The duplicate check fires from the name input's onChange, so a name that
     arrived by hydration rather than by typing was never tested against the
     target agency. That is fine across agencies — the same project appearing
     under two agencies is the ordinary reason to clone, and blanking the name
     would make the common case worse to serve the rare one. It is not fine
     within one agency, where it collides.

     So the check is run when the clone lands, and again whenever the target
     agency changes, which is the moment the answer can flip. The super admin
     is told only when there is actually something to fix. */
  const clonedName = formik?.values?.projectDetails?.builder?.projectName;
  useEffect(() => {
    if (isEditMode || !cloneSourceId || !clonedName) return undefined;
    const t = setTimeout(() => { void checkProjectName(clonedName); }, 300);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cloneSourceId, clonedName, takenNames, isEditMode]);

  const isSuperAdmin = UserService.hasRole("super_admin");
  // Display-order edit is super_admin-only by product decision (single
  // curator for marketplace ordering). Backend enforces 403 for everyone
  // else regardless; this is the UI gate.
  const canReorderProjects = isSuperAdmin;

  // Meta model CRUD state
  const [editingMetaModelId, setEditingMetaModelId] = useState<string | null>(null);
  const [metaModelDraft, setMetaModelDraft] = useState<{ name: string; url: string; slug: string; description: string; thumbnail_url: string }>({ name: "", url: "", slug: "", description: "", thumbnail_url: "" });
  const [showAddMetaModel, setShowAddMetaModel] = useState(false);
  const [savingMetaModel, setSavingMetaModel] = useState(false);
  const [deletingMetaModelId, setDeletingMetaModelId] = useState<string | null>(null);

  // Matterport CRUD state
  const [editingMatterportId, setEditingMatterportId] = useState<string | null>(null);
  const [matterportDraft, setMatterportDraft] = useState<{ matterport_id: string; name: string; tour_type: string; description: string }>({ matterport_id: "", name: "", tour_type: "Apartment", description: "" });
  const [showAddMatterport, setShowAddMatterport] = useState(false);
  const [savingMatterport, setSavingMatterport] = useState(false);
  const [deletingMatterportId, setDeletingMatterportId] = useState<string | null>(null);

  const TOUR_TYPES = ["Apartment", "Castle", "Estate", "Free standing house", "Office", "Farmhouse", "Palace", "Penthouse", "Shop", "Studio", "Villa", "Commercial", "Others", "Layout", "Farmland", "Farm house", "Warehouse", "Office space", "Meta space"];
  // Backend restricts type_of_property to these 5 when the parent project is
  // commercial. Anything else is rejected on create/update. Update via formik
  // value (which always reflects the current selection in the Type tab) and
  // the existing project type for edit mode.
  const COMMERCIAL_TOUR_TYPES = ["Office", "Office space", "Commercial", "Shop", "Warehouse"];
  const isCommercialProject =
    formik.values.projectTypeDetails.typeOfProperty === "commercial" ||
    existingProject?.project_type_details?.type === "commercial";
  const availableTourTypes = isCommercialProject ? COMMERCIAL_TOUR_TYPES : TOUR_TYPES;

  const refreshMetaAssets = async () => {
    if (!projectId) return;
    const [mpRes, mmRes] = await Promise.all([
      getMatterports(projectId).catch(() => null),
      getMetaModels(projectId).catch(() => null),
    ]);
    setProjectMatterports(Array.isArray(mpRes?.matterports) ? mpRes.matterports.filter((mp: any) => mp.is_active !== false) : []);
    setProjectMetaModels(Array.isArray(mmRes?.meta_models) ? mmRes.meta_models.filter((mm: any) => mm.is_active !== false) : []);
  };

  // Meta Model handlers
  const startEditMetaModel = (mm: any) => {
    setEditingMetaModelId(mm._id);
    setMetaModelDraft({ name: mm.name || "", url: mm.url || "", slug: mm.slug || "", description: mm.description || "", thumbnail_url: mm.thumbnail_url || "" });
    setShowAddMetaModel(false);
  };
  const cancelEditMetaModel = () => {
    setEditingMetaModelId(null);
    setMetaModelDraft({ name: "", url: "", slug: "", description: "", thumbnail_url: "" });
  };
  const saveMetaModel = async (id: string | null) => {
    if (!metaModelDraft.name.trim() || !metaModelDraft.url.trim()) {
      alert("Name and URL are required");
      return;
    }
    setSavingMetaModel(true);
    try {
      if (!isEditMode) {
        // Create mode: stage locally; will be persisted on project save
        if (id) {
          setProjectMetaModels((prev) =>
            prev.map((mm) => (mm._id === id ? { ...mm, ...metaModelDraft } : mm)),
          );
        } else {
          setProjectMetaModels((prev) => [
            ...prev,
            { _id: `temp-mm-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`, _temp: true, ...metaModelDraft },
          ]);
        }
      } else {
        if (id) {
          await updateMetaModel(id, metaModelDraft);
        } else {
          await createMetaModel({ ...metaModelDraft, project_id: projectId });
        }
        await refreshMetaAssets();
      }
      setEditingMetaModelId(null);
      setShowAddMetaModel(false);
      setMetaModelDraft({ name: "", url: "", slug: "", description: "", thumbnail_url: "" });
    } catch (e) {
      alert("Failed to save meta model. Please try again.");
    } finally {
      setSavingMetaModel(false);
    }
  };
  const removeMetaModel = async (id: string) => {
    if (!window.confirm("Delete this meta model?")) return;
    if (!isEditMode || id.startsWith("temp-")) {
      setProjectMetaModels((prev) => prev.filter((mm) => mm._id !== id));
      return;
    }
    setDeletingMetaModelId(id);
    try {
      await deleteMetaModel(id);
      await refreshMetaAssets();
    } catch (e) {
      alert("Failed to delete meta model.");
    } finally {
      setDeletingMetaModelId(null);
    }
  };

  // Matterport handlers
  const startEditMatterport = (mp: any) => {
    setEditingMatterportId(mp._id);
    setMatterportDraft({ matterport_id: mp.matterport_id || "", name: mp.name || "", tour_type: mp.tour_type || "Apartment", description: mp.description || "" });
    setShowAddMatterport(false);
  };
  const cancelEditMatterport = () => {
    setEditingMatterportId(null);
    setMatterportDraft({ matterport_id: "", name: "", tour_type: availableTourTypes[0], description: "" });
  };
  const saveMatterport = async (id: string | null) => {
    if (!matterportDraft.matterport_id.trim() || !matterportDraft.name.trim()) {
      alert("Matterport ID and Name are required");
      return;
    }
    setSavingMatterport(true);
    try {
      if (!isEditMode) {
        if (id) {
          setProjectMatterports((prev) =>
            prev.map((mp) => (mp._id === id ? { ...mp, ...matterportDraft } : mp)),
          );
        } else {
          setProjectMatterports((prev) => [
            ...prev,
            { _id: `temp-mp-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`, _temp: true, ...matterportDraft },
          ]);
        }
      } else {
        if (id) {
          await updateMatterport(id, matterportDraft);
        } else {
          await createMatterport({ ...matterportDraft, project_id: projectId });
        }
        await refreshMetaAssets();
      }
      setEditingMatterportId(null);
      setShowAddMatterport(false);
      setMatterportDraft({ matterport_id: "", name: "", tour_type: availableTourTypes[0], description: "" });
    } catch (e) {
      alert("Failed to save digital twin. Please try again.");
    } finally {
      setSavingMatterport(false);
    }
  };
  const removeMatterport = async (id: string) => {
    if (!window.confirm("Delete this digital twin?")) return;
    if (!isEditMode || id.startsWith("temp-")) {
      setProjectMatterports((prev) => prev.filter((mp) => mp._id !== id));
      return;
    }
    setDeletingMatterportId(id);
    try {
      await deleteMatterport(id);
      await refreshMetaAssets();
    } catch (e) {
      alert("Failed to delete digital twin.");
    } finally {
      setDeletingMatterportId(null);
    }
  };

  useEffect(() => {
    let cancelled = false;
    if (isEditMode && projectId) {
      setLoadingMetaAssets(true);
      Promise.all([
        getMatterports(projectId).catch((err) => {
          console.error("Failed to fetch matterports:", err);
          return null;
        }),
        getMetaModels(projectId).catch((err) => {
          console.error("Failed to fetch meta models:", err);
          return null;
        }),
      ])
        .then(([mpRes, mmRes]: any[]) => {
          if (cancelled) return;
          setProjectMatterports(
            Array.isArray(mpRes?.matterports) ? mpRes.matterports.filter((mp: any) => mp.is_active !== false) : [],
          );
          setProjectMetaModels(
            Array.isArray(mmRes?.meta_models) ? mmRes.meta_models.filter((mm: any) => mm.is_active !== false) : [],
          );
        })
        .finally(() => {
          if (!cancelled) setLoadingMetaAssets(false);
        });
    }
    return () => {
      cancelled = true;
    };
  }, [isEditMode, projectId]);

  useEffect(() => {
    if (
      !propertyType ||
      ![
        "villaInGatedCommunity",
        "apartment",
        "bungalow",
        "commercialSpace",
        "layoutInGatedCommunity",
      ].includes(propertyType)
    ) {
      return;
    }
    const path = `projectTypeDetails.propertySpecificDetails.${propertyType}`;
    const total = uniqueUnits.reduce(
      (sum: number, u: any) => sum + (parseInt(u.unitNumber) || 0),
      0,
    );
    formik.setFieldValue(`${path}.numberOfUnits`, total.toString());
    formik.setFieldValue(
      `${path}.numberOfUniqueUnits`,
      uniqueUnits.length.toString(),
    );
  }, [uniqueUnits, propertyType]);

  /* The Meta Assets tab's Save button runs Formik's own schema validation
     directly - it's the only tab that does, every other tab goes through
     validateCurrentTab/handleNext below. When that validation fails, Formik
     just skips onSubmit silently; nothing in this file reads formik.errors,
     so the admin saw the button do absolutely nothing with no explanation.
     This flattens whatever Yup rejected into the plain-English messages
     already written into the schema's own .required() calls. */
  const collectFormikErrorMessages = (errors: any): string[] => {
    if (!errors) return [];
    if (typeof errors === "string") return [errors];
    if (Array.isArray(errors)) return errors.flatMap(collectFormikErrorMessages);
    if (typeof errors === "object") {
      return Object.values(errors).flatMap(collectFormikErrorMessages);
    }
    return [];
  };

  const validateCurrentTab = async (): Promise<boolean> => {
    let isValid = true;
    const errors: { [key: string]: string } = {};

    if (activeTab === "details") {
      try {
        await detailsValidationSchema.validate(formik.values.projectDetails, {
          abortEarly: false,
        });
      } catch (err: any) {
        isValid = false;
        err.inner.forEach((error: any) => {
          errors[error.path] = error.message;
        });
      }
    } else if (activeTab === "type") {
      try {
        await typeValidationSchema.validate(formik.values.projectTypeDetails, {
          abortEarly: false,
        });
      } catch (err: any) {
        isValid = false;
        err.inner.forEach((error: any) => {
          errors[error.path] = error.message;
        });
      }
    }

    setFormErrors(errors);
    return isValid;
  };

  const handleNext = async () => {
    const isValid = await validateCurrentTab();

    if (!isValid) {
      const firstError = Object.keys(formErrors)[0];
      if (firstError) {
        const element = document.querySelector(`[name="${firstError}"]`);
        if (element) {
          (element as HTMLElement).scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
          (element as HTMLElement).focus();
        }
      }
      return;
    }

    if (activeTab === "details") {
      setActiveTab("type");
    } else if (activeTab === "type") {
      setActiveTab("gallery");
    } else if (activeTab === "gallery") {
      setActiveTab("amenities");
    } else if (activeTab === "amenities") {
      if (isSuperAdmin && !isEditMode) {
        // Super-admin shortcut: save the project now so meta assets can be
        // attached to it on the next tab in the same flow.
        saveAndContinueRef.current = true;
        setSavingAndContinuing(true);
        formik.handleSubmit();
      } else {
        setActiveTab("meta_assets");
      }
    }
  };

  const handleImageUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    if (!files || files.length === 0) return;

    const fileArray = Array.from(files);
    const maxSize = 5 * 1024 * 1024 * 1024; // 5GB
    for (const file of fileArray) {
      if (!file.type.startsWith("image/")) {
        alert(
          `"${file.name}" is not an image file. Please upload images only.`,
        );
        e.target.value = "";
        return;
      }
      if (file.size > maxSize) {
        alert(
          `File "${file.name}" exceeds 5GB limit. Please upload a smaller file.`,
        );
        e.target.value = "";
        return;
      }
    }

    setIsUploadingImages(true);

    const API_URL = `${process.env.REACT_APP_ONEVERSE_REALESTATE_SERVER_URL}/api/v1/realestate/actions/realestate/gc_upload`;

    const uploadedImages: any[] = [];

    for (const file of fileArray) {
      const uploadFormData = new FormData();
      uploadFormData.append("gc_upload_request", file);

      try {
        const res = await axios.post(API_URL, uploadFormData, {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            "ngrok-skip-browser-warning": "disabled",
            // "Content-Type": "multipart/form-data",
          },
          timeout: 60 * 60000, // 60 minutes timeout
          maxContentLength: Infinity,
          maxBodyLength: Infinity,
          onUploadProgress: (progressEvent) => {
            const percentCompleted = Math.round(
              (progressEvent.loaded * 100) / (progressEvent.total || 1),
            );
            console.log(
              `Upload Progress for ${file.name}: ${percentCompleted}%`,
            );
          },
        });

        uploadedImages.push({
          url: res.data.uploaded_url,
          name: file.name,
        });
      } catch (error) {
        console.error("Image upload failed:", error);
        // alert(`Failed to upload ${file.name}`);
        // Log detailed error for debugging
        if (error.response) {
          console.error("Error response:", error.response.data);
          console.error("Error status:", error.response.status);
          console.error("Error headers:", error.response.headers);
        }

        // Better error handling
        if (error.code === "ECONNABORTED") {
          alert(
            `Upload timeout for ${file.name}. Please try again with a better connection.`,
          );
        } else if (error.response?.status === 400) {
          alert(
            `Bad request for ${file.name}. ${
              error.response?.data?.message ||
              "Please check the file and try again."
            }`,
          );
        } else if (error.response?.status === 413) {
          alert(`File ${file.name} too large. Server rejected the upload.`);
        } else if (error.response?.status === 500) {
          alert(
            `Server error occurred while uploading ${file.name}. Please try again later.`,
          );
        } else {
          alert(
            `Failed to upload ${file.name}. ${
              error.response?.data?.message || error.message || "Unknown error"
            }`,
          );
        }

        // Continue with other files instead of stopping
        continue;
      }
    }

    // If cover image exists, preserve it at first position
    if (coverImage) {
      // Get current images without cover (from index 1 onwards)
      const currentImagesWithoutCover =
        formik.values.projectGallery.images.slice(1);
      const currentPreviewsWithoutCover = images.slice(1);

      // Add new images after existing ones (but after cover)
      formik.setFieldValue("projectGallery.images", [
        formik.values.projectGallery.images[0], // Keep cover image at first
        ...currentImagesWithoutCover,
        ...uploadedImages,
      ]);

      setImages([
        coverImage, // Keep cover image at first
        ...currentPreviewsWithoutCover,
        ...uploadedImages.map((img) => img.url),
      ]);
    } else {
      // No cover image, just append normally
      formik.setFieldValue("projectGallery.images", [
        ...formik.values.projectGallery.images,
        ...uploadedImages,
      ]);

      setImages((prev) => [...prev, ...uploadedImages.map((img) => img.url)]);
    }

    setIsUploadingImages(false);
    e.target.value = "";
  };

  const handleCoverImageUpload = async (
    e: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const files = e.target.files;
    if (!files || files.length === 0) return;

    // Only take the first file
    const file = files[0];

    // Validate image file
    if (!file.type.startsWith("image/")) {
      alert("Please upload an image file only");
      e.target.value = "";
      return;
    }

    // Check file size (5GB limit)
    const maxSize = 5 * 1024 * 1024 * 1024;
    if (file.size > maxSize) {
      alert("File size exceeds 5GB limit. Please upload a smaller file.");
      e.target.value = "";
      return;
    }

    setIsUploadingCoverImage(true);

    const API_URL = `${process.env.REACT_APP_ONEVERSE_REALESTATE_SERVER_URL}/api/v1/realestate/actions/realestate/gc_upload`;

    const uploadFormData = new FormData();
    uploadFormData.append("gc_upload_request", file);

    try {
      const res = await axios.post(API_URL, uploadFormData, {
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
          "ngrok-skip-browser-warning": "disabled",
          // "Content-Type": "multipart/form-data",
        },
        timeout: 30 * 60000, // 30 minutes timeout
        maxContentLength: Infinity,
        maxBodyLength: Infinity,
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / (progressEvent.total || 1),
          );
          console.log(`Upload Progress: ${percentCompleted}%`);
        },
      });

      const coverImageUrl = res.data.uploaded_url;

      // Update cover image state
      setCoverImage(coverImageUrl);

      // Get current images array (excluding old cover image if exists)
      const currentImages = images.filter(
        (img, index) => index !== 0 || !coverImage,
      );
      const currentFormikImages = formik.values.projectGallery.images.filter(
        (img, index) => index !== 0 || !coverImage,
      );

      // Add cover image as first element
      const updatedImages = [coverImageUrl, ...currentImages];
      const updatedFormikImages = [
        { url: coverImageUrl, name: file.name },
        ...currentFormikImages,
      ];

      // Update states
      setImages(updatedImages);
      formik.setFieldValue("projectGallery.images", updatedFormikImages);
    } catch (error) {
      console.error("Cover image upload failed:", error);
      // alert(`Failed to upload cover image`);

      // Log detailed error for debugging
      if (error.response) {
        console.error("Error response:", error.response.data);
        console.error("Error status:", error.response.status);
        console.error("Error headers:", error.response.headers);
      }

      // Better error handling
      if (error.code === "ECONNABORTED") {
        alert(`Upload timeout. Please try again with a better connection.`);
      } else if (error.response?.status === 400) {
        alert(
          `Bad request. ${
            error.response?.data?.message ||
            "Please check the file and try again."
          }`,
        );
      } else if (error.response?.status === 413) {
        alert(`File too large. Server rejected the upload.`);
      } else if (error.response?.status === 500) {
        alert(`Server error occurred. Please try again later.`);
      } else {
        alert(
          `Failed to upload cover image. ${
            error.response?.data?.message || error.message || "Unknown error"
          }`,
        );
      }
    } finally {
      setIsUploadingCoverImage(false);
      e.target.value = "";
    }
  };

  const handleVideoUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    if (!files || files.length === 0) return;

    const fileArray = Array.from(files);
    const newVideos = fileArray.map((file) => ({
      file,
      url: URL.createObjectURL(file),
      name: file.name,
    }));

    formik.values.projectGallery.videos = newVideos;

    // Create previews
    const newPreviews = fileArray.map((file) => URL.createObjectURL(file));
    setVideos((prev) => [...prev, ...newPreviews]);

    // Reset the input value
    e.target.value = "";
  };

  const handleBrochureUpload = async (
    e: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const files = e.target.files;
    if (!files || files.length === 0) return;

    // Check if there's already a brochure uploaded
    if (brochureFiles.length > 0) {
      alert(
        "Please remove the existing brochure first before uploading a new one.",
      );
      e.target.value = "";
      return;
    }

    // Only take the first file
    const file = files[0];

    // Validate PDF file
    if (file.type !== "application/pdf") {
      alert("Please upload PDF file only");
      e.target.value = "";
      return;
    }

    // Check file size (5GB limit)
    const maxSize = 5 * 1024 * 1024 * 1024;
    if (file.size > maxSize) {
      alert("File size exceeds 5GB limit. Please upload a smaller file.");
      e.target.value = "";
      return;
    }

    setIsUploadingBrochures(true);

    const API_URL = `${process.env.REACT_APP_ONEVERSE_REALESTATE_SERVER_URL}/api/v1/realestate/actions/realestate/gc_upload`;

    const uploadFormData = new FormData();
    uploadFormData.append("gc_upload_request", file);

    try {
      const res = await axios.post(API_URL, uploadFormData, {
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
          "ngrok-skip-browser-warning": "disabled",
          // REMOVE Content-Type - let axios set it automatically with boundary
        },
        timeout: 60 * 60000, // 60 minutes timeout
        maxContentLength: Infinity,
        maxBodyLength: Infinity,
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / (progressEvent.total || 1),
          );
          console.log(`Upload Progress: ${percentCompleted}%`);
        },
      });

      const uploadedBrochure = {
        url: res.data.uploaded_url,
        name: file.name,
        size: `${(file.size / 1024 / 1024).toFixed(2)} MB`,
      };

      formik.setFieldValue("projectGallery.brochures", [uploadedBrochure]);
      setBrochureFiles([uploadedBrochure]);

      alert("Brochure uploaded successfully!");
    } catch (error: any) {
      console.error("Brochure upload failed:", error);

      // Log detailed error for debugging
      if (error.response) {
        console.error("Error response:", error.response.data);
        console.error("Error status:", error.response.status);
        console.error("Error headers:", error.response.headers);
      }

      // Better error handling
      if (error.code === "ECONNABORTED") {
        alert(`Upload timeout. Please try again with a better connection.`);
      } else if (error.response?.status === 400) {
        alert(
          `Bad request. ${
            error.response?.data?.message ||
            "Please check the file and try again."
          }`,
        );
      } else if (error.response?.status === 413) {
        alert(`File too large. Server rejected the upload.`);
      } else if (error.response?.status === 500) {
        alert(`Server error occurred. Please try again later.`);
      } else {
        alert(
          `Failed to upload ${file.name}. ${
            error.response?.data?.message || error.message || "Unknown error"
          }`,
        );
      }
    } finally {
      setIsUploadingBrochures(false);
      e.target.value = "";
    }
  };

  const handleRemoveBrochure = () => {
    // Clear all brochures
    setBrochureFiles([]);
    formik.setFieldValue("projectGallery.brochures", []);
  };

  const handleRemoveImage = (index: number) => {
    // Remove from local state only
    setImages((prev) => prev.filter((_, i) => i !== index));
    formik.setFieldValue(
      "projectGallery.images",
      formik.values.projectGallery.images.filter((_, i) => i !== index),
    );
  };

  const handleRemoveCoverImage = () => {
    if (!coverImage) return;

    // Remove cover image (first element) from arrays
    setImages((prev) => prev.slice(1));
    formik.setFieldValue(
      "projectGallery.images",
      formik.values.projectGallery.images.slice(1),
    );

    // Clear cover image state
    setCoverImage("");
  };

  const handleRemoveVideo = (index: number) => {
    const updatedVideos = videos.filter((_, i) => i !== index);
    setVideos(updatedVideos);
  };

  const removeFile = (type: string, id: any, previewUrl?: string) => {
    if (previewUrl) {
      URL.revokeObjectURL(previewUrl);
    }

    if (type === "video")
      setVideos((prev: any) => prev.filter((f: any) => f.id !== id));
  };

  const handleAddUniqueUnit = () => {
    if (!propertyType) {
      alert("Please select a property type first");
      return;
    }

    let newUnit: any = {};
    switch (propertyType) {
      case "villaInGatedCommunity":
      case "apartment":
      case "farmland":
      case "layoutInGatedCommunity":
      case "bungalow":
        newUnit = {
          id: Date.now().toString(),
          unitNumber: "",
          facing: "",
          sizeInSqft: "",
          bhk: "",
        };
        if (propertyType === "bungalow") {
          newUnit.plotSizeInSqft = "";
        }
        break;
    }

    setUniqueUnits([...uniqueUnits, newUnit]);
  };

  const handleUniqueUnitChange = (
    index: number,
    field: string,
    value: string,
  ) => {
    const updatedUnits = [...uniqueUnits];
    updatedUnits[index][field] = value;
    setUniqueUnits(updatedUnits);
  };

  const handleRemoveUniqueUnit = (index: number) => {
    const updatedUnits = uniqueUnits.filter((_, i) => i !== index);
    setUniqueUnits(updatedUnits);
  };

  // Tower handlers for the commercial project type
  const commercialTowersPath =
    "projectTypeDetails.propertySpecificDetails.commercial.towers";
  const handleAddCommercialTower = () => {
    const towers =
      formik.values.projectTypeDetails.propertySpecificDetails.commercial
        .towers || [];
    formik.setFieldValue(commercialTowersPath, [
      ...towers,
      {
        id: Date.now().toString(),
        name: "",
        numberOfFloors: "",
        floorPlateSqft: "",
      },
    ]);
  };
  const handleRemoveCommercialTower = (index: number) => {
    const towers =
      formik.values.projectTypeDetails.propertySpecificDetails.commercial
        .towers || [];
    formik.setFieldValue(
      commercialTowersPath,
      towers.filter((_: any, i: number) => i !== index),
    );
  };
  const handleCommercialTowerChange = (
    index: number,
    field: string,
    value: string,
  ) => {
    const towers = [
      ...(formik.values.projectTypeDetails.propertySpecificDetails.commercial
        .towers || []),
    ];
    towers[index] = { ...towers[index], [field]: value };
    formik.setFieldValue(commercialTowersPath, towers);
  };

  const renderPropertyTypeForm = () => {
    const inputClass =
      "w-full px-3 py-2 rounded-lg bg-[#2E4051] text-[#F4F5F7] text-sm border-none placeholder-[#5A6F84] focus:outline-none focus:ring-2 focus:ring-[#008564] [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none";
    const inputReadOnlyClass = inputClass + " opacity-70 cursor-not-allowed";
    const rowInputClass =
      "w-full px-2.5 py-1.5 rounded-md bg-[#1D3440] text-[#F4F5F7] text-sm border border-[#374B5E] placeholder-[#5A6F84] focus:outline-none focus:ring-1 focus:ring-[#008564] [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none";
    const sectionLabel =
      "text-[#889DB2] text-xs uppercase tracking-wider font-semibold";
    const fieldLabel = "text-[#889DB2] block text-sm font-medium mb-1.5";
    const facingOptions = [
      { value: "north", label: "North" },
      { value: "south", label: "South" },
      { value: "east", label: "East" },
      { value: "west", label: "West" },
    ];
    const sumUnits = uniqueUnits
      .reduce((s: number, u: any) => s + (parseInt(u.unitNumber) || 0), 0)
      .toString();
    const countUniqueUnits = uniqueUnits.length.toString();

    const renderSection = (
      title: React.ReactNode,
      children: React.ReactNode,
      action?: React.ReactNode,
    ) => (
      <div className="border border-[#374B5E] rounded-lg p-4">
        <div className="flex items-center justify-between mb-4">
          <h3 className={sectionLabel + " mb-0"}>{title}</h3>
          {action}
        </div>
        {children}
      </div>
    );

    const renderUnitsTable = (opts: {
      withBHK: boolean;
      rowLabel: string;
    }) => {
      const { withBHK, rowLabel } = opts;
      const cols = withBHK
        ? "grid-cols-1 sm:grid-cols-[1fr_1fr_1fr_0.8fr_auto]"
        : "grid-cols-1 sm:grid-cols-[1fr_1fr_1fr_auto]";
      const headerLabel =
        "text-[#889DB2] text-xs uppercase tracking-wider font-semibold";
      return renderSection(
        `${rowLabel} Configurations (${uniqueUnits.length})`,
        uniqueUnits.length === 0 ? (
          <div className="py-8 text-center text-sm text-[#889DB2] border border-dashed border-[#374B5E] rounded-lg">
            No rows yet. Click{" "}
            <span className="text-white">+ Add {rowLabel}</span> to add one.
          </div>
        ) : (
          <div>
            {/* Sticky header row — column labels shown once, not per row */}
            <div
              className={`grid gap-3 items-center px-3 pb-2 ${cols} sm:hidden`}
            >
              {/* On mobile (single column) the per-row labels render inside
                  each row instead — this header is desktop-only. */}
            </div>
            <div
              className={`hidden sm:grid gap-3 items-center px-3 pb-2 ${cols} border-b border-[#374B5E] mb-3`}
            >
              <div className={headerLabel}>Count *</div>
              <div className={headerLabel}>Facing</div>
              <div className={headerLabel}>Size (sqft) *</div>
              {withBHK && <div className={headerLabel}>BHK *</div>}
              <div />
            </div>

            {/* Rows — scroll container so 20+ rows don't dominate the page */}
            <div
              className="space-y-2 max-h-[420px] overflow-y-auto pr-1"
              style={{ scrollbarWidth: "thin" }}
            >
              {uniqueUnits.map((unit: any, index: number) => (
                <div
                  key={unit.id}
                  className={`grid gap-3 items-center px-3 py-2 bg-[#1D3440] rounded-lg ${cols}`}
                >
                  <div>
                    <label className={`${fieldLabel} sm:hidden`}>Count *</label>
                    <input
                      type="number"
                      className={rowInputClass}
                      value={unit.unitNumber || ""}
                      onChange={(e) =>
                        handleUniqueUnitChange(index, "unitNumber", e.target.value)
                      }
                      placeholder="e.g. 24"
                    />
                  </div>
                  <div>
                    <label className={`${fieldLabel} sm:hidden`}>Facing</label>
                    {/* Native <select> instead of CustomSelect — the
                        absolute-positioned CustomSelect panel gets clipped
                        by the scroll container; native renders above the
                        viewport. */}
                    <select
                      className="w-full px-2.5 py-1.5 pr-8 rounded-md bg-[#1D3440] text-[#F4F5F7] text-sm border border-[#374B5E] focus:outline-none focus:ring-1 focus:ring-[#008564]"
                      style={{
                        appearance: "none",
                        WebkitAppearance: "none",
                        MozAppearance: "none",
                        backgroundImage:
                          "url(\"data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23889DB2' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e\")",
                        backgroundRepeat: "no-repeat",
                        backgroundPosition: "right 8px center",
                        backgroundSize: "14px 14px",
                      }}
                      value={unit.facing || ""}
                      onChange={(e) =>
                        handleUniqueUnitChange(index, "facing", e.target.value)
                      }
                    >
                      <option value="">Select…</option>
                      {facingOptions.map((opt) => (
                        <option key={opt.value} value={opt.value}>
                          {opt.label}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div>
                    <label className={`${fieldLabel} sm:hidden`}>Size (sqft) *</label>
                    <input
                      type="number"
                      className={rowInputClass}
                      value={unit.sizeInSqft || ""}
                      onChange={(e) =>
                        handleUniqueUnitChange(index, "sizeInSqft", e.target.value)
                      }
                      placeholder="e.g. 1200"
                    />
                  </div>
                  {withBHK && (
                    <div>
                      <label className={`${fieldLabel} sm:hidden`}>BHK *</label>
                      <input
                        type="number"
                        className={rowInputClass}
                        value={unit.bhk || ""}
                        onChange={(e: any) => {
                          const v = e.target.value;
                          if (v === "" || (parseInt(v) >= 1 && parseInt(v) <= 10)) {
                            handleUniqueUnitChange(index, "bhk", v);
                          }
                        }}
                        min="1"
                        max="10"
                        placeholder="e.g. 3"
                      />
                    </div>
                  )}
                  <button
                    type="button"
                    onClick={() => handleRemoveUniqueUnit(index)}
                    title="Remove row"
                    className="h-9 px-3 text-[#889DB2] hover:text-red-400 text-lg leading-none justify-self-end"
                  >
                    ×
                  </button>
                </div>
              ))}
            </div>
          </div>
        ),
        <button
          type="button"
          onClick={handleAddUniqueUnit}
          className="px-3 py-1.5 bg-[#008564] text-white text-xs font-medium rounded-lg hover:bg-[#006e52]"
        >
          + Add {rowLabel}
        </button>,
      );
    };

    switch (propertyType) {
      case "villaInGatedCommunity": {
        const v =
          formik.values.projectTypeDetails.propertySpecificDetails
            .villaInGatedCommunity;
        return (
          <div className="space-y-5 w-full">
            {renderSection(
              "Property Details",
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                <div>
                  <label className={fieldLabel}>Total Villas</label>
                  <input
                    type="number"
                    readOnly
                    className={inputReadOnlyClass}
                    value={sumUnits}
                    placeholder="Auto-calculated"
                  />
                  <p className="text-xs text-[#5A6F84] mt-1.5">
                    Sum of Count across rows below.
                  </p>
                </div>
                <div>
                  <label className={fieldLabel}>Unique Configurations</label>
                  <input
                    type="number"
                    readOnly
                    className={inputReadOnlyClass}
                    value={countUniqueUnits}
                    placeholder="Auto-calculated"
                  />
                  <p className="text-xs text-[#5A6F84] mt-1.5">
                    Number of rows below.
                  </p>
                </div>
                <div>
                  <label className={fieldLabel}>Clubhouse Size (sqft)</label>
                  <input
                    type="number"
                    className={inputClass}
                    value={v.clubhouseSizeSqft}
                    onChange={(e) =>
                      formik.setFieldValue(
                        "projectTypeDetails.propertySpecificDetails.villaInGatedCommunity.clubhouseSizeSqft",
                        e.target.value,
                      )
                    }
                    placeholder="e.g. 12000"
                  />
                </div>
              </div>,
            )}
            {renderUnitsTable({ withBHK: true, rowLabel: "Unit" })}
          </div>
        );
      }
      case "apartment": {
        const a =
          formik.values.projectTypeDetails.propertySpecificDetails.apartment;
        return (
          <div className="space-y-5 w-full">
            {renderSection(
              "Building Details",
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div>
                  <label className={fieldLabel}>Number of Towers *</label>
                  <input
                    type="number"
                    className={inputClass}
                    value={a.numberOfTowers}
                    onChange={(e) =>
                      formik.setFieldValue(
                        "projectTypeDetails.propertySpecificDetails.apartment.numberOfTowers",
                        e.target.value,
                      )
                    }
                    placeholder="e.g. 3"
                  />
                </div>
                <div>
                  <label className={fieldLabel}>Number of Floors *</label>
                  <input
                    type="number"
                    className={inputClass}
                    value={a.numberOfFloors}
                    onChange={(e) =>
                      formik.setFieldValue(
                        "projectTypeDetails.propertySpecificDetails.apartment.numberOfFloors",
                        e.target.value,
                      )
                    }
                    placeholder="e.g. 18"
                  />
                </div>
                <div>
                  <label className={fieldLabel}>Total Units</label>
                  <input
                    type="number"
                    readOnly
                    className={inputReadOnlyClass}
                    value={sumUnits}
                    placeholder="Auto-calculated"
                  />
                  <p className="text-xs text-[#5A6F84] mt-1.5">
                    Sum of Count across rows below.
                  </p>
                </div>
                <div>
                  <label className={fieldLabel}>Unique Configurations</label>
                  <input
                    type="number"
                    readOnly
                    className={inputReadOnlyClass}
                    value={countUniqueUnits}
                    placeholder="Auto-calculated"
                  />
                  <p className="text-xs text-[#5A6F84] mt-1.5">
                    Number of rows below.
                  </p>
                </div>
                <div className="sm:col-span-2">
                  <label className={fieldLabel}>Clubhouse Size (sqft)</label>
                  <input
                    type="number"
                    className={inputClass}
                    value={a.clubhouseSizeSqft}
                    onChange={(e) =>
                      formik.setFieldValue(
                        "projectTypeDetails.propertySpecificDetails.apartment.clubhouseSizeSqft",
                        e.target.value,
                      )
                    }
                    placeholder="e.g. 18000"
                  />
                </div>
              </div>,
            )}
            {renderUnitsTable({ withBHK: true, rowLabel: "Unit" })}
          </div>
        );
      }
      case "farmland":
        return (
          <div className="space-y-5 w-full">
            {renderUnitsTable({ withBHK: false, rowLabel: "Plot" })}
          </div>
        );

      case "bungalow":
        return (
          <div className="flex flex-col gap-4 space-y-4 md:space-y-6">
            <CardBorder title="Property Details" borderColor="border-[#FFFFFF]">
              <div className="w-full grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4">
                <div>
                  <label className="text-[#889DB2] block text-lg font-medium mb-1">
                    Number of Units
                  </label>
                  <input
                    type="number"
                    className="text-[#F4F5F7] w-full px-3 py-2 rounded-lg shadow-md border-none text-lg md:text-base bg-[#2E4051] focus:border-[#008564] focus:outline-none focus:ring-2 focus:ring-[#008564] [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
                    readOnly
                    value={
                      formik.values.projectTypeDetails.propertySpecificDetails
                        .bungalow.numberOfUnits
                    }
                    placeholder="Auto-calculated"
                  />
                  <p className="text-xs text-[#889DB2] mt-2 italic">
                    Sum of units across all rows in Unique Unit Details
                  </p>
                </div>
                <div>
                  <label className="text-[#889DB2] block text-lg font-medium mb-1">
                    Unique Units
                  </label>
                  <input
                    type="number"
                    className="text-[#F4F5F7] w-full px-3 py-2 rounded-lg shadow-md border-none text-sm md:text-base bg-[#2E4051] focus:border-[#008564] focus:outline-none focus:ring-2 focus:ring-[#008564] [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
                    readOnly
                    value={
                      formik.values.projectTypeDetails.propertySpecificDetails
                        .bungalow.numberOfUniqueUnits
                    }
                    placeholder="Auto-calculated"
                  />
                  <p className="text-xs text-[#889DB2] mt-2 italic">
                    Count of rows in Unique Unit Details
                  </p>
                </div>
                <div>
                  <label className="text-[#889DB2] block text-lg font-medium mb-1">
                    Common Area Size (Sqft)
                  </label>
                  <input
                    type="number"
                    className="text-[#F4F5F7] w-full px-3 py-2 rounded-lg shadow-md border-none text-sm md:text-base bg-[#2E4051] focus:border-[#008564] focus:outline-none focus:ring-2 focus:ring-[#008564] [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
                    value={
                      formik.values.projectTypeDetails.propertySpecificDetails
                        .bungalow.commonAreaSizeSqft
                    }
                    onChange={(e) =>
                      formik.setFieldValue(
                        "projectTypeDetails.propertySpecificDetails.bungalow.commonAreaSizeSqft",
                        e.target.value,
                      )
                    }
                    placeholder="Enter..."
                  />
                </div>
              </div>
            </CardBorder>

            <CardBorder
              title="Unique Unit Details"
              borderColor="border-[#FFFFFF]"
            >
              <div className="flex flex-col w-full mt-6 md:mt-8">
                {uniqueUnits.length > 0 ? (
                  <div className=" -mx-2 md:mx-0">
                    <div className="min-w-full inline-block align-middle">
                      <div className="rounded-lg border border-[#374B5E]">
                        <table className="min-w-full border-collapse rounded-lg ">
                          <thead className="bg-[#222F3C] border border-[#374B5E]">
                            <tr className="bg-[#222F3C] text-[#889DB2]  border-b-2 border-[#374B5E]">
                              <th className="px-3 py-2 text-left text-xs font-medium text-[#889DB2] uppercase tracking-wider">
                                Unit Number
                              </th>
                              <th className="px-3 py-2 text-left text-xs font-medium text-[#889DB2] uppercase tracking-wider">
                                Facing
                              </th>
                              <th className="px-3 py-2 text-left text-xs font-medium text-[#889DB2] uppercase tracking-wider">
                                Size in Sqft
                              </th>
                              <th className="px-3 py-2 text-left text-xs font-medium text-[#889DB2] uppercase tracking-wider">
                                Plot Size in Sqft
                              </th>
                              <th className="px-3 py-2 text-left text-xs font-medium text-[#889DB2] uppercase tracking-wider">
                                BHK
                              </th>
                              <th className="px-3 py-2 text-left text-xs font-medium text-[#889DB2] uppercase tracking-wider">
                                Actions
                              </th>
                            </tr>
                          </thead>
                          <tbody className="bg-[#2E4051] border border-[#374B5E]">
                            {uniqueUnits.map((unit, index) => (
                              <tr
                                key={unit.id}
                                className="hover:bg-[#35495E] transition-colors border-b-2 border-[#374B5E]"
                              >
                                <td className="px-3 py-2 whitespace-nowrap">
                                  <input
                                    type="text"
                                    className="text-[#F4F5F7] w-full px-3 py-1 border border-[#919AA4] rounded text-sm bg-[#2E4051] focus:border-[#008564] focus:outline-none focus:ring-2 focus:ring-[#008564]"
                                    value={unit.unitNumber || ""}
                                    onChange={(e) =>
                                      handleUniqueUnitChange(
                                        index,
                                        "unitNumber",
                                        e.target.value,
                                      )
                                    }
                                    placeholder="Enter Unit Number"
                                  />
                                </td>
                                <td className="px-3 py-2 whitespace-nowrap">
                                  <CustomSelect
                                    label=""
                                    name="projectTypeDetails.typeOfProperty"
                                    value={unit.facing || ""}
                                    type="client"
                                    border="rounded border border-[#919AA4]"
                                    onChange={(e: any) =>
                                      handleUniqueUnitChange(
                                        index,
                                        "facing",
                                        e.target.value,
                                      )
                                    }
                                    options={[
                                      { value: "", label: "Direction" },
                                      { value: "north", label: "North" },
                                      { value: "south", label: "South" },
                                      { value: "east", label: "East" },
                                      { value: "west", label: "West" },
                                    ]}
                                    py={1}
                                  />
                                </td>
                                <td className="px-3 py-2 whitespace-nowrap">
                                  <input
                                    type="number"
                                    className="text-[#F4F5F7] w-full px-3 py-1 border border-[#919AA4] rounded text-sm bg-[#2E4051] focus:border-[#008564] focus:outline-none focus:ring-2 focus:ring-[#008564]"
                                    value={unit.sizeInSqft || ""}
                                    onChange={(e) =>
                                      handleUniqueUnitChange(
                                        index,
                                        "sizeInSqft",
                                        e.target.value,
                                      )
                                    }
                                    placeholder="Enter Size"
                                  />
                                </td>
                                <td className="px-3 py-2 whitespace-nowrap">
                                  <input
                                    type="number"
                                    className="text-[#F4F5F7] w-full px-3 py-1 border border-[#919AA4] rounded text-sm bg-[#2E4051] focus:border-[#008564] focus:outline-none focus:ring-2 focus:ring-[#008564]"
                                    value={unit.plotSizeInSqft || ""}
                                    onChange={(e) =>
                                      handleUniqueUnitChange(
                                        index,
                                        "plotSizeInSqft",
                                        e.target.value,
                                      )
                                    }
                                    placeholder="Enter Plot Size"
                                  />
                                </td>
                                <td className="px-3 py-2 whitespace-nowrap">
                                  <input
                                    type="number"
                                    className="text-[#F4F5F7] w-full px-3 py-1 border border-[#919AA4] rounded text-sm bg-[#2E4051] focus:border-[#008564] focus:outline-none focus:ring-2 focus:ring-[#008564]"
                                    value={unit.bhk || ""}
                                    onChange={(e: any) => {
                                      const value = e.target.value;
                                      if (
                                        value === "" ||
                                        (parseInt(value) >= 1 &&
                                          parseInt(value) <= 10)
                                      ) {
                                        handleUniqueUnitChange(
                                          index,
                                          "bhk",
                                          value,
                                        );
                                      }
                                    }}
                                    onInput={(e: any) => {
                                      if (e.target.value.length > 2) {
                                        e.target.value = e.target.value.slice(
                                          0,
                                          2,
                                        );
                                      }
                                    }}
                                    min="1"
                                    max="10"
                                    placeholder="Enter BHK"
                                  />
                                </td>
                                <td className="px-3 py-2 whitespace-nowrap">
                                  <button
                                    type="button"
                                    onClick={() =>
                                      handleRemoveUniqueUnit(index)
                                    }
                                    className="px-3 py-1 text-white rounded hover:bg-red-600 text-lg"
                                  >
                                    <Icon
                                      name="ic-delete"
                                      className="w-5 h-5"
                                    />
                                  </button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                ) : (
                  <p className="text-gray-500 text-center py-4 text-sm md:text-base">
                    No unique units added yet
                  </p>
                )}

                <div className="flex w-full items-center justify-center">
                  <label
                    htmlFor="brochure-upload-input"
                    onClick={handleAddUniqueUnit}
                    className="block rounded-lg p-6 text-center justify-center transition-colors cursor-pointer"
                  >
                    <div className="flex flex-col justify-center items-center">
                      <div className="flex justify-center items-center text-4xl text-white mb-2 w-12 h-12 bg-[#008564] rounded-full">
                        +
                      </div>
                      <div className="flex w-full items-center justify-center text-white font-medium">
                        Add unique unit
                      </div>
                    </div>
                  </label>
                </div>
              </div>
            </CardBorder>
          </div>
        );

      case "commercialSpace":
        return (
          <div className="flex flex-col gap-4 space-y-4 md:space-y-6">
            <CardBorder title="Property Details" borderColor="border-[#FFFFFF]">
              <div className="w-full grid grid-cols-1 sm:grid-cols-2 gap-3 md:gap-4">
                <div>
                  <label className="text-[#889DB2] block text-lg font-medium mb-1">
                    Number of Floors
                  </label>
                  <input
                    type="number"
                    className="text-[#F4F5F7] w-full px-3 py-2 rounded-lg shadow-md border-none text-lg md:text-base bg-[#2E4051] focus:border-[#008564] focus:outline-none focus:ring-2 focus:ring-[#008564] [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
                    value={
                      formik.values.projectTypeDetails.propertySpecificDetails
                        .commercialSpace.numberOfFloors
                    }
                    onChange={(e) =>
                      formik.setFieldValue(
                        "projectTypeDetails.propertySpecificDetails.commercialSpace.numberOfFloors",
                        e.target.value,
                      )
                    }
                    placeholder="Enter..."
                  />
                </div>
                <div>
                  <label className="text-[#889DB2] block text-lg font-medium mb-1">
                    Number of Units
                  </label>
                  <input
                    type="number"
                    className="text-[#F4F5F7] w-full px-3 py-2 rounded-lg shadow-md border-none text-lg md:text-base bg-[#2E4051] focus:border-[#008564] focus:outline-none focus:ring-2 focus:ring-[#008564] [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
                    readOnly
                    value={
                      formik.values.projectTypeDetails.propertySpecificDetails
                        .commercialSpace.numberOfUnits
                    }
                    placeholder="Auto-calculated"
                  />
                  <p className="text-xs text-[#889DB2] mt-2 italic">
                    Sum of units across all rows in Unique Unit Details
                  </p>
                </div>
                <div>
                  <label className="text-[#889DB2] block text-lg font-medium mb-1">
                    Unique Units
                  </label>
                  <input
                    type="number"
                    className="text-[#F4F5F7] w-full px-3 py-2 rounded-lg shadow-md border-none text-sm md:text-base bg-[#2E4051] focus:border-[#008564] focus:outline-none focus:ring-2 focus:ring-[#008564] [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
                    readOnly
                    value={
                      formik.values.projectTypeDetails.propertySpecificDetails
                        .commercialSpace.numberOfUniqueUnits
                    }
                    placeholder="Auto-calculated"
                  />
                  <p className="text-xs text-[#889DB2] mt-2 italic">
                    Count of rows in Unique Unit Details
                  </p>
                </div>
                <div>
                  <label className="text-[#889DB2] block text-lg font-medium mb-1">
                    Common Facilities Size (Sqft)
                  </label>
                  <input
                    type="number"
                    className="text-[#F4F5F7] w-full px-3 py-2 rounded-lg shadow-md border-none text-sm md:text-base bg-[#2E4051] focus:border-[#008564] focus:outline-none focus:ring-2 focus:ring-[#008564] [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
                    value={
                      formik.values.projectTypeDetails.propertySpecificDetails
                        .commercialSpace.commonFacilitiesSizeSqft
                    }
                    onChange={(e) =>
                      formik.setFieldValue(
                        "projectTypeDetails.propertySpecificDetails.commercialSpace.commonFacilitiesSizeSqft",
                        e.target.value,
                      )
                    }
                    placeholder="Enter..."
                  />
                </div>
              </div>
            </CardBorder>

            <CardBorder
              title="Unique Unit Details"
              borderColor="border-[#FFFFFF]"
            >
              <div className="flex flex-col w-full mt-6 md:mt-8">
                {uniqueUnits.length > 0 ? (
                  <div className=" -mx-2 md:mx-0">
                    <div className="min-w-full inline-block align-middle">
                      <div className="rounded-lg border border-[#374B5E]">
                        <table className="min-w-full border-collapse rounded-lg ">
                          <thead className="bg-[#222F3C] border border-[#374B5E]">
                            <tr className="bg-[#222F3C] text-[#889DB2]  border-b-2 border-[#374B5E]">
                              <th className="px-3 py-2 text-center text-xs font-medium text-[#889DB2] uppercase tracking-wider">
                                Unit Number
                              </th>
                              <th className="px-3 py-2 text-center text-xs font-medium text-[#889DB2] uppercase tracking-wider">
                                Facing
                              </th>
                              <th className="px-3 py-2 text-center text-xs font-medium text-[#889DB2] uppercase tracking-wider">
                                Size in Sqft
                              </th>
                              <th className="px-3 py-2 text-center text-xs font-medium text-[#889DB2] uppercase tracking-wider">
                                Unit Type
                              </th>
                              <th className="px-3 py-2 text-center text-xs font-medium text-[#889DB2] uppercase tracking-wider">
                                Floor Number
                              </th>
                              <th className="px-3 py-2 text-center text-xs font-medium text-[#889DB2] uppercase tracking-wider">
                                Actions
                              </th>
                            </tr>
                          </thead>
                          <tbody className="bg-[#2E4051] border border-[#374B5E]">
                            {uniqueUnits.map((unit, index) => (
                              <tr
                                key={unit.id}
                                className="hover:bg-[#35495E] transition-colors border-b-2 border-[#374B5E]"
                              >
                                <td className="px-3 py-2 whitespace-nowrap text-center">
                                  <input
                                    type="text"
                                    className="text-[#F4F5F7] w-full px-3 py-1 border border-[#919AA4] rounded text-sm bg-[#2E4051] focus:border-[#008564] focus:outline-none focus:ring-2 focus:ring-[#008564]"
                                    value={unit.unitNumber || ""}
                                    onChange={(e) =>
                                      handleUniqueUnitChange(
                                        index,
                                        "unitNumber",
                                        e.target.value,
                                      )
                                    }
                                    placeholder="Enter Unit Number"
                                  />
                                </td>
                                <td className="px-3 py-2 whitespace-nowrap">
                                  <CustomSelect
                                    label=""
                                    name="projectTypeDetails.typeOfProperty"
                                    value={unit.facing || ""}
                                    type="client"
                                    border="rounded border border-[#919AA4]"
                                    onChange={(e: any) =>
                                      handleUniqueUnitChange(
                                        index,
                                        "facing",
                                        e.target.value,
                                      )
                                    }
                                    options={[
                                      { value: "", label: "Direction" },
                                      { value: "north", label: "North" },
                                      { value: "south", label: "South" },
                                      { value: "east", label: "East" },
                                      { value: "west", label: "West" },
                                    ]}
                                    py={1}
                                  />
                                </td>
                                <td className="px-3 py-2 whitespace-nowrap">
                                  <input
                                    type="number"
                                    className="text-[#F4F5F7] w-full px-3 py-1 border border-[#919AA4] rounded text-sm bg-[#2E4051] focus:border-[#008564] focus:outline-none focus:ring-2 focus:ring-[#008564]"
                                    value={unit.sizeInSqft || ""}
                                    onChange={(e) =>
                                      handleUniqueUnitChange(
                                        index,
                                        "sizeInSqft",
                                        e.target.value,
                                      )
                                    }
                                    placeholder="Enter Size"
                                  />
                                </td>
                                <td className="px-3 py-2 whitespace-nowrap">
                                  <input
                                    type="text"
                                    className="text-[#F4F5F7] w-full px-3 py-1 border border-[#919AA4] rounded text-sm bg-[#2E4051] focus:border-[#008564] focus:outline-none focus:ring-2 focus:ring-[#008564]"
                                    value={unit.unitType || ""}
                                    onChange={(e) =>
                                      handleUniqueUnitChange(
                                        index,
                                        "unitType",
                                        e.target.value,
                                      )
                                    }
                                    placeholder="e.g., Office, Shop"
                                  />
                                </td>
                                <td className="px-3 py-2 whitespace-nowrap">
                                  <input
                                    type="number"
                                    className="text-[#F4F5F7] w-full px-3 py-1 border border-[#919AA4] rounded text-sm bg-[#2E4051] focus:border-[#008564] focus:outline-none focus:ring-2 focus:ring-[#008564]"
                                    value={unit.floorNumber || ""}
                                    onChange={(e) =>
                                      handleUniqueUnitChange(
                                        index,
                                        "floorNumber",
                                        e.target.value,
                                      )
                                    }
                                    placeholder="Floor"
                                  />
                                </td>
                                <td className="px-3 py-2 whitespace-nowrap text-center">
                                  <button
                                    type="button"
                                    onClick={() =>
                                      handleRemoveUniqueUnit(index)
                                    }
                                    className="px-2 py-1 text-white rounded hover:bg-red-600 text-lg"
                                  >
                                    <Icon
                                      name="ic-delete"
                                      className="w-5 h-5"
                                    />
                                  </button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                ) : (
                  <p className="text-gray-500 text-center py-4 text-sm md:text-base">
                    No unique units added yet
                  </p>
                )}

                <div className="flex w-full items-center justify-center">
                  <label
                    htmlFor="brochure-upload-input"
                    onClick={handleAddUniqueUnit}
                    className="block rounded-lg p-6 text-center justify-center transition-colors cursor-pointer"
                  >
                    <div className="flex flex-col justify-center items-center">
                      <div className="flex justify-center items-center text-4xl text-white mb-2 w-12 h-12 bg-[#008564] rounded-full">
                        +
                      </div>
                      <div className="text-white font-medium">
                        Add unique unit
                      </div>
                    </div>
                  </label>
                </div>
              </div>
            </CardBorder>
          </div>
        );

      case "layoutInGatedCommunity": {
        const l =
          formik.values.projectTypeDetails.propertySpecificDetails
            .layoutInGatedCommunity;
        return (
          <div className="space-y-5 w-full">
            {renderSection(
              "Property Details",
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div>
                  <label className={fieldLabel}>Total Plots</label>
                  <input
                    type="number"
                    readOnly
                    className={inputReadOnlyClass}
                    value={sumUnits}
                    placeholder="Auto-calculated"
                  />
                  <p className="text-xs text-[#5A6F84] mt-1.5">
                    Sum of Count across rows below.
                  </p>
                </div>
                <div>
                  <label className={fieldLabel}>Clubhouse Size (sqft)</label>
                  <input
                    type="number"
                    className={inputClass}
                    value={l.clubhouseSizeSqft}
                    onChange={(e) =>
                      formik.setFieldValue(
                        "projectTypeDetails.propertySpecificDetails.layoutInGatedCommunity.clubhouseSizeSqft",
                        e.target.value,
                      )
                    }
                    placeholder="e.g. 8000"
                  />
                </div>
              </div>,
            )}
            {renderUnitsTable({ withBHK: false, rowLabel: "Layout" })}
          </div>
        );
      }

      case "commercial": {
        const c =
          formik.values.projectTypeDetails.propertySpecificDetails.commercial;
        const buildingGrades = ["Grade A", "Grade A+", "Grade B"];
        const inputClass =
          "w-full px-3 py-2 rounded-lg bg-[#2E4051] text-[#F4F5F7] text-sm border-none placeholder-[#5A6F84] focus:outline-none focus:ring-2 focus:ring-[#008564] [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none";
        const sectionLabel =
          "text-[#889DB2] text-xs uppercase tracking-wider mb-4 font-semibold block";
        const fieldLabel =
          "text-[#889DB2] block text-sm font-medium mb-1.5";
        return (
          <div className="space-y-5 w-full">
            {/* Building details */}
            <div className="border border-[#374B5E] rounded-lg p-4">
              <h3 className={sectionLabel}>Building Details</h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div className="sm:col-span-2">
                  <label className={fieldLabel}>Building Grade *</label>
                  <div className="flex flex-wrap gap-2">
                    {buildingGrades.map((grade) => {
                      const isOn = c.buildingGrade === grade;
                      return (
                        <button
                          key={grade}
                          type="button"
                          onClick={() =>
                            formik.setFieldValue(
                              "projectTypeDetails.propertySpecificDetails.commercial.buildingGrade",
                              grade,
                            )
                          }
                          className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                            isOn
                              ? "bg-[#008564] text-white"
                              : "bg-[#2E4051] text-[#889DB2] hover:text-white"
                          }`}
                        >
                          {grade}
                        </button>
                      );
                    })}
                  </div>
                </div>
                <div>
                  <label className={fieldLabel}>
                    Total Leasable Area (sqft) *
                  </label>
                  <input
                    type="number"
                    className={inputClass}
                    value={c.totalLeasableAreaSqft}
                    onChange={(e) =>
                      formik.setFieldValue(
                        "projectTypeDetails.propertySpecificDetails.commercial.totalLeasableAreaSqft",
                        e.target.value,
                      )
                    }
                    placeholder="e.g. 2500000"
                  />
                </div>
                <div>
                  <label className={fieldLabel}>
                    Common Area Size (sqft)
                  </label>
                  <input
                    type="number"
                    className={inputClass}
                    value={c.commonAreaSizeSqft}
                    onChange={(e) =>
                      formik.setFieldValue(
                        "projectTypeDetails.propertySpecificDetails.commercial.commonAreaSizeSqft",
                        e.target.value,
                      )
                    }
                    placeholder="e.g. 80000"
                  />
                </div>
                <div className="sm:col-span-2">
                  <label className={fieldLabel}>Parking Ratio</label>
                  <input
                    type="text"
                    className={inputClass}
                    value={c.parkingRatio}
                    onChange={(e) =>
                      formik.setFieldValue(
                        "projectTypeDetails.propertySpecificDetails.commercial.parkingRatio",
                        e.target.value,
                      )
                    }
                    placeholder="e.g. 1:1000"
                  />
                  <p className="text-xs text-[#5A6F84] mt-1.5">
                    Format: spaces-to-sqft (e.g. 1:1000 means 1 parking space per 1,000 sqft).
                  </p>
                </div>
              </div>
            </div>

            {/* Towers */}
            <div className="border border-[#374B5E] rounded-lg p-4">
              <div className="flex items-center justify-between mb-4">
                <h3 className={sectionLabel + " mb-0"}>
                  Towers ({(c.towers || []).length})
                </h3>
                <button
                  type="button"
                  onClick={handleAddCommercialTower}
                  className="px-3 py-1.5 bg-[#008564] text-white text-xs font-medium rounded-lg hover:bg-[#006e52]"
                >
                  + Add Tower
                </button>
              </div>
              {(!c.towers || c.towers.length === 0) ? (
                <div className="py-8 text-center text-sm text-[#889DB2] border border-dashed border-[#374B5E] rounded-lg">
                  No towers added yet. Click <span className="text-white">+ Add Tower</span> to add one.
                </div>
              ) : (
                <div className="space-y-3">
                  {c.towers.map((tower: any, index: number) => (
                    <div
                      key={tower.id || index}
                      className="grid grid-cols-1 sm:grid-cols-[1.5fr_1fr_1fr_auto] gap-3 items-end p-3 bg-[#1D3440] rounded-lg"
                    >
                      <div>
                        <label className={fieldLabel}>Tower Name *</label>
                        <input
                          type="text"
                          className={inputClass}
                          value={tower.name}
                          onChange={(e) =>
                            handleCommercialTowerChange(index, "name", e.target.value)
                          }
                          placeholder="e.g. Tower A"
                        />
                      </div>
                      <div>
                        <label className={fieldLabel}>Floors *</label>
                        <input
                          type="number"
                          className={inputClass}
                          value={tower.numberOfFloors}
                          onChange={(e) =>
                            handleCommercialTowerChange(
                              index,
                              "numberOfFloors",
                              e.target.value,
                            )
                          }
                          placeholder="e.g. 30"
                        />
                      </div>
                      <div>
                        <label className={fieldLabel}>Floor Plate (sqft) *</label>
                        <input
                          type="number"
                          className={inputClass}
                          value={tower.floorPlateSqft}
                          onChange={(e) =>
                            handleCommercialTowerChange(
                              index,
                              "floorPlateSqft",
                              e.target.value,
                            )
                          }
                          placeholder="e.g. 50000"
                        />
                      </div>
                      <button
                        type="button"
                        onClick={() => handleRemoveCommercialTower(index)}
                        title="Remove tower"
                        className="h-10 px-3 text-[#889DB2] hover:text-red-400 text-sm"
                      >
                        ×
                      </button>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        );
      }

      default:
        return (
          <div className="text-center py-6 md:py-8">
            <p className="text-gray-500 text-sm md:text-base">
              Select a property type to see details
            </p>
          </div>
        );
    }
  };

  const handleDeleteProject = (projectId: string) => {
    if (window.confirm("Are you sure you want to delete this project?")) {
      const updatedProjects = projects.filter(
        (project) => project.id !== projectId,
      );
      setProjects(updatedProjects);
    }
  };

  const getFieldError = (fieldName: string) => {
    return formErrors[fieldName];
  };

  return (
    <div className="font-inter min-h-screen bg-gradient-to-b from-[#1C2C3A] to-[#1E4F52] p-3 sm:p-4 md:p-6">
      {/* Breadcrumb */}
      <div className="flex items-center gap-1.5 text-sm mb-4 px-1">
        <button
          onClick={() => navigate("/project_list")}
          className="text-[#889DB2] hover:text-white transition-colors"
        >
          My Projects
        </button>
        <span className="text-[#889DB2]">/</span>
        <span className="text-white font-medium">
          {isEditMode ? "Edit Project" : "Add New Project"}
        </span>
      </div>

      {/* ── Fresh or clone ───────────────────────────────────────────────
          Asked BEFORE the form, and only of a super admin creating a
          project. A clone rewrites forty fields the moment it is chosen, so
          it cannot be an afterthought halfway down the page — by then the
          super admin has typed things this would overwrite. */}
      {!isEditMode && isSuperAdmin && (
        <div className="mb-5 rounded-lg border border-[#3A5163] bg-[#243645] p-4">
          <div className="flex flex-wrap items-center gap-3">
            <span className="text-sm text-[#C7D6DD]">Start from</span>
            <button
              type="button"
              onClick={() => { setStartMode("fresh"); setCloneSourceId(""); }}
              className={`px-4 py-1.5 rounded-md text-sm transition-colors ${
                startMode !== "clone"
                  ? "bg-[#008564] text-white"
                  : "text-white hover:bg-[#1C2C3A] cursor-pointer border border-[#3A5163]"
              }`}
            >
              A blank project
            </button>
            <button
              type="button"
              onClick={() => setStartMode("clone")}
              className={`px-4 py-1.5 rounded-md text-sm transition-colors ${
                startMode === "clone"
                  ? "bg-[#008564] text-white"
                  : "text-white hover:bg-[#1C2C3A] cursor-pointer border border-[#3A5163]"
              }`}
            >
              A copy of an existing project
            </button>
          </div>

          {startMode === "clone" && (
            <div className="mt-4 flex flex-wrap gap-3">
              <select
                value={cloneAgencyId}
                onChange={(e) => { setCloneAgencyId(e.target.value); setCloneSourceId(""); }}
                className="min-w-[220px] rounded-md bg-[#1C2C3A] border border-[#3A5163] text-white text-sm px-3 py-2"
              >
                <option value="">Copy from which agency…</option>
                {cloneAgencies.map((a: any) => (
                  <option key={a._id || a.id} value={a._id || a.id}>
                    {a.name || a.agency_name || a._id}
                  </option>
                ))}
              </select>

              <select
                value={cloneSourceId}
                onChange={(e) => setCloneSourceId(e.target.value)}
                disabled={!cloneAgencyId}
                className="min-w-[260px] rounded-md bg-[#1C2C3A] border border-[#3A5163] text-white text-sm px-3 py-2 disabled:opacity-50"
              >
                <option value="">
                  {cloneAgencyId
                    ? cloneProjects.length ? "Which project…" : "No projects in this agency"
                    : "Pick an agency first"}
                </option>
                {cloneProjects.map((p: any) => (
                  <option key={p._id || p.id} value={p._id || p.id}>
                    {p.project_name || p.name || p._id}
                  </option>
                ))}
              </select>

              {cloneAgencyId && cloneProjectTotal > cloneProjects.length && (
                <span className="self-center text-xs text-[#E3B341]">
                  Showing the {cloneProjects.length} most recent of {cloneProjectTotal}.
                </span>
              )}
              {cloneLoading && (
                <span className="self-center text-sm text-[#889DB2]">Copying…</span>
              )}
              {!cloneLoading && cloneSourceId && (
                <span className="self-center text-sm text-[#4ADE80]">
                  Copied. {cloneAssetCount.mm} meta model{cloneAssetCount.mm === 1 ? "" : "s"} and{" "}
                  {cloneAssetCount.mp} digital twin{cloneAssetCount.mp === 1 ? "" : "s"} came with it.
                </span>
              )}
            </div>
          )}

          {startMode === "clone" && cloneSourceId && (
            <p className="mt-3 text-xs text-[#889DB2] leading-relaxed">
              Everything is editable before you save. Only the <b>slug</b> is
              left blank — it is this project&apos;s own address and two can&apos;t
              share one. Choose the new project&apos;s agency below as usual; the
              copied experiences point at the same hosted URLs and Matterport
              ids.
            </p>
          )}
        </div>
      )}

      <div className="flex flex-col gap-6 w-full mx-auto">
        {/* Tab Bar */}
        <div className="flex items-center justify-center">
          <div className="flex flex-wrap gap-1 bg-[#2E4051] px-4 py-2 rounded-lg">
            {(["details", "type", "gallery", "amenities", "meta_assets"] as const).map((tab) => (
              <button
                key={tab}
                onClick={() => setActiveTab(tab)}
                className={`px-4 py-2 text-xs sm:text-sm rounded-md transition-colors ${
                  activeTab === tab
                    ? "bg-[#008564] text-white"
                    : "text-white hover:bg-[#1C2C3A] cursor-pointer"
                }`}
              >
                {tab === "details" ? "Project Details"
                  : tab === "gallery" ? "Project Gallery"
                  : tab === "type" ? "Project Type"
                  : tab === "amenities" ? "Amenities"
                  : (
                    <span className="inline-flex items-center gap-1.5">
                      Project Meta Assets
                      {!isEditMode && isSuperAdmin && (
                        <span
                          title="Save the project first to unlock meta assets"
                          aria-label="Locked until the project is saved"
                          className="text-[#889DB2]"
                        >
                          🔒
                        </span>
                      )}
                    </span>
                  )}
              </button>
            ))}
          </div>
        </div>

        <form onSubmit={formik.handleSubmit}>
          {/* Project Details Tab */}
          {activeTab === "details" && (
            <div className=" p-4 sm:p-6 rounded-lg">
              <div className="flex flex-col gap-3 space-y-4 sm:space-y-6">
                <CardBorder
                  title="Basic Details"
                  borderColor="border-[#FFFFFF]"
                  bgColor="bg-[#1D3440]"
                >
                  <div className="flex w-full gap-4">
                    {/* Project Logo */}
                    <div className="flex flex-col px-10 max-md:w-1/3 max-xl:w-1/3 items-center ">
                      <div className="flex space-x-4">
                        <span
                          className={`p-2 text-lg font-medium text-[#889DB2]`}
                        >
                          Project's Logo
                        </span>
                      </div>
                      {/* <LogoUploadWithCrop
                        value={formik.values.projectDetails.clientLogo}
                        onChange={(url: any) =>
                          formik.setFieldValue("projectDetails.clientLogo", url)
                        }
                        onUpload={async (file) => {
                          const uploadFormData = new FormData();
                          uploadFormData.append("gc_upload_request", file);

                          const res = await axios.post(
                            `${process.env.REACT_APP_ONEVERSE_REALESTATE_SERVER_URL}/api/v1/realestate/actions/realestate/gc_upload`,
                            uploadFormData,
                            {
                              headers: {
                                Authorization: `Bearer ${UserService.getToken()}`,
                                "ngrok-skip-browser-warning": "disabled",
                                "Content-Type": "multipart/form-data",
                              },
                            },
                          );

                          return res.data.uploaded_url;
                        }}
                        maxWidth={400}
                        maxHeight={400}
                        isUploading={isUploadingLogo}
                        builderName={
                          formik.values.projectDetails.builder.builderName
                        }
                      /> */}

                      <div className="relative mb-3">
                        {!formik.values.projectDetails.clientLogo ? (
                          formik.values.projectDetails.builder?.builderName &&
                          formik.values.projectDetails.builder?.builderName
                            .length >= 2 ? (
                            <div className="w-28 h-28 md:w-32 md:h-32 rounded-full flex items-center justify-center bg-[#2E4051] text-[#889DB2] text-3xl md:text-4xl font-bold border-4 border-[#889DB2] shadow-md">
                              {`${formik.values.projectDetails.builder?.builderName[0]?.toUpperCase()}${formik.values.projectDetails.builder?.builderName[1]?.toUpperCase()}`}
                            </div>
                          ) : (
                            <div className="w-28 h-28 md:w-32 md:h-32 rounded-full flex items-center justify-center bg-[#2E4051] text-[#889DB2] border-4 border-[#889DB2] shadow-md">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-12 w-12"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth={2}
                                  d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
                                />
                              </svg>
                            </div>
                          )
                        ) : (
                          <div className="w-28 h-28 md:w-32 md:h-32 rounded-full overflow-hidden border-4 border-[#889DB2] shadow-md">
                            <img
                              src={formik.values.projectDetails.clientLogo}
                              alt="Client Logo"
                              className="w-full h-full object-cover"
                            />
                          </div>
                        )}
                      </div>

                      <input
                        type="file"
                        accept="image/*"
                        ref={logoInputRef}
                        style={{ display: "none" }}
                        onChange={handleLogoUpload}
                      />

                      <div className="flex space-x-4">
                        <button
                          type="button"
                          onClick={() => logoInputRef.current?.click()}
                          disabled={isUploadingLogo}
                          className="bg-[#008564] text-white p-3 rounded-lg hover:bg-[#008564] hover:opacity-70 transition-colors disabled:opacity-50"
                          title="Upload New Image"
                        >
                          {isUploadingLogo ? (
                            <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                          ) : (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className="h-5 w-5"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
                              />
                            </svg>
                          )}
                        </button>

                        <button
                          type="button"
                          onClick={() => {
                            formik.setFieldValue(
                              "projectDetails.clientLogo",
                              "",
                            );
                            if (logoInputRef.current) {
                              logoInputRef.current.value = "";
                            }
                          }}
                          disabled={
                            isUploadingLogo ||
                            !formik.values.projectDetails.clientLogo
                          }
                          className="bg-[#2E4051] text-white p-3 rounded-lg hover:bg-[#008564] hover:opacity-70 transition-colors disabled:opacity-50"
                          title="Delete Photo"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-5 w-5"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                            />
                          </svg>
                        </button>
                      </div>
                    </div>

                    <div className="flex-1 gap-2">
                      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-6">
                        {/* Builder Name */}
                        <div>
                          <label className="block text-lg font-medium text-[#889DB2] mb-2">
                            Builder Name
                          </label>
                          <input
                            type="text"
                            name="projectDetails.builder.builderName"
                            className={`w-full px-3 py-2 text-[#F4F5F7] rounded-lg shadow-md bg-[#2E4051] border-none focus:border-[#008564] focus:outline-none focus:ring-2 focus:ring-[#008564] transition-colors ${
                              getFieldError("matterportId")
                                ? "border-red-500 bg-[#2E4051]"
                                : ""
                            }`}
                            value={
                              // formik.values.projectDetails.builder.builderName
                              agencyName
                            }
                            // onChange={(e) => {
                            //   formik.handleChange(e);
                            //   if (getFieldError("builder.builderName")) {
                            //     const newErrors = { ...formErrors };
                            //     delete newErrors["builder.builderName"];
                            //     setFormErrors(newErrors);
                            //   }
                            // }}
                            onBlur={formik.handleBlur}
                            placeholder="Enter Name..."
                            readOnly
                          />
                          {getFieldError("builder.builderName") && (
                            <p className="text-red-500 text-xs sm:text-sm mt-1">
                              {getFieldError("builder.builderName")}
                            </p>
                          )}
                        </div>

                        {/* Project Name */}
                        <div>
                          <label className="block text-lg font-medium text-[#889DB2] mb-2">
                            Project Name
                          </label>
                          <div className="relative">
                            <input
                              type="text"
                              name="projectDetails.builder.projectName"
                              className={`w-full px-3 py-2 text-[#F4F5F7] rounded-lg shadow-md bg-[#2E4051] border-none focus:border-[#008564] focus:outline-none focus:ring-2 focus:ring-[#008564] transition-colors ${
                                getFieldError("builder.projectName") ||
                                projectNameError
                                  ? "border-red-500 bg-[#2E4051]"
                                  : ""
                              }`}
                              value={
                                formik.values.projectDetails.builder.projectName
                              }
                              onChange={(e) => {
                                formik.handleChange(e);

                                // Clear existing error
                                if (getFieldError("builder.projectName")) {
                                  const newErrors = { ...formErrors };
                                  delete newErrors["builder.projectName"];
                                  setFormErrors(newErrors);
                                }

                                // Clear project name error
                                setProjectNameError("");

                                // Debounced duplicate check
                                if (projectNameCheckTimeout.current) {
                                  clearTimeout(projectNameCheckTimeout.current);
                                }

                                projectNameCheckTimeout.current = setTimeout(
                                  () => {
                                    checkProjectName(e.target.value);
                                  },
                                  800,
                                );
                              }}
                              onBlur={formik.handleBlur}
                              placeholder="Enter Name..."
                            />
                            {checkingProjectName && (
                              <div className="absolute right-3 top-3">
                                <svg
                                  className="animate-spin h-5 w-5 text-[#008564]"
                                  xmlns="http://www.w3.org/2000/svg"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                >
                                  <circle
                                    className="opacity-25"
                                    cx="12"
                                    cy="12"
                                    r="10"
                                    stroke="currentColor"
                                    strokeWidth="4"
                                  ></circle>
                                  <path
                                    className="opacity-75"
                                    fill="currentColor"
                                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                  ></path>
                                </svg>
                              </div>
                            )}
                          </div>
                          {(getFieldError("builder.projectName") ||
                            projectNameError) && (
                            <p className="text-red-500 text-xs sm:text-sm mt-1">
                              {projectNameError ||
                                getFieldError("builder.projectName")}
                            </p>
                          )}
                          {/* Same confirmation the slug field gives, so the
                              two read as one pair rather than one field that
                              answers and one that stays quiet. */}
                          {!projectNameError &&
                            !getFieldError("builder.projectName") &&
                            formik.values.projectDetails.builder.projectName && (
                              <p className="text-[#4ADE80] text-xs sm:text-sm mt-1">
                                Available
                              </p>
                            )}
                        </div>

                        {/* Slug */}
                        <div>
                          <label className="block text-lg font-medium text-[#889DB2] mb-2">
                            Slug
                          </label>
                          <input
                            type="text"
                            name="projectDetails.slug"
                            onChange={(e) => {
                              formik.handleChange(e);
                              const v = e.target.value.trim().toLowerCase();
                              setSlugError(
                                v && takenSlugs.has(v)
                                  ? "This slug is already used by another project in this agency"
                                  : "",
                              );
                            }}
                            className="w-full px-3 py-2 text-[#F4F5F7] rounded-lg shadow-md bg-[#2E4051] border-none focus:border-[#008564] focus:outline-none focus:ring-2 focus:ring-[#008564] transition-colors"
                            value={formik.values.projectDetails.slug}
                            onBlur={formik.handleBlur}
                            placeholder="e.g. phoenix-residences"
                          />
                          {/* Answered in the field. Slug uniqueness is enforced
                              per agency on save; before this it was only
                              discoverable by being rejected. */}
                          {slugError ? (
                            <p className="mt-2 text-xs text-[#FF6B6B]">{slugError}</p>
                          ) : cloneSourceId && !formik.values.projectDetails.slug ? (
                            /* A super admin who has just watched forty fields
                               fill themselves in will reasonably assume this
                               one did too. */
                            <p className="mt-2 text-xs text-[#E3B341]">
                              Not copied — a slug is the project&apos;s address and two
                              projects can&apos;t share one. Give this project its own.
                            </p>
                          ) : formik.values.projectDetails.slug ? (
                            <p className="mt-2 text-xs text-[#4ADE80]">Available</p>
                          ) : null}
                        </div>
                      </div>

                      {/* Project Description */}
                      <div className="mt-8 pt-6 border-t border-[#374B5E]/60">
                        <div className="flex items-center justify-between mb-5 gap-4 flex-wrap">
                          <h3 className="text-xl font-semibold text-white">
                            Description
                          </h3>
                          <div className="flex items-center gap-2">
                            {aiMode === "reframe" && (
                              <button
                                type="button"
                                onClick={handleClearDescription}
                                disabled={aiLoading}
                                title="Clear all four description fields"
                                className="inline-flex items-center gap-1.5 px-3 py-2 rounded-lg text-sm font-medium text-[#889DB2] hover:text-white hover:bg-[#374B5E]/40 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                              >
                                <span aria-hidden="true">✕</span>
                                Clear
                              </button>
                            )}
                          <button
                            type="button"
                            onClick={() => {
                              setAiError(null);
                              setAiPanelOpen((v) => !v);
                            }}
                            disabled={!aiConfigured || aiLoading}
                            title={
                              aiConfigured
                                ? aiMode === "reframe"
                                  ? "Reframe the existing description with AI"
                                  : "Generate a description with AI"
                                : "AI not configured — set REACT_APP_ANTHROPIC_API_KEY at build time"
                            }
                            className={`inline-flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                              !aiConfigured
                                ? "bg-[#2E4051]/60 text-[#889DB2] cursor-not-allowed"
                                : "bg-gradient-to-r from-[#008564] to-[#00a07a] text-white hover:from-[#00a07a] hover:to-[#008564]"
                            }`}
                          >
                            <span aria-hidden="true">✨</span>
                            {aiConfigured
                              ? aiMode === "reframe"
                                ? "Reframe with AI"
                                : "Generate with AI"
                              : "AI not configured"}
                          </button>
                          </div>
                        </div>

                        {aiPanelOpen && aiConfigured && (
                          <div className="mb-6 p-4 rounded-lg bg-[#1F2E3D]/80 border border-[#374B5E]">
                            <label className="block text-sm font-medium text-[#889DB2] mb-2">
                              Additional emphasis (optional)
                            </label>
                            <textarea
                              value={aiHint}
                              onChange={(e) => setAiHint(e.target.value)}
                              rows={2}
                              placeholder={
                                aiMode === "reframe"
                                  ? "e.g. make the tone more aspirational, emphasize sustainability"
                                  : "e.g. luxury, lake-facing, family-friendly"
                              }
                              className="w-full px-3 py-2 text-[#F4F5F7] rounded-lg bg-[#2E4051] border-none focus:outline-none focus:ring-2 focus:ring-[#008564] text-sm"
                              disabled={aiLoading}
                            />
                            <p className="text-xs text-[#889DB2] mt-2">
                              The AI uses the project name, builder, location,
                              type, area and selected amenities as context.
                              {aiMode === "reframe" &&
                                " Existing description will be rewritten."}
                            </p>
                            <div className="flex items-center gap-3 mt-3">
                              <button
                                type="button"
                                onClick={handleAiGenerate}
                                disabled={aiLoading}
                                className="inline-flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium bg-[#008564] text-white hover:bg-[#00a07a] disabled:opacity-60 disabled:cursor-not-allowed transition-colors"
                              >
                                {aiLoading ? (
                                  <>
                                    <span
                                      className="inline-block w-3 h-3 border-2 border-white/40 border-t-white rounded-full animate-spin"
                                      aria-hidden="true"
                                    />
                                    Generating…
                                  </>
                                ) : (
                                  <>
                                    <span aria-hidden="true">✨</span>
                                    {aiMode === "reframe"
                                      ? "Reframe now"
                                      : "Generate now"}
                                  </>
                                )}
                              </button>
                              <button
                                type="button"
                                onClick={() => {
                                  setAiPanelOpen(false);
                                  setAiError(null);
                                }}
                                disabled={aiLoading}
                                className="text-sm text-[#889DB2] hover:text-white transition-colors"
                              >
                                Cancel
                              </button>
                            </div>
                            {aiError && (
                              <p className="text-red-400 text-xs mt-3">
                                {aiError}
                              </p>
                            )}
                          </div>
                        )}

                        <div className="flex flex-col gap-6">
                        <div>
                          <label className="block text-lg font-medium text-[#889DB2] mb-2">
                            Headline
                          </label>
                          <input
                            type="text"
                            name="projectDetails.projectDescription.headline"
                            className="block w-full px-3 py-2 text-[#F4F5F7] rounded-lg shadow-md border-none bg-[#2E4051] focus:border-[#008564] focus:outline-none focus:ring-2 focus:ring-[#008564] transition-colors"
                            value={
                              formik.values.projectDetails.projectDescription
                                .headline
                            }
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            placeholder="e.g. A vertical forest above Powai Lake"
                          />
                          <p className="text-xs text-[#889DB2] mt-2 italic">
                            The main hook — one strong line capturing the
                            project's essence.
                          </p>
                        </div>

                        <div>
                          <label className="block text-lg font-medium text-[#889DB2] mb-2">
                            Lede
                          </label>
                          <textarea
                            name="projectDetails.projectDescription.lede"
                            className="block w-full px-3 py-2 text-[#F4F5F7] rounded-lg shadow-md border-none bg-[#2E4051] focus:border-[#008564] focus:outline-none focus:ring-2 focus:ring-[#008564] transition-colors"
                            value={
                              formik.values.projectDetails.projectDescription
                                .lede
                            }
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            rows={2}
                            placeholder="e.g. Skyforest is a 38-acre residential development on the eastern edge of Powai Lake..."
                          />
                          <p className="text-xs text-[#889DB2] mt-2 italic">
                            The opening summary — key facts up front: location,
                            scale, signature features.
                          </p>
                        </div>

                        <div>
                          <label className="block text-lg font-medium text-[#889DB2] mb-2">
                            Body
                          </label>
                          <textarea
                            name="projectDetails.projectDescription.body"
                            className={`w-full px-3 py-2 text-[#F4F5F7] rounded-lg shadow-md border-none bg-[#2E4051] focus:border-[#008564] focus:outline-none focus:ring-2 focus:ring-[#008564] transition-colors ${
                              getFieldError("projectDescription")
                                ? "border border-red-500"
                                : ""
                            }`}
                            value={
                              formik.values.projectDetails.projectDescription
                                .body
                            }
                            onChange={(e) => {
                              formik.handleChange(e);
                              if (getFieldError("projectDescription")) {
                                const newErrors = { ...formErrors };
                                delete newErrors.projectDescription;
                                setFormErrors(newErrors);
                              }
                            }}
                            onBlur={formik.handleBlur}
                            rows={6}
                            placeholder="Main paragraphs describing design, lifestyle, sustainability, timeline..."
                          />
                          <p className="text-xs text-[#889DB2] mt-2 italic">
                            Main paragraphs — separate paragraphs with a blank
                            line. Required.
                          </p>
                          {getFieldError("projectDescription") && (
                            <p className="text-red-500 text-xs sm:text-sm mt-1">
                              {getFieldError("projectDescription")}
                            </p>
                          )}
                        </div>

                        <div>
                          <label className="block text-lg font-medium text-[#889DB2] mb-2">
                            Pull Quote
                          </label>
                          <textarea
                            name="projectDetails.projectDescription.quote"
                            className="block w-full px-3 py-2 text-[#F4F5F7] rounded-lg shadow-md border-none bg-[#2E4051] focus:border-[#008564] focus:outline-none focus:ring-2 focus:ring-[#008564] transition-colors"
                            value={
                              formik.values.projectDetails.projectDescription
                                .quote
                            }
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            rows={2}
                            placeholder={`e.g. "We didn't want a building with trees on the balconies..."`}
                          />
                          <p className="text-xs text-[#889DB2] mt-2 italic">
                            Optional — a memorable line that breaks the visual
                            rhythm. Leave empty to omit.
                          </p>
                        </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </CardBorder>

                {/* this is extra div, will remove it later */}
                <div className="hidden">
                  <div className="hidden grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
                    <div>
                      <label className="block text-lg font-medium text-[#889DB2] mb-2">
                        Project Delivery
                      </label>
                      <input
                        type="text"
                        name="projectDetails.projectDelivery"
                        className={`w-full px-3 py-2 rounded-lg shadow-md border-none text-sm sm:text-base ${
                          getFieldError("projectDelivery")
                            ? "border-red-500"
                            : ""
                        }`}
                        value={formik.values.projectDetails.projectDelivery}
                        onChange={(e) => {
                          formik.handleChange(e);
                          if (getFieldError("projectDelivery")) {
                            const newErrors = { ...formErrors };
                            delete newErrors.projectDelivery;
                            setFormErrors(newErrors);
                          }
                        }}
                        onBlur={formik.handleBlur}
                        placeholder="Enter project delivery"
                      />
                      {getFieldError("projectDelivery") && (
                        <p className="text-red-500 text-xs sm:text-sm mt-1">
                          {getFieldError("projectDelivery")}
                        </p>
                      )}
                    </div>
                    <div>
                      <label className="block text-lg font-medium text-[#889DB2] mb-2">
                        Project Type
                      </label>
                      <input
                        type="text"
                        name="projectDetails.projectType"
                        className={`w-full px-3 py-2 rounded-lg shadow-md border-none text-sm sm:text-base ${
                          getFieldError("projectType") ? "border-red-500" : ""
                        }`}
                        value={formik.values.projectDetails.projectType}
                        onChange={(e) => {
                          formik.handleChange(e);
                          if (getFieldError("projectType")) {
                            const newErrors = { ...formErrors };
                            delete newErrors.projectType;
                            setFormErrors(newErrors);
                          }
                        }}
                        onBlur={formik.handleBlur}
                        placeholder="Enter project type"
                      />
                      {getFieldError("projectType") && (
                        <p className="text-red-500 text-xs sm:text-sm mt-1">
                          {getFieldError("projectType")}
                        </p>
                      )}
                    </div>
                  </div>
                  {/* logo */}
                  <div className="hidden grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
                    <div>
                      <label className="block text-lg font-medium text-[#889DB2] mb-2">
                        Client's Logo
                      </label>
                      <div className="border rounded px-3 py-2">
                        <input
                          type="file"
                          accept="image/*"
                          className="w-full text-xs sm:text-sm"
                          onChange={(e) => {
                            const file = e.target.files?.[0];
                            if (file) {
                              formik.setFieldValue(
                                "projectDetails.clientLogo",
                                URL.createObjectURL(file),
                              );
                            }
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  {/* Basic Detail */}
                  <div>
                    <label className="block text-lg font-medium text-[#889DB2] mb-2">
                      Basic Details*
                    </label>
                    <textarea
                      name="projectDetails.basicDetails"
                      className={`w-full px-3 py-2 rounded-lg shadow-md border-none text-sm sm:text-base ${
                        getFieldError("basicDetails") ? "border-red-500" : ""
                      }`}
                      value={formik.values.projectDetails.basicDetails}
                      onChange={(e) => {
                        formik.handleChange(e);
                        if (getFieldError("basicDetails")) {
                          const newErrors = { ...formErrors };
                          delete newErrors.basicDetails;
                          setFormErrors(newErrors);
                        }
                      }}
                      onBlur={formik.handleBlur}
                      rows={2}
                      placeholder="Enter basic details"
                    />
                    {getFieldError("basicDetails") && (
                      <p className="text-red-500 text-xs sm:text-sm mt-1">
                        {getFieldError("basicDetails")}
                      </p>
                    )}
                  </div>
                </div>

                <CardBorder
                  title="Project Location"
                  borderColor="border-[#FFFFFF]"
                  bgColor="bg-[#1D3943]"
                >
                  <div className="flex-1 w-full pt-4 sm:pt-6">
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
                      <div>
                        <label className="block text-lg font-medium text-[#889DB2] mb-2">
                          Address Line 1
                        </label>
                        <input
                          type="text"
                          name="projectDetails.location.addressLine1"
                          className={`w-full px-3 py-2 text-[#F4F5F7] rounded-lg shadow-md border-none bg-[#2E4051] focus:border-[#008564] focus:outline-none focus:ring-2 focus:ring-[#008564] transition-colors ${
                            getFieldError("location.addressLine1")
                              ? "border-red-500 bg-[#2E4051]"
                              : ""
                          }`}
                          value={
                            formik.values.projectDetails.location.addressLine1
                          }
                          onChange={(e) => {
                            formik.handleChange(e);
                            if (getFieldError("location.addressLine1")) {
                              const newErrors = { ...formErrors };
                              delete newErrors["location.addressLine1"];
                              setFormErrors(newErrors);
                            }
                          }}
                          onBlur={formik.handleBlur}
                          placeholder="Enter..."
                        />
                        {getFieldError("location.addressLine1") && (
                          <p className="text-red-500 text-xs sm:text-sm mt-1">
                            {getFieldError("location.addressLine1")}
                          </p>
                        )}
                      </div>
                      <div>
                        <label className="block text-lg font-medium text-[#889DB2] mb-2">
                          Address Line 2
                        </label>
                        <input
                          type="text"
                          name="projectDetails.location.addressLine2"
                          className={`w-full px-3 py-2 text-[#F4F5F7] rounded-lg shadow-md border-none bg-[#2E4051] focus:border-[#008564] focus:outline-none focus:ring-2 focus:ring-[#008564] transition-colors `}
                          value={
                            formik.values.projectDetails.location.addressLine2
                          }
                          onChange={formik.handleChange}
                          placeholder="Enter..."
                        />
                      </div>
                      <div>
                        <label className="block text-lg font-medium text-[#889DB2] mb-2">
                          City
                        </label>
                        <input
                          type="text"
                          name="projectDetails.location.city"
                          className={`w-full px-3 py-2 text-[#F4F5F7] rounded-lg shadow-md border-none bg-[#2E4051] focus:border-[#008564] focus:outline-none focus:ring-2 focus:ring-[#008564] transition-colors ${
                            getFieldError("location.city")
                              ? "border-red-500 bg-[#2E4051]"
                              : ""
                          }`}
                          value={formik.values.projectDetails.location.city}
                          onChange={(e) => {
                            formik.handleChange(e);
                            if (getFieldError("location.city")) {
                              const newErrors = { ...formErrors };
                              delete newErrors["location.city"];
                              setFormErrors(newErrors);
                            }
                          }}
                          onBlur={formik.handleBlur}
                          placeholder="Enter..."
                        />
                        <p className="text-xs text-[#889DB2] mt-1">
                          Displayed next to the project name on the project details page.
                        </p>
                        {getFieldError("location.city") && (
                          <p className="text-red-500 text-xs sm:text-sm mt-1">
                            {getFieldError("location.city")}
                          </p>
                        )}
                      </div>
                      <div>
                        <label className="block text-lg font-medium text-[#889DB2] mb-2">
                          Pincode
                        </label>
                        <input
                          type="number"
                          maxLength={6}
                          onInput={(e: any) => {
                            if (e.target.value.length > 6) {
                              e.target.value = e.target.value.slice(0, 6);
                            }
                          }}
                          name="projectDetails.location.pincode"
                          className={`w-full px-3 py-2 text-[#F4F5F7] rounded-lg shadow-md border-none bg-[#2E4051] focus:border-[#008564] focus:outline-none focus:ring-2 focus:ring-[#008564] transition-colors ${
                            getFieldError("location.pincode")
                              ? "border-red-500 bg-[#2E4051]"
                              : ""
                          }`}
                          value={formik.values.projectDetails.location.pincode}
                          onChange={(e) => {
                            formik.handleChange(e);
                            if (getFieldError("location.pincode")) {
                              const newErrors = { ...formErrors };
                              delete newErrors["location.pincode"];
                              setFormErrors(newErrors);
                            }
                          }}
                          onBlur={formik.handleBlur}
                          placeholder="Enter..."
                        />
                        {getFieldError("location.pincode") && (
                          <p className="text-red-500 text-xs sm:text-sm mt-1">
                            {getFieldError("location.pincode")}
                          </p>
                        )}
                      </div>
                      <div>
                        <label className="block text-lg font-medium text-[#889DB2] mb-2">
                          Landmark
                        </label>
                        <input
                          type="text"
                          name="projectDetails.location.landmark"
                          className={`w-full px-3 py-2 text-[#F4F5F7] rounded-lg shadow-md border-none bg-[#2E4051] focus:border-[#008564] focus:outline-none focus:ring-2 focus:ring-[#008564] transition-colors `}
                          value={formik.values.projectDetails.location.landmark}
                          onChange={formik.handleChange}
                          placeholder="Enter..."
                        />
                        <p className="text-xs text-[#889DB2] mt-1">
                          Displayed next to the project name on the project details page.
                        </p>
                      </div>
                      <div>
                        <label className="block text-lg font-medium text-[#889DB2] mb-2">
                          State
                        </label>
                        <input
                          type="text"
                          name="projectDetails.location.state"
                          className={`w-full px-3 py-2 text-[#F4F5F7] rounded-lg shadow-md border-none bg-[#2E4051] focus:border-[#008564] focus:outline-none focus:ring-2 focus:ring-[#008564] transition-colors ${
                            getFieldError("location.state")
                              ? "border-red-500 bg-[#2E4051]"
                              : ""
                          }`}
                          value={formik.values.projectDetails.location.state}
                          onChange={(e) => {
                            formik.handleChange(e);
                            if (getFieldError("location.state")) {
                              const newErrors = { ...formErrors };
                              delete newErrors["location.state"];
                              setFormErrors(newErrors);
                            }
                          }}
                          onBlur={formik.handleBlur}
                          placeholder="Enter..."
                        />
                        {getFieldError("location.state") && (
                          <p className="text-red-500 text-xs sm:text-sm mt-1">
                            {getFieldError("location.state")}
                          </p>
                        )}
                      </div>
                      <div>
                        <label className="block text-lg font-medium text-[#889DB2] mb-2">
                          Country
                        </label>
                        <input
                          type="text"
                          name="projectDetails.location.country"
                          className={`w-full px-3 py-2 text-[#F4F5F7] rounded-lg shadow-md border-none bg-[#2E4051] focus:border-[#008564] focus:outline-none focus:ring-2 focus:ring-[#008564] transition-colors ${
                            getFieldError("location.country")
                              ? "border-red-500 bg-[#2E4051]"
                              : ""
                          }`}
                          value={formik.values.projectDetails.location.country}
                          onChange={(e) => {
                            formik.handleChange(e);
                            if (getFieldError("location.country")) {
                              const newErrors = { ...formErrors };
                              delete newErrors["location.country"];
                              setFormErrors(newErrors);
                            }
                          }}
                          onBlur={formik.handleBlur}
                          placeholder="Enter..."
                        />
                        {getFieldError("location.country") && (
                          <p className="text-red-500 text-xs sm:text-sm mt-1">
                            {getFieldError("location.country")}
                          </p>
                        )}
                      </div>
                      <div className="col-span-2">
                        <label className="block text-lg font-medium text-[#889DB2] mb-2">
                          Coordinates
                        </label>
                        <input
                          type="text"
                          className="w-full px-3 py-2 text-[#F4F5F7] rounded-lg shadow-md border-none bg-[#2E4051] focus:border-[#008564] focus:outline-none focus:ring-2 focus:ring-[#008564] transition-colors"
                          value={
                            formik.values.projectDetails.location.latitude && formik.values.projectDetails.location.longitude
                              ? `${formik.values.projectDetails.location.latitude}, ${formik.values.projectDetails.location.longitude}`
                              : formik.values.projectDetails.location.latitude || ""
                          }
                          onChange={(e) => {
                            const parts = e.target.value.split(",").map((s) => s.trim());
                            if (parts.length >= 2) {
                              formik.setFieldValue("projectDetails.location.latitude", parts[0]);
                              formik.setFieldValue("projectDetails.location.longitude", parts[1]);
                            } else {
                              formik.setFieldValue("projectDetails.location.latitude", e.target.value);
                              formik.setFieldValue("projectDetails.location.longitude", "");
                            }
                          }}
                          placeholder="Paste from Google Maps (e.g. 17.4126, 78.2773)"
                        />
                        <p className="text-xs text-[#889DB2] mt-1">Right-click any location on Google Maps → Copy coordinates, then paste here</p>
                      </div>
                    </div>

                    {/* Map Preview */}
                    {formik.values.projectDetails.location.longitude &&
                      formik.values.projectDetails.location.latitude && (
                        <div className="flex flex-col w-full mt-6">
                          <h3 className="text-lg font-medium text-[#889DB2] mb-3">
                            Location Preview
                          </h3>
                          <div className="text-center">
                            <div className="h-[300px] md:h-[340px] lg:h-[460px] overflow-y-auto">
                              <NewMap
                                key={`${formik.values.projectDetails.location.latitude},${formik.values.projectDetails.location.longitude}`}
                                geo_location={[
                                  formik.values.projectDetails.location.latitude,
                                  formik.values.projectDetails.location.longitude,
                                ]}
                              />
                            </div>
                          </div>
                        </div>
                      )}
                  </div>
                </CardBorder>

                <CardBorder
                  title="More Information"
                  borderColor="border-[#FFFFFF]"
                  bgColor="bg-[#1E444A]"
                >
                  <div className="flex-1 w-full  pt-4 sm:pt-6">
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-3 sm:gap-4">
                      <div>
                        <label className="block text-lg font-medium text-[#889DB2] mb-2">
                          Project Size in Acres
                        </label>
                        <input
                          type="number"
                          name="projectDetails.moreInformation.projectSizeInAcres"
                          className={`w-full px-3 py-2 text-[#F4F5F7] rounded-lg shadow-md border-none bg-[#2E4051] focus:border-[#008564] focus:outline-none focus:ring-2 focus:ring-[#008564] transition-colors ${
                            getFieldError("moreInformation.projectSizeInAcres")
                              ? "border-red-500 bg-[#2E4051]"
                              : ""
                          }`}
                          value={
                            formik.values.projectDetails.moreInformation
                              .projectSizeInAcres
                          }
                          onChange={(e) => {
                            formik.handleChange(e);
                            if (
                              getFieldError(
                                "moreInformation.projectSizeInAcres",
                              )
                            ) {
                              const newErrors = { ...formErrors };
                              delete newErrors[
                                "moreInformation.projectSizeInAcres"
                              ];
                              setFormErrors(newErrors);
                            }
                          }}
                          onBlur={formik.handleBlur}
                          placeholder="Enter..."
                        />
                        {getFieldError(
                          "moreInformation.projectSizeInAcres",
                        ) && (
                          <p className="text-red-500 text-xs sm:text-sm mt-1">
                            {getFieldError(
                              "moreInformation.projectSizeInAcres",
                            )}
                          </p>
                        )}
                      </div>
                      <div>
                        <label className="block text-lg font-medium text-[#889DB2] mb-2">
                          Project License Number
                        </label>
                        <input
                          type="text"
                          name="projectDetails.moreInformation.projectLicenseNumber"
                          className={`w-full px-3 py-2 text-[#F4F5F7] rounded-lg shadow-md border-none bg-[#2E4051] focus:border-[#008564] focus:outline-none focus:ring-2 focus:ring-[#008564] transition-colors ${
                            getFieldError("moreInformation.projectLicensNumber")
                              ? "border-red-500 bg-[#2E4051]"
                              : ""
                          }`}
                          value={
                            formik.values.projectDetails.moreInformation
                              .projectLicenseNumber
                          }
                          onChange={(e) => {
                            formik.handleChange(e);
                            if (
                              getFieldError(
                                "moreInformation.projectLicenseNumber",
                              )
                            ) {
                              const newErrors = { ...formErrors };
                              delete newErrors[
                                "moreInformation.projectLicenseNumber"
                              ];
                              setFormErrors(newErrors);
                            }
                          }}
                          onBlur={formik.handleBlur}
                          placeholder="Enter..."
                        />
                        {getFieldError(
                          "moreInformation.projectLicenseNumber",
                        ) && (
                          <p className="text-red-500 text-xs sm:text-sm mt-1">
                            {getFieldError(
                              "moreInformation.projectLicenseNumber",
                            )}
                          </p>
                        )}
                      </div>
                      <div>
                        <label className="block text-lg font-medium text-[#889DB2] mb-2">
                          Project Launch Date
                        </label>
                        <input
                          type="date"
                          name="projectDetails.moreInformation.projectLaunchDate"
                          className={`w-full px-3 py-2 text-[#F4F5F7] rounded-lg shadow-md border-none bg-[#2E4051] focus:border-[#008564] focus:outline-none focus:ring-2 focus:ring-[#008564] transition-colors ${
                            getFieldError("moreInformation.projectLaunchDate")
                              ? "border-red-500 bg-[#2E4051]"
                              : ""
                          }`}
                          value={
                            formik.values.projectDetails.moreInformation
                              .projectLaunchDate
                          }
                          onChange={(e) => {
                            formik.handleChange(e);
                            if (
                              getFieldError("moreInformation.projectLaunchDate")
                            ) {
                              const newErrors = { ...formErrors };
                              delete newErrors[
                                "moreInformation.projectLaunchDate"
                              ];
                              setFormErrors(newErrors);
                            }
                          }}
                          placeholder="Enter..."
                          onBlur={formik.handleBlur}
                        />
                        {getFieldError("moreInformation.projectLaunchDate") && (
                          <p className="text-red-500 text-xs sm:text-sm mt-1">
                            {getFieldError("moreInformation.projectLaunchDate")}
                          </p>
                        )}
                      </div>
                      <div>
                        <label className="block text-lg font-medium text-[#889DB2] mb-2">
                          Project Completion Date
                        </label>
                        <input
                          type="date"
                          name="projectDetails.moreInformation.projectCompletionDate"
                          className={`w-full px-3 py-2 text-[#F4F5F7] rounded-lg shadow-md border-none bg-[#2E4051] focus:border-[#008564] focus:outline-none focus:ring-2 focus:ring-[#008564] transition-colors ${
                            getFieldError(
                              "moreInformation.projectCompletionDate",
                            )
                              ? "border-red-500 bg-[#2E4051]"
                              : ""
                          }`}
                          value={
                            formik.values.projectDetails.moreInformation
                              .projectCompletionDate
                          }
                          onChange={(e) => {
                            formik.handleChange(e);
                            if (
                              getFieldError(
                                "moreInformation.projectCompletionDate",
                              )
                            ) {
                              const newErrors = { ...formErrors };
                              delete newErrors[
                                "moreInformation.projectCompletionDate"
                              ];
                              setFormErrors(newErrors);
                            }
                          }}
                          placeholder="Enter..."
                          onBlur={formik.handleBlur}
                        />
                        {getFieldError(
                          "moreInformation.projectCompletionDate",
                        ) && (
                          <p className="text-red-500 text-xs sm:text-sm mt-1">
                            {getFieldError(
                              "moreInformation.projectCompletionDate",
                            )}
                          </p>
                        )}
                      </div>
                      <div className="sm:col-span-2 lg:col-span-2 w-1/2">
                        <label className="block text-lg font-medium text-[#889DB2] mb-2">
                          Project saleable area sqft
                        </label>
                        <input
                          type="number"
                          name="projectDetails.moreInformation.projectSaleableAreaSqft"
                          className={`w-full px-3 py-2 text-[#F4F5F7] rounded-lg shadow-md border-none bg-[#2E4051] focus:border-[#008564] focus:outline-none focus:ring-2 focus:ring-[#008564] transition-colors ${
                            getFieldError(
                              "moreInformation.projectSaleableAreaSqft",
                            )
                              ? "border-red-500 bg-[#2E4051]"
                              : ""
                          }`}
                          value={
                            formik.values.projectDetails.moreInformation
                              .projectSaleableAreaSqft
                          }
                          onChange={(e) => {
                            formik.handleChange(e);
                            if (
                              getFieldError(
                                "moreInformation.projectSaleableAreaSqft",
                              )
                            ) {
                              const newErrors = { ...formErrors };
                              delete newErrors[
                                "moreInformation.projectSaleableAreaSqft"
                              ];
                              setFormErrors(newErrors);
                            }
                          }}
                          onBlur={formik.handleBlur}
                          placeholder="Area in sqft"
                        />
                        {getFieldError(
                          "moreInformation.projectSaleableAreaSqft",
                        ) && (
                          <p className="text-red-500 text-xs sm:text-sm mt-1">
                            {getFieldError(
                              "moreInformation.projectSaleableAreaSqft",
                            )}
                          </p>
                        )}
                      </div>
                      {isEditMode && canReorderProjects && (
                        <div className="sm:col-span-2 lg:col-span-2 w-1/2">
                          <label className="block text-lg font-medium text-[#889DB2] mb-2">
                            Display Order
                          </label>
                          <input
                            type="number"
                            step="0.01"
                            name="displayOrder"
                            className="w-full px-3 py-2 text-[#F4F5F7] rounded-lg shadow-md border-none bg-[#2E4051] focus:border-[#008564] focus:outline-none focus:ring-2 focus:ring-[#008564] transition-colors"
                            value={displayOrderInput}
                            onChange={(e) =>
                              setDisplayOrderInput(e.target.value)
                            }
                            placeholder="e.g. 1000, 1500, 2000…"
                          />
                          <p className="text-xs text-[#889DB2] mt-1">
                            Lower number = higher in the projects list.
                            Decimals allowed (e.g. 1500.5 inserts between 1000
                            and 2000).
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                </CardBorder>

                {/* {Object.keys(formErrors).length > 0 && (
                  <div className="border border-red-300 bg-red-50 p-3 sm:p-4 rounded">
                    <h4 className="font-medium text-red-700 mb-2 text-sm sm:text-base">
                      Please fix the following errors:
                    </h4>
                    <ul className="list-disc list-inside text-red-600 text-xs sm:text-sm">
                      {Object.entries(formErrors).map(([field, error]) => (
                        <li key={field}>{error}</li>
                      ))}
                    </ul>
                  </div>
                )} */}
              </div>
            </div>
          )}

          {activeTab === "gallery" && (
            <div className="flex flex-col gap-3 space-y-4 sm:space-y-6">
              {/* pdf Upload */}
              <CardBorder
                title="Upload Brochure"
                borderColor="border-[#FFFFFF]"
                bgColor="bg-[#1C323E]"
              >
                {/* Loading Indicator */}
                {isUploadingBrochures && (
                  <div className="flex w-full flex-col items-center justify-center py-8">
                    <div className="w-16 h-16 border-4 border-[#176f59] border-t-transparent rounded-full animate-spin"></div>
                    <p className="text-white mt-4 text-sm">
                      Uploading brochure...
                    </p>
                  </div>
                )}

                {/* Brochure Preview - Show when uploaded */}
                {!isUploadingBrochures && brochureFiles.length > 0 && (
                  <div className="hidden flex-col w-full justify-center mt-6">
                    <div className="flex w-full justify-start items-center">
                      <div className="flex w-full lg:w-2/3 xl:w-1/2 items-center justify-between p-4 bg-gray-50 rounded-lg border border-gray-200 hover:bg-gray-100 transition-colors">
                        <div className="flex items-center flex-1 min-w-0">
                          <div className="w-10 h-10 bg-red-100 rounded-lg flex items-center justify-center mr-3 flex-shrink-0">
                            <span className="text-red-600 font-bold text-xs">
                              PDF
                            </span>
                          </div>
                          <div className="flex-1 min-w-0">
                            <p className="font-medium text-gray-800 truncate">
                              {brochureFiles[0].name}
                            </p>
                            <p className="text-sm text-gray-500">
                              {brochureFiles[0].size || "Size not available"}
                            </p>
                          </div>
                        </div>
                        <div className="flex items-center ml-2">
                          <button
                            type="button"
                            onClick={handleRemoveBrochure}
                            className="text-red-600 hover:text-red-800 px-3 py-1 rounded hover:bg-red-50 transition-colors"
                            title="Remove"
                          >
                            <svg
                              className="w-5 h-5"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                              />
                            </svg>
                          </button>
                        </div>
                      </div>
                    </div>

                    {/* Info Message */}
                    {/* {showSuccess && (
                      <div className="mt-4 p-3 bg-green-50 rounded-lg border border-green-200">
                        <div className="flex items-center justify-center">
                          <p className="text-sm text-green-800">
                            <span className="font-medium">
                              ✓ Brochure uploaded successfully
                            </span>
                          </p>
                        </div>
                      </div>
                    )} */}
                  </div>
                )}
                {!isUploadingBrochures && brochureFiles.length > 0 && (
                  <div className="flex w-full justify-start items-center">
                    <div className="flex w-full items-center justify-between p-4  rounded-lg  ansition-colors">
                      <div className="flex items-center flex-1 min-w-0">
                        <div className="w-14 h-14 bg-[#1E4F52] rounded-lg flex items-center justify-center mr-3 flex-shrink-0 shadow-lg">
                          <Icon name="ic-pdf" className="w-5 h-5" />
                        </div>
                        <div className="flex-1 min-w-0">
                          <p className="font-medium text-[#FFFFFF] truncate">
                            {brochureFiles[0].name}
                          </p>
                          {/* <p className="text-sm text-gray-500">
                              {brochureFiles[0].size || "Size not available"}
                            </p> */}
                        </div>
                      </div>
                      <div className="flex items-center ml-2">
                        <button
                          type="button"
                          onClick={handleRemoveBrochure}
                          className="text-red-600 hover:text-red-800 px-3 py-1 rounded hover:bg-red-50 transition-colors"
                          title="Remove"
                        >
                          <svg
                            className="w-5 h-5"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                            />
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>
                )}

                {/* Upload Button - Always visible */}
                {!isUploadingBrochures && (
                  <>
                    <div className="flex w-full items-center justify-center">
                      <input
                        ref={brochureInputRef}
                        type="file"
                        accept=".pdf,application/pdf"
                        onChange={handleBrochureUpload}
                        className="hidden"
                        id="brochure-upload-input"
                        disabled={isUploadingBrochures}
                      />

                      <label
                        htmlFor="brochure-upload-input"
                        className="block rounded-lg p-6 text-center justify-center transition-colors cursor-pointer"
                      >
                        <div className="flex flex-col justify-center items-center">
                          <div className="flex justify-center items-center text-4xl text-white mb-2 w-12 h-12 bg-[#008564] rounded-full">
                            +
                          </div>
                        </div>
                      </label>
                    </div>
                    <div className="flex flex-col w-full items-center justify-center text-white font-medium">
                      Upload your project brochure in PDF
                      <span className="text-sm">
                        {brochureFiles.length > 0
                          ? "(Upload new PDF to replace existing)"
                          : "(Only one PDF file allowed, max 5GB)"}
                      </span>
                    </div>
                  </>
                )}
              </CardBorder>

              {/* Cover Image Upload */}
              <CardBorder
                title="Upload Cover Image"
                borderColor="border-[#FFFFFF]"
                bgColor="bg-[#1D3842]"
              >
                {/* Loading Indicator */}
                {isUploadingCoverImage && (
                  <div className="flex w-full flex-col items-center justify-center py-8">
                    <div className="w-16 h-16 border-4 border-[#008564] border-t-transparent rounded-full animate-spin"></div>
                    <p className="text-white mt-4 text-sm">
                      Uploading cover image...
                    </p>
                  </div>
                )}

                {/* Cover Image Preview */}
                {!isUploadingCoverImage && coverImage && (
                  <div className="flex w-full justify-center mt-6 mb-4">
                    <div className="relative group flex flex-col items-center">
                      <div className="w-32 h-24 rounded-lg overflow-hidden  shadow-lg">
                        <img
                          src={coverImage}
                          alt="Cover"
                          className="w-full h-full object-cover"
                        />
                      </div>
                      <button
                        type="button"
                        onClick={handleRemoveCoverImage}
                        className="mt-2 bg-[#008564] text-white rounded-md w-6 h-6 flex items-center justify-center hover:bg-[#006b50] transition-colors shadow-lg"
                      >
                        <Icon name="ic-delete" className="w-3 h-3" />
                      </button>
                    </div>
                  </div>
                )}

                {/* Upload Button */}
                {!isUploadingCoverImage && (
                  <>
                    <div className="flex w-full items-center justify-center">
                      <input
                        ref={coverImageInputRef}
                        type="file"
                        accept="image/*"
                        onChange={handleCoverImageUpload}
                        className="hidden"
                        id="cover-image-upload-input"
                        disabled={isUploadingCoverImage}
                      />
                      <label
                        htmlFor="cover-image-upload-input"
                        className="block rounded-lg p-6 text-center justify-center transition-colors cursor-pointer"
                      >
                        <div className="flex flex-col justify-center items-center">
                          <div className="flex justify-center items-center text-4xl text-white mb-2 w-12 h-12 bg-[#008564] rounded-full">
                            +
                          </div>
                        </div>
                      </label>
                    </div>
                    <div className="flex flex-col w-full items-center justify-center text-white font-medium">
                      {/* {coverImage
                        ? "Replace Cover Image"
                        : "Upload cover photo for your project"} */}
                      Upload cover photo for your project
                    </div>
                  </>
                )}
              </CardBorder>

              {/* images Upload */}
              <CardBorder
                title="Images"
                borderColor="border-[#FFFFFF]"
                bgColor="bg-[#1E3A44]"
              >
                {/* Loading Indicator */}
                {isUploadingImages && (
                  <div className="flex w-full flex-col items-center justify-center py-8">
                    <div className="w-16 h-16 border-4 border-[#008564] border-t-transparent rounded-full animate-spin"></div>
                    <p className="text-white mt-4 text-sm">
                      Uploading images...
                    </p>
                  </div>
                )}

                {/* Image Previews - Exclude cover image (skip first if cover exists) */}
                {!isUploadingImages && images.length > 0 && (
                  <div className="flex w-full justify-center mt-6">
                    <div className="flex flex-wrap gap-4 justify-center">
                      {images
                        .slice(coverImage ? 1 : 0) // Skip first image if cover exists
                        .map((preview: any, index: number) => {
                          const actualIndex = coverImage ? index + 1 : index; // Adjust index for removal
                          return (
                            <div
                              key={actualIndex}
                              className="relative group flex flex-col items-center"
                            >
                              <div className="w-32 h-24 rounded-lg overflow-hidden shadow-lg">
                                <img
                                  src={preview}
                                  alt={`Preview ${index + 1}`}
                                  className="w-full h-full object-cover"
                                />
                              </div>
                              <button
                                type="button"
                                onClick={() => handleRemoveImage(actualIndex)}
                                className="mt-2 bg-[#008564] text-white rounded-md w-6 h-6 flex items-center justify-center hover:bg-[#006b50] transition-colors shadow-lg"
                              >
                                <Icon name="ic-delete" className="w-3 h-3" />
                              </button>
                              {/* <p className="text-xs text-[#889DB2] mt-1 truncate">
                                {formik.values.projectGallery.images[
                                  actualIndex
                                ]?.name || `Image ${index + 1}`}
                              </p> */}
                            </div>
                          );
                        })}
                    </div>
                  </div>
                )}

                {/* Upload Button */}
                {!isUploadingImages && (
                  <div className="flex w-full items-center justify-center">
                    <input
                      ref={imageInputRef}
                      type="file"
                      multiple
                      accept="image/*"
                      onChange={handleImageUpload}
                      className="hidden"
                      id="image-upload-input"
                      disabled={isUploadingImages}
                    />
                    <label
                      htmlFor="image-upload-input"
                      className="block rounded-lg p-6 text-center justify-center transition-colors cursor-pointer"
                    >
                      <div className="flex flex-col justify-center items-center">
                        <div className="flex justify-center items-center text-4xl text-white mb-2 w-12 h-12 bg-[#008564] rounded-full">
                          +
                        </div>
                      </div>
                    </label>
                  </div>
                )}

                {!isUploadingImages && (
                  <div className="flex w-full items-center justify-center text-white font-medium">
                    Upload Images
                  </div>
                )}
              </CardBorder>

              <div className="flex w-full gap-4">
                {/* Route Views - Dynamic Array */}
                <div className="w-1/2">
                  <CardBorder title={`Route Views`} borderColor="border-[#FFFFFF]" bgColor="bg-[#1e474c]">
                    <div className="flex w-full px-3 mb-6">
                      <div className="flex flex-col w-full">
                        <label className="block text-lg font-medium text-[#889DB2] mb-2">
                          Route View
                        </label>
                        <p className="text-xs text-[#6B8299] mb-3">Paste an embed URL from YouTube, Vimeo, or any iframe-compatible source. Direct video file links (.mp4) are not supported.</p>
                        <div className="space-y-3">
                          {formik.values.projectGallery.routeViews.map(
                            (view: string, index: number) => (
                              <div key={index} className="flex gap-2">
                                <input
                                  type="text"
                                  value={view}
                                  onChange={(e) => {
                                    const updated = [...formik.values.projectGallery.routeViews];
                                    updated[index] = e.target.value;
                                    formik.setFieldValue("projectGallery.routeViews", updated);
                                  }}
                                  className="flex-1 px-3 py-2 text-[#F4F5F7] rounded-md bg-[#2E4051] border-none shadow-md focus:border-[#008564] focus:outline-none focus:ring-2 focus:ring-[#008564] transition-colors border-gray-300"
                                  placeholder="Enter Route View URL..."
                                />
                                {formik.values.projectGallery.routeViews.length > 1 && (
                                  <button
                                    type="button"
                                    onClick={() => {
                                      const updated = formik.values.projectGallery.routeViews.filter((_: string, i: number) => i !== index);
                                      formik.setFieldValue("projectGallery.routeViews", updated);
                                    }}
                                    className="px-3 py-2 bg-red-500 text-white rounded-md hover:bg-red-600 transition-colors"
                                    title="Remove"
                                  >
                                    <Icon name="ic-delete" className="w-4 h-4" />
                                  </button>
                                )}
                              </div>
                            ),
                          )}
                          <button
                            type="button"
                            onClick={() => {
                              formik.setFieldValue("projectGallery.routeViews", [...formik.values.projectGallery.routeViews, ""]);
                            }}
                            className="flex items-center gap-2 px-4 py-2 bg-[#008564] text-white rounded-md hover:opacity-90 transition-colors"
                          >
                            <span className="text-xl">+</span>
                            <span>Add Route View</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </CardBorder>
                </div>

                {/* Video Links - Dynamic Array */}
                <div className="w-1/2">
                  <CardBorder title={`Video Links`} borderColor="border-[#FFFFFF]" bgColor="bg-[#1e474c]">
                    <div className="flex w-full px-3 mb-6">
                      <div className="flex flex-col w-full"> 
                        <label className="block text-lg font-medium text-[#889DB2] mb-2">
                          Video Embed Links
                        </label>
                        <p className="text-xs text-[#6B8299] mb-3">Paste an embed URL only — YouTube (<code className="text-[#7EB8A4]">youtube.com/embed/…</code>), Vimeo (<code className="text-[#7EB8A4]">player.vimeo.com/video/…</code>), or Bunny.net. Direct .mp4 links are not supported.</p>
                        <div className="space-y-3">
                          {formik.values.projectGallery.videoLinks.map(
                            (link: string, index: number) => (
                              <div key={index} className="flex gap-2">
                                <input
                                  type="text"
                                  value={link}
                                  onChange={(e) => {
                                    const updated = [...formik.values.projectGallery.videoLinks];
                                    updated[index] = e.target.value;
                                    formik.setFieldValue("projectGallery.videoLinks", updated);
                                  }}
                                  className="flex-1 px-3 py-2 text-[#F4F5F7] rounded-md bg-[#2E4051] border-none shadow-md focus:border-[#008564] focus:outline-none focus:ring-2 focus:ring-[#008564] transition-colors border-gray-300"
                                  placeholder="Paste embed URL (e.g. https://www.youtube.com/embed/...)"
                                />
                                {formik.values.projectGallery.videoLinks.length > 1 && (
                                  <button
                                    type="button"
                                    onClick={() => {
                                      const updated = formik.values.projectGallery.videoLinks.filter((_: string, i: number) => i !== index);
                                      formik.setFieldValue("projectGallery.videoLinks", updated);
                                    }}
                                    className="px-3 py-2 bg-red-500 text-white rounded-md hover:bg-red-600 transition-colors"
                                    title="Remove"
                                  >
                                    <Icon name="ic-delete" className="w-4 h-4" />
                                  </button>
                                )}
                              </div>
                            ),
                          )}
                          <button
                            type="button"
                            onClick={() => {
                              formik.setFieldValue("projectGallery.videoLinks", [...formik.values.projectGallery.videoLinks, ""]);
                            }}
                            className="flex items-center gap-2 px-4 py-2 bg-[#008564] text-white rounded-md hover:opacity-90 transition-colors"
                          >
                            <span className="text-xl">+</span>
                            <span>Add Video Link</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </CardBorder>
                </div>
              </div>

              {/* Videos Upload */}
              {/* <CardBorder title="Upload Videos" borderColor="border-[#FFFFFF]"> */}
              {/* Video Previews */}
              {videos.length > 0 && (
                <div className="hidden w-full justify-center mt-6">
                  <div className="flex flex-wrap justify-center gap-4">
                    {videos.map((preview: any, index: number) => (
                      <div key={index} className="relative group">
                        <div className="flex w-60 h-36 rounded-lg overflow-hidden border border-gray-200 bg-black">
                          <video
                            src={preview}
                            className="w-full h-full object-contain"
                            controls={false}
                          />
                        </div>
                        <button
                          type="button"
                          onClick={() => handleRemoveVideo(index)}
                          className="absolute top-2 right-2 bg-red-500 text-white rounded-full w-6 h-6 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity"
                        >
                          ×
                        </button>
                        <p className="text-xs text-[#889DB2] mt-1 truncate">
                          {formik.values.projectGallery.videos[index]?.name ||
                            `Video ${index + 1}`}
                        </p>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {videos.map((video: any) => (
                <div key={video.id} className="hidden w-full justify-center">
                  {/* Video Preview */}
                  <div className="mb-2">
                    <div className="relative h-40 w-full rounded overflow-hidden bg-gray-900">
                      <video
                        src={video.preview}
                        className="w-full h-full object-cover"
                        preload="metadata"
                      />
                      {/* Play Overlay */}
                      <div className="absolute inset-0 flex items-center justify-center">
                        <div className="bg-black/50 rounded-full p-3">
                          <PlayIcon className="w-8 h-8 text-white" />
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* File Info */}
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-2">
                      <VideoCameraIcon className="w-4 h-4 text-purple-500" />
                      <span className="text-sm text-gray-700 truncate">
                        {video.name}
                      </span>
                    </div>
                    <button
                      onClick={() =>
                        removeFile("video", video.id, video.preview)
                      }
                      className="text-gray-400 hover:text-red-500"
                    >
                      <XMarkIcon className="w-5 h-5" />
                    </button>
                  </div>
                </div>
              ))}

              <div className="hidden  w-full items-center justify-center">
                {/* Hidden file input with direct onChange handler */}
                <input
                  ref={videoInputRef}
                  type="file"
                  multiple
                  accept="video/*"
                  onChange={handleVideoUpload}
                  className="hidden"
                  id="video-upload-input"
                />

                {/* Upload area - clicks the hidden input */}
                <label
                  htmlFor="video-upload-input"
                  className="block  rounded-lg p-6 text-center justify-center transition-colors cursor-pointer"
                >
                  <div className="flex flex-col justify-center items-center">
                    <div className="flex justify-center items-center text-4xl text-white  mb-2 w-12 h-12 bg-[#008564] rounded-full">
                      +
                    </div>
                  </div>
                </label>
              </div>
              <div className="hidden w-full items-center justify-center text-white font-medium">
                Upload Videos
              </div>
              {/* </CardBorder> */}
            </div>
          )}

          {/* Amenities Tab */}
          {activeTab === "amenities" && (
            <div className="min-h-[70vh] p-4 sm:p-6 rounded-lg">
              <CardBorder
                title="Amenities"
                borderColor="border-[#FFFFFF]"
                bgColor="bg-[#1D3440]"
              >
                <div className="space-y-5 w-full">
                  {/* Seed button — visible when backend is missing amenities */}
                  {fetchedAmenities.length < 100 && (
                    <div className="flex flex-col items-center gap-3 py-8 border border-dashed border-[#374B5E] rounded-lg">
                      <p className="text-[#889DB2] text-sm">No amenities found in the system.</p>
                      <button
                        type="button"
                        disabled={isSeedingAmenities}
                        onClick={async () => {
                          setIsSeedingAmenities(true);
                          try {
                            await seedDefaultAmenities();
                            const res: any = await listAmenities();
                            const list = res?.re_amenity_list || res?.amenities || res?.data || [];
                            setFetchedAmenities(list);
                            if (list.length > 0) setActiveAmenityCategory(list[0].category);
                          } finally {
                            setIsSeedingAmenities(false);
                          }
                        }}
                        className="px-5 py-2 bg-[#008564] text-white text-sm rounded-lg disabled:opacity-60"
                      >
                        {isSeedingAmenities ? "Seeding…" : "Seed Default Amenities"}
                      </button>
                    </div>
                  )}

                  {/* Category chips + grid + summary — visible once amenities are loaded */}
                  {fetchedAmenities.length > 0 && (
                    <>
                      <div className="flex flex-wrap gap-2">
                        {amenityCategories.map(({ category, label, items }) => {
                          const selectedCount = items.filter((amenity) =>
                            selectedAmenities.includes(amenity._id),
                          ).length;
                          return (
                            <button
                              key={category}
                              type="button"
                              onClick={() => setActiveAmenityCategory(category)}
                              className={`relative flex items-center gap-1.5 px-4 py-2 rounded-lg text-sm font-medium capitalize transition-colors ${
                                activeAmenityCategory === category
                                  ? "bg-[#008564] text-white"
                                  : "bg-[#2E4051] text-[#889DB2] hover:text-white"
                              }`}
                            >
                              {label}
                              {selectedCount > 0 && (
                                <span className="ml-1 flex items-center justify-center w-5 h-5 rounded-full bg-white text-[#008564] text-xs font-bold leading-none">
                                  {selectedCount}
                                </span>
                              )}
                            </button>
                          );
                        })}
                      </div>

                      <div className="border border-[#374B5E] rounded-lg p-4">
                        <h3 className="text-[#889DB2] text-xs uppercase tracking-wider mb-4 font-semibold">
                          {amenityCategories.find((d) => d.category === activeAmenityCategory)?.label}
                        </h3>
                        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3">
                          {amenityCategories
                            .find((d) => d.category === activeAmenityCategory)
                            ?.items.map((amenity) => {
                              const isChecked = selectedAmenities.includes(amenity._id);
                              return (
                                <label
                                  key={amenity._id}
                                  className="flex items-center gap-2 cursor-pointer group"
                                >
                                  <input
                                    type="checkbox"
                                    checked={isChecked}
                                    onChange={() => toggleAmenity(amenity._id)}
                                    className="w-4 h-4 accent-[#008564] cursor-pointer shrink-0"
                                  />
                                  <span className={`shrink-0 ${isChecked ? "text-white" : "text-[#889DB2]"} group-hover:text-white transition-colors`}>
                                    {getAmenityIcon(amenity.slug, "w-4 h-4")}
                                  </span>
                                  <span
                                    className={`text-sm select-none ${
                                      isChecked ? "text-white" : "text-[#889DB2]"
                                    } group-hover:text-white transition-colors`}
                                  >
                                    {amenity.name}
                                  </span>
                                </label>
                              );
                            })}
                        </div>
                      </div>

                      {selectedAmenities.length > 0 && (
                        <div className="border border-[#374B5E] rounded-lg p-4">
                          <h3 className="text-[#889DB2] text-xs uppercase tracking-wider mb-3 font-semibold">
                            Selected Amenities ({selectedAmenities.length})
                          </h3>
                          <div className="flex flex-wrap gap-2">
                            {selectedAmenities.map((id) => {
                              const amenity = fetchedAmenities.find((a) => a._id === id);
                              return (
                                <span
                                  key={id}
                                  className="flex items-center gap-1.5 px-3 py-1 bg-[#2E4051] text-[#E7EEF9] text-xs rounded-full"
                                >
                                  {amenity?.name || id}
                                  <button
                                    type="button"
                                    onClick={() => toggleAmenity(id)}
                                    className="text-[#889DB2] hover:text-white leading-none"
                                  >
                                    ×
                                  </button>
                                </span>
                              );
                            })}
                          </div>
                        </div>
                      )}
                    </>
                  )}
                </div>
              </CardBorder>
            </div>
          )}

          {/* Project Type Tab */}
          {activeTab === "type" && (
            <div className="min-h-[70vh] p-4 sm:p-6 rounded-lg ">
              <CardBorder
                title="Project Type"
                borderColor="border-[#FFFFFF]"
                bgColor="bg-[#1D3440]"
              >
                <div className="space-y-5 w-full">
                  <div>
                    <label className="text-[#889DB2] block text-sm font-medium mb-1.5">
                      Select Project Type
                    </label>
                    <CustomSelect
                      label=""
                      name="projectTypeDetails.typeOfProperty"
                      value={formik.values.projectTypeDetails.typeOfProperty}
                      type="client"
                      textSize="text-sm"
                      border="rounded-lg border border-[#374B5E]"
                      py={1}
                    onChange={(e: any) => {
                      const newType = e.target.value;
                      const prevType = propertyType;
                      // Re-selecting the same type is a no-op. Without this,
                      // the save-then-read of unitsByType inside one render
                      // reads stale (undefined) state and wipes the form.
                      if (newType === prevType) return;
                      formik.handleChange(e);
                      if (getFieldError("typeOfProperty")) {
                        const newErrors = { ...formErrors };
                        delete newErrors.typeOfProperty;
                        setFormErrors(newErrors);
                      }
                      if (prevType) {
                        setUnitsByType((prev) => ({
                          ...prev,
                          [prevType]: uniqueUnits,
                        }));
                      }
                      setPropertyType(newType);
                      setUniqueUnits(unitsByType[newType] || []);
                    }}
                    onBlur={formik.handleBlur}
                    error={getFieldError("typeOfProperty")}
                    options={[
                      { value: "apartment", label: "Apartments" },
                      {
                        value: "villaInGatedCommunity",
                        label: "Villa in a Gated Community",
                      },
                      { value: "farmland", label: "Farmland" },
                      {
                        value: "layoutInGatedCommunity",
                        label: "Layouts in a Gated Community",
                      },
                      { value: "commercial", label: "Commercial Buildings" },
                    ]}
                  />
                  </div>

                  {propertyType && <div>{renderPropertyTypeForm()}</div>}

                  {Object.keys(formErrors).length > 0 && (
                    <div className="border border-red-300 bg-red-50 p-3 sm:p-4 rounded">
                      <h4 className="font-medium text-red-700 mb-2 text-sm sm:text-base">
                        Please fix the following errors:
                      </h4>
                      <ul className="list-disc list-inside text-red-600 text-xs sm:text-sm">
                        {Object.entries(formErrors).map(([field, error]) => (
                          <li key={field}>{error}</li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              </CardBorder>
            </div>
          )}

          {/* Project Meta Assets Tab */}
          {activeTab === "meta_assets" && (
            <div className="min-h-[70vh] p-4 sm:p-6 rounded-lg">
              <CardBorder
                title="Project Meta Assets"
                borderColor="border-[#FFFFFF]"
                bgColor="bg-[#1D3440]"
              >
                <div className="w-full flex flex-col gap-4 p-4 sm:p-6">
                  {!isEditMode ? (
                    <div className="w-full flex items-center justify-center min-h-[40vh]">
                      <div className="flex flex-col items-center gap-3 text-center max-w-md">
                        <div className="w-14 h-14 rounded-full bg-[#008564]/15 flex items-center justify-center">
                          <svg
                            className="w-7 h-7 text-[#008564]"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                            strokeWidth={1.5}
                          >
                            {isSuperAdmin ? (
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M16.5 10.5V6.75a4.5 4.5 0 1 0-9 0v3.75m-1.5 0h12a1.5 1.5 0 0 1 1.5 1.5v7.5a1.5 1.5 0 0 1-1.5 1.5h-12a1.5 1.5 0 0 1-1.5-1.5V12a1.5 1.5 0 0 1 1.5-1.5Z"
                              />
                            ) : (
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                              />
                            )}
                          </svg>
                        </div>
                        {isSuperAdmin ? (
                          <>
                            <h3 className="text-white text-lg font-semibold">
                              Save the project first
                            </h3>
                            <p className="text-[#889DB2] text-sm">
                              Meta assets — meta models and Matterport tours —
                              can only be attached to an existing project. Fill
                              in the previous tabs, hit{" "}
                              <span className="text-white font-medium">Save</span>{" "}
                              at the bottom, then click{" "}
                              <span className="text-white font-medium">Edit</span>{" "}
                              to come back here and add them.
                            </p>
                          </>
                        ) : (
                          <>
                            <h3 className="text-white text-lg font-semibold">
                              Meta assets will be added after you save
                            </h3>
                            <p className="text-[#889DB2] text-sm">
                              Once you save the project, OpenSky's admin team
                              will set up the 3D meta models and digital twins
                              for it. Go ahead and create the project — we'll
                              take it from here.
                            </p>
                          </>
                        )}
                      </div>
                    </div>
                  ) : loadingMetaAssets ? (
                    <div className="flex items-center justify-center py-10">
                      <p className="text-[#889DB2] text-sm">
                        Loading meta assets…
                      </p>
                    </div>
                  ) : projectMatterports.length === 0 &&
                    projectMetaModels.length === 0 &&
                    !isSuperAdmin ? (
                    <div className="w-full flex items-center justify-center min-h-[40vh]">
                      <div className="flex flex-col items-center gap-3 text-center max-w-md">
                        <div className="w-14 h-14 rounded-full bg-[#008564]/15 flex items-center justify-center">
                          <svg
                            className="w-7 h-7 text-[#008564] animate-pulse"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                            strokeWidth={1.5}
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                            />
                          </svg>
                        </div>
                        <h3 className="text-white text-lg font-semibold">
                          OpenSky Admin is setting up your meta assets
                        </h3>
                        <p className="text-[#889DB2] text-sm">
                          Your 3D meta models and digital twins are being
                          prepared. They'll appear here as soon as the admin
                          team uploads them.
                        </p>
                      </div>
                    </div>
                  ) : (
                    <div className="flex flex-col gap-5">
                      {/* Meta Models section */}
                      <div className="border border-[#374B5E] rounded-lg p-4">
                        <div className="flex items-center justify-between mb-3">
                          <h4 className="text-[#889DB2] text-xs uppercase tracking-wider font-semibold">
                            Meta Models ({projectMetaModels.length})
                          </h4>
                          {isSuperAdmin && !showAddMetaModel && editingMetaModelId === null && (
                            <button
                              type="button"
                              onClick={() => { setShowAddMetaModel(true); setMetaModelDraft({ name: "", url: "", slug: "", description: "", thumbnail_url: "" }); }}
                              className="text-[#008564] text-xs font-semibold flex items-center gap-1 hover:opacity-80"
                            >
                              <Icon name="ic-plus" className="w-3 h-3" /> Add Meta Model
                            </button>
                          )}
                        </div>

                        {projectMetaModels.length === 0 && !showAddMetaModel && (
                          <p className="text-[#889DB2] text-sm italic">No meta models yet.</p>
                        )}

                        <ul className="flex flex-col gap-2">
                          {projectMetaModels.map((mm: any) => (
                            <li key={mm._id} className="px-3 py-2 bg-[#2E4051] rounded-md text-[#E7EEF9] text-sm">
                              {isSuperAdmin && editingMetaModelId === mm._id ? (
                                <div className="flex flex-col gap-3">
                                  <div className="flex flex-col gap-1">
                                    <label className="text-[#889DB2] text-xs font-medium">Name</label>
                                    <input
                                      type="text"
                                      placeholder="e.g. Ark Lead Generation"
                                      value={metaModelDraft.name}
                                      onChange={(e) => setMetaModelDraft({ ...metaModelDraft, name: e.target.value })}
                                      className="bg-[#1D3440] border border-[#374B5E] rounded px-2 py-1.5 text-sm text-white placeholder-[#5A6E84]"
                                    />
                                  </div>
                                  <div className="flex flex-col gap-1">
                                    <label className="text-[#889DB2] text-xs font-medium">URL</label>
                                    <input
                                      type="text"
                                      placeholder="e.g. view.openskyvr.com"
                                      value={metaModelDraft.url}
                                      onChange={(e) => setMetaModelDraft({ ...metaModelDraft, url: e.target.value })}
                                      className="bg-[#1D3440] border border-[#374B5E] rounded px-2 py-1.5 text-sm text-white placeholder-[#5A6E84]"
                                    />
                                  </div>
                                  <div className="flex flex-col gap-1">
                                    <label className="text-[#889DB2] text-xs font-medium">Slug</label>
                                    <input
                                      type="text"
                                      placeholder="e.g. ark-lead"
                                      value={metaModelDraft.slug}
                                      onChange={(e) => setMetaModelDraft({ ...metaModelDraft, slug: e.target.value })}
                                      className="bg-[#1D3440] border border-[#374B5E] rounded px-2 py-1.5 text-sm text-white placeholder-[#5A6E84]"
                                    />
                                  </div>
                                  <div className="flex flex-col gap-1">
                                    <label className="text-[#889DB2] text-xs font-medium">Description</label>
                                    <textarea
                                      placeholder="Brief description of this meta model"
                                      value={metaModelDraft.description}
                                      onChange={(e) => setMetaModelDraft({ ...metaModelDraft, description: e.target.value })}
                                      rows={2}
                                      className="bg-[#1D3440] border border-[#374B5E] rounded px-2 py-1.5 text-sm text-white placeholder-[#5A6E84] resize-none block"
                                    />
                                  </div>
                                  <div className="flex flex-col gap-1">
                                    <label className="text-[#889DB2] text-xs font-medium">Poster image URL</label>
                                    <input
                                      type="text"
                                      placeholder="https://… — shown before a website embed is played"
                                      value={metaModelDraft.thumbnail_url}
                                      onChange={(e) => setMetaModelDraft({ ...metaModelDraft, thumbnail_url: e.target.value })}
                                      className="bg-[#1D3440] border border-[#374B5E] rounded px-2 py-1.5 text-sm text-white placeholder-[#5A6E84]"
                                    />
                                  </div>
                                  <div className="flex gap-2 justify-end">
                                    <button type="button" onClick={cancelEditMetaModel} className="px-3 py-1 text-xs text-[#889DB2] hover:text-white">Cancel</button>
                                    <button type="button" onClick={() => saveMetaModel(mm._id)} disabled={savingMetaModel} className="px-3 py-1 text-xs bg-[#008564] text-white rounded hover:opacity-90 disabled:opacity-50">{savingMetaModel ? "Saving…" : "Save"}</button>
                                  </div>
                                </div>
                              ) : (
                                <div className="flex items-start gap-3">
                                  <Icon name="ic-home" className="w-4 h-4 text-[#008564] flex-shrink-0 mt-1" />
                                  <div className="flex-1 min-w-0 flex flex-col gap-1">
                                    <span className="text-[#E7EEF9] font-medium truncate">{mm.name || "Unnamed"}</span>
                                    {mm.url && <span className="text-[#889DB2] text-xs truncate"><span className="text-[#5A6E84]">URL:</span> {mm.url}</span>}
                                    {mm.slug && <span className="text-[#889DB2] text-xs truncate"><span className="text-[#5A6E84]">Slug:</span> {mm.slug}</span>}
                                    {mm.description && <span className="text-[#889DB2] text-xs line-clamp-2"><span className="text-[#5A6E84]">Description:</span> {mm.description}</span>}
                                  </div>
                                  {isSuperAdmin && (
                                    <div className="flex gap-2 flex-shrink-0">
                                      <button type="button" onClick={() => startEditMetaModel(mm)} className="text-[#889DB2] hover:text-white" title="Edit">
                                        <Icon name="ic-edit" className="w-4 h-4" />
                                      </button>
                                      <button type="button" onClick={() => removeMetaModel(mm._id)} disabled={deletingMetaModelId === mm._id} className="text-[#889DB2] hover:text-[#E57373] disabled:opacity-50" title="Delete">
                                        {deletingMetaModelId === mm._id ? "…" : <Icon name="ic-delete" className="w-4 h-4" />}
                                      </button>
                                    </div>
                                  )}
                                </div>
                              )}
                            </li>
                          ))}

                          {isSuperAdmin && showAddMetaModel && (
                            <li className="px-3 py-2 bg-[#2E4051] rounded-md border border-dashed border-[#008564]">
                              <div className="flex flex-col gap-3">
                                <div className="flex flex-col gap-1">
                                  <label className="text-[#889DB2] text-xs font-medium">Name</label>
                                  <input type="text" placeholder="e.g. Ark Lead Generation" value={metaModelDraft.name} onChange={(e) => setMetaModelDraft({ ...metaModelDraft, name: e.target.value })} className="bg-[#1D3440] border border-[#374B5E] rounded px-2 py-1.5 text-sm text-white placeholder-[#5A6E84]" />
                                </div>
                                <div className="flex flex-col gap-1">
                                  <label className="text-[#889DB2] text-xs font-medium">URL</label>
                                  <input type="text" placeholder="e.g. view.openskyvr.com" value={metaModelDraft.url} onChange={(e) => setMetaModelDraft({ ...metaModelDraft, url: e.target.value })} className="bg-[#1D3440] border border-[#374B5E] rounded px-2 py-1.5 text-sm text-white placeholder-[#5A6E84]" />
                                </div>
                                <div className="flex flex-col gap-1">
                                  <label className="text-[#889DB2] text-xs font-medium">Slug</label>
                                  <input type="text" placeholder="e.g. ark-lead" value={metaModelDraft.slug} onChange={(e) => setMetaModelDraft({ ...metaModelDraft, slug: e.target.value })} className="bg-[#1D3440] border border-[#374B5E] rounded px-2 py-1.5 text-sm text-white placeholder-[#5A6E84]" />
                                </div>
                                <div className="flex flex-col gap-1">
                                  <label className="text-[#889DB2] text-xs font-medium">Description</label>
                                  <textarea placeholder="Brief description of this meta model" value={metaModelDraft.description} onChange={(e) => setMetaModelDraft({ ...metaModelDraft, description: e.target.value })} rows={2} className="bg-[#1D3440] border border-[#374B5E] rounded px-2 py-1.5 text-sm text-white placeholder-[#5A6E84] resize-none block" />
                                </div>
                                <div className="flex flex-col gap-1">
                                  <label className="text-[#889DB2] text-xs font-medium">Poster image URL</label>
                                  <input type="text" placeholder="https://… — shown before a website embed is played" value={metaModelDraft.thumbnail_url} onChange={(e) => setMetaModelDraft({ ...metaModelDraft, thumbnail_url: e.target.value })} className="bg-[#1D3440] border border-[#374B5E] rounded px-2 py-1.5 text-sm text-white placeholder-[#5A6E84]" />
                                </div>
                                <div className="flex gap-2 justify-end">
                                  <button type="button" onClick={() => { setShowAddMetaModel(false); setMetaModelDraft({ name: "", url: "", slug: "", description: "", thumbnail_url: "" }); }} className="px-3 py-1 text-xs text-[#889DB2] hover:text-white">Cancel</button>
                                  <button type="button" onClick={() => saveMetaModel(null)} disabled={savingMetaModel} className="px-3 py-1 text-xs bg-[#008564] text-white rounded hover:opacity-90 disabled:opacity-50">{savingMetaModel ? "Saving…" : "Add"}</button>
                                </div>
                              </div>
                            </li>
                          )}
                        </ul>
                      </div>

                      {/* Digital Twins section */}
                      <div className="border border-[#374B5E] rounded-lg p-4">
                        <div className="flex items-center justify-between mb-3">
                          <h4 className="text-[#889DB2] text-xs uppercase tracking-wider font-semibold">
                            Digital Twins ({projectMatterports.length})
                          </h4>
                          {isSuperAdmin && !showAddMatterport && editingMatterportId === null && (
                            <button
                              type="button"
                              onClick={() => { setShowAddMatterport(true); setMatterportDraft({ matterport_id: "", name: "", tour_type: availableTourTypes[0], description: "" }); }}
                              className="text-[#008564] text-xs font-semibold flex items-center gap-1 hover:opacity-80"
                            >
                              <Icon name="ic-plus" className="w-3 h-3" /> Add Digital Twin
                            </button>
                          )}
                        </div>

                        {projectMatterports.length === 0 && !showAddMatterport && (
                          <p className="text-[#889DB2] text-sm italic">No digital twins yet.</p>
                        )}

                        <ul className="flex flex-col gap-2">
                          {projectMatterports.map((mp: any) => (
                            <li key={mp._id} className="px-3 py-2 bg-[#2E4051] rounded-md text-[#E7EEF9] text-sm">
                              {isSuperAdmin && editingMatterportId === mp._id ? (
                                <div className="flex flex-col gap-3">
                                  <div className="flex flex-col gap-1">
                                    <label className="text-[#889DB2] text-xs font-medium">Matterport ID</label>
                                    <input type="text" placeholder="e.g. 6a08bc6805e0e4e47c148dd0" value={matterportDraft.matterport_id} onChange={(e) => setMatterportDraft({ ...matterportDraft, matterport_id: e.target.value })} className="bg-[#1D3440] border border-[#374B5E] rounded px-2 py-1.5 text-sm text-white placeholder-[#5A6E84]" />
                                  </div>
                                  <div className="flex flex-col gap-1">
                                    <label className="text-[#889DB2] text-xs font-medium">Name</label>
                                    <input type="text" placeholder="e.g. Haritha Retreat" value={matterportDraft.name} onChange={(e) => setMatterportDraft({ ...matterportDraft, name: e.target.value })} className="bg-[#1D3440] border border-[#374B5E] rounded px-2 py-1.5 text-sm text-white placeholder-[#5A6E84]" />
                                  </div>
                                  <div className="flex flex-col gap-1">
                                    <label className="text-[#889DB2] text-xs font-medium">Tour Type</label>
                                    <select value={matterportDraft.tour_type} onChange={(e) => setMatterportDraft({ ...matterportDraft, tour_type: e.target.value })} className="bg-[#1D3440] border border-[#374B5E] rounded px-2 py-1.5 text-sm text-white">
                                      {availableTourTypes.map(t => <option key={t} value={t}>{t}</option>)}
                                    </select>
                                  </div>
                                  <div className="flex flex-col gap-1">
                                    <label className="text-[#889DB2] text-xs font-medium">Description</label>
                                    <textarea placeholder="Brief description of this digital twin" value={matterportDraft.description} onChange={(e) => setMatterportDraft({ ...matterportDraft, description: e.target.value })} rows={2} className="bg-[#1D3440] border border-[#374B5E] rounded px-2 py-1.5 text-sm text-white placeholder-[#5A6E84] resize-none block" />
                                  </div>
                                  <div className="flex gap-2 justify-end">
                                    <button type="button" onClick={cancelEditMatterport} className="px-3 py-1 text-xs text-[#889DB2] hover:text-white">Cancel</button>
                                    <button type="button" onClick={() => saveMatterport(mp._id)} disabled={savingMatterport} className="px-3 py-1 text-xs bg-[#008564] text-white rounded hover:opacity-90 disabled:opacity-50">{savingMatterport ? "Saving…" : "Save"}</button>
                                  </div>
                                </div>
                              ) : (
                                <div className="flex items-start gap-3">
                                  <Icon name="ic-home" className="w-4 h-4 text-[#008564] flex-shrink-0 mt-1" />
                                  <div className="flex-1 min-w-0 flex flex-col gap-1">
                                    <span className="text-[#E7EEF9] font-medium truncate">{mp.name || "Unnamed"}</span>
                                    {mp.matterport_id && <span className="text-[#889DB2] text-xs truncate"><span className="text-[#5A6E84]">Matterport ID:</span> {mp.matterport_id}</span>}
                                    {mp.tour_type && <span className="text-[#889DB2] text-xs truncate"><span className="text-[#5A6E84]">Tour Type:</span> {mp.tour_type}</span>}
                                    {mp.description && <span className="text-[#889DB2] text-xs line-clamp-2"><span className="text-[#5A6E84]">Description:</span> {mp.description}</span>}
                                  </div>
                                  {isSuperAdmin && (
                                    <div className="flex gap-2 flex-shrink-0">
                                      <button type="button" onClick={() => startEditMatterport(mp)} className="text-[#889DB2] hover:text-white" title="Edit">
                                        <Icon name="ic-edit" className="w-4 h-4" />
                                      </button>
                                      <button type="button" onClick={() => removeMatterport(mp._id)} disabled={deletingMatterportId === mp._id} className="text-[#889DB2] hover:text-[#E57373] disabled:opacity-50" title="Delete">
                                        {deletingMatterportId === mp._id ? "…" : <Icon name="ic-delete" className="w-4 h-4" />}
                                      </button>
                                    </div>
                                  )}
                                </div>
                              )}
                            </li>
                          ))}

                          {isSuperAdmin && showAddMatterport && (
                            <li className="px-3 py-2 bg-[#2E4051] rounded-md border border-dashed border-[#008564]">
                              <div className="flex flex-col gap-3">
                                <div className="flex flex-col gap-1">
                                  <label className="text-[#889DB2] text-xs font-medium">Matterport ID</label>
                                  <input type="text" placeholder="e.g. 6a08bc6805e0e4e47c148dd0" value={matterportDraft.matterport_id} onChange={(e) => setMatterportDraft({ ...matterportDraft, matterport_id: e.target.value })} className="bg-[#1D3440] border border-[#374B5E] rounded px-2 py-1.5 text-sm text-white placeholder-[#5A6E84]" />
                                </div>
                                <div className="flex flex-col gap-1">
                                  <label className="text-[#889DB2] text-xs font-medium">Name</label>
                                  <input type="text" placeholder="e.g. Haritha Retreat" value={matterportDraft.name} onChange={(e) => setMatterportDraft({ ...matterportDraft, name: e.target.value })} className="bg-[#1D3440] border border-[#374B5E] rounded px-2 py-1.5 text-sm text-white placeholder-[#5A6E84]" />
                                </div>
                                <div className="flex flex-col gap-1">
                                  <label className="text-[#889DB2] text-xs font-medium">Tour Type</label>
                                  <select value={matterportDraft.tour_type} onChange={(e) => setMatterportDraft({ ...matterportDraft, tour_type: e.target.value })} className="bg-[#1D3440] border border-[#374B5E] rounded px-2 py-1.5 text-sm text-white">
                                    {availableTourTypes.map(t => <option key={t} value={t}>{t}</option>)}
                                  </select>
                                </div>
                                <div className="flex flex-col gap-1">
                                  <label className="text-[#889DB2] text-xs font-medium">Description</label>
                                  <textarea placeholder="Brief description of this digital twin" value={matterportDraft.description} onChange={(e) => setMatterportDraft({ ...matterportDraft, description: e.target.value })} rows={2} className="bg-[#1D3440] border border-[#374B5E] rounded px-2 py-1.5 text-sm text-white placeholder-[#5A6E84] resize-none block" />
                                </div>
                                <div className="flex gap-2 justify-end">
                                  <button type="button" onClick={() => { setShowAddMatterport(false); setMatterportDraft({ matterport_id: "", name: "", tour_type: availableTourTypes[0], description: "" }); }} className="px-3 py-1 text-xs text-[#889DB2] hover:text-white">Cancel</button>
                                  <button type="button" onClick={() => saveMatterport(null)} disabled={savingMatterport} className="px-3 py-1 text-xs bg-[#008564] text-white rounded hover:opacity-90 disabled:opacity-50">{savingMatterport ? "Saving…" : "Add"}</button>
                                </div>
                              </div>
                            </li>
                          )}
                        </ul>
                      </div>

                      {!isSuperAdmin && (
                        <div className="text-[#889DB2] text-xs italic flex flex-col gap-1">
                          <p>You can preview these assets on the project experience page.</p>
                          <p>To request changes to meta models or digital twins, please contact your OpenSky admin.</p>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </CardBorder>
            </div>
          )}
        </form>

        {/* Navigation Buttons */}
        <div className="flex flex-col-reverse sm:flex-row justify-center gap-3 sm:gap-4">
          <button
            type="button"
            className="px-4 sm:px-6 py-2 text-[#E7EEF9] bg-[#2E4051] rounded-lg hover:bg-opacity-90 shadow-[0_2px_2px_0_rgba(0,0,0,0.25)] text-sm sm:text-base"
            onClick={() => {
              if (activeTab === "details") {
                if (
                  window.confirm(
                    "Are you sure you want to cancel? All unsaved data will be lost.",
                  )
                ) {
                  formik.resetForm();
                  setBrochureFiles([]);
                  setImages([]);
                  setVideos([]);
                  setUniqueUnits([]);
                  setPropertyType("");
                  setFormErrors({});
                  navigate("/");
                }
              } else if (activeTab === "type") {
                setActiveTab("details");
                setFormErrors({});
              } else if (activeTab === "gallery") {
                setActiveTab("type");
                setFormErrors({});
              } else if (activeTab === "amenities") {
                setActiveTab("gallery");
                setFormErrors({});
              } else if (activeTab === "meta_assets") {
                setActiveTab("amenities");
                setFormErrors({});
              }
            }}
          >
            {activeTab === "details" ? "Cancel" : "Back"}
          </button>

          <div className="flex justify-end">
            {activeTab !== "meta_assets" ? (
              <button
                type="button"
                disabled={savingAndContinuing}
                className="w-full sm:w-auto px-4 sm:px-6 py-2 shadow-[0_2px_2px_0_rgba(0,0,0,0.25)] bg-[#008564] text-white rounded-lg focus:bg-opacity-90 text-sm sm:text-base disabled:opacity-60 disabled:cursor-not-allowed inline-flex items-center justify-center gap-2"
                onClick={handleNext}
              >
                {savingAndContinuing ? (
                  <>
                    <span
                      className="inline-block w-3 h-3 border-2 border-white/40 border-t-white rounded-full animate-spin"
                      aria-hidden="true"
                    />
                    Saving…
                  </>
                ) : activeTab === "amenities" && isSuperAdmin && !isEditMode ? (
                  "Save & Add Meta Assets"
                ) : (
                  "Next"
                )}
              </button>
            ) : (
              <button
                type="button"
                onClick={async () => {
                  const errors = await formik.validateForm();
                  if (Object.keys(errors).length > 0) {
                    const messages = collectFormikErrorMessages(errors);
                    setActiveTab("details");
                    window.alert(
                      "Can't save yet - some required Project Details fields are missing:\n\n" +
                        messages.map((m) => `• ${m}`).join("\n") +
                        "\n\nYou've been taken back to the Project Details tab to fix them.",
                    );
                    return;
                  }
                  formik.handleSubmit();
                }}
                className="w-full sm:w-auto px-4 sm:px-6 py-2 shadow-[0_2px_2px_0_rgba(0,0,0,0.25)] bg-[#008564] text-white rounded-lg hover:bg-opacity-90 text-sm sm:text-base"
              >
                Save
              </button>
            )}
          </div>
        </div>

        {/* Projects List Section */}
        {projects.length > 0 && (
          <div className="hidden mt-8 sm:mt-12 bg-white p-4 sm:p-6 rounded-lg shadow">
            <h2 className="text-lg sm:text-xl font-semibold mb-4">
              Saved Projects ({projects.length})
            </h2>
            <div className="overflow-x-auto -mx-2 sm:mx-0">
              <div className="inline-block min-w-full align-middle">
                <div className="overflow-hidden border rounded-lg">
                  <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                      <tr>
                        <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Project Name
                        </th>
                        <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider hidden sm:table-cell">
                          Builder
                        </th>
                        <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider hidden md:table-cell">
                          Property Type
                        </th>
                        <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Location
                        </th>
                        <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Actions
                        </th>
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                      {projects.slice(0, 5).map((project) => (
                        <tr key={project.id}>
                          <td className="px-3 py-2 whitespace-nowrap text-sm">
                            {project.projectDetails.builder.projectName}
                          </td>
                          <td className="px-3 py-2 whitespace-nowrap text-sm hidden sm:table-cell">
                            {project.projectDetails.builder.builderName}
                          </td>
                          <td className="px-3 py-2 whitespace-nowrap text-sm hidden md:table-cell">
                            {project.projectTypeDetails.typeOfProperty}
                          </td>
                          <td className="px-3 py-2 whitespace-nowrap text-sm">
                            {project.projectDetails.location.city}
                          </td>
                          <td className="px-3 py-2 whitespace-nowrap">
                            <button
                              type="button"
                              onClick={() => handleDeleteProject(project.id)}
                              className="px-2 py-1 bg-red-500 text-white rounded hover:bg-red-600 text-xs"
                            >
                              Delete
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            {projects.length > 5 && (
              <p className="text-center text-gray-500 mt-2 text-xs sm:text-sm">
                ... and {projects.length - 5} more projects
              </p>
            )}
            <div className="mt-4 text-center">
              <button
                type="button"
                onClick={() => {
                  const dataStr = JSON.stringify(projects, null, 2);
                  const dataUri =
                    "data:application/json;charset=utf-8," +
                    encodeURIComponent(dataStr);
                  const exportFileDefaultName = `projects_${
                    new Date().toISOString().split("T")[0]
                  }.json`;

                  const linkElement = document.createElement("a");
                  linkElement.setAttribute("href", dataUri);
                  linkElement.setAttribute("download", exportFileDefaultName);
                  linkElement.click();
                }}
                className="px-4 py-2 bg-purple-600 text-white rounded hover:bg-purple-700 text-sm sm:text-base"
              >
                Export All Projects to JSON
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AddProject;
